{
  "format_version": "1.0",
  "generated_by": "Judo Tree JS",
  "elements": {
    "nodes": [
      {
        "data": {
          "id": "JDP-24",
          "name": "Walter Todd",
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": "https://archive.org/download/walter_todd/walter_todd.jpg",
          "teachers": [
            {
              "id": "JDP-11",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1946,
                "end": null
              },
              "quality": 1
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://www.koryu.com/library/mskoss10.html"
            }
          ],
          "source_yaml": "database/persons/USA/Walter_Todd.yaml",
          "photo_url_local": "images/cache/f675dca6b1d7d2394952b1b6ee6810bc.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-96",
          "name": "Theodore Roosevelt Jr.",
          "aka": [
            {
              "name": "Theodore Roosevelt Jr."
            },
            {
              "name": "Teddy Roosevelt"
            }
          ],
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": "1858-10-27",
            "location": "Manhattan",
            "country_code": "USA"
          },
          "death": {
            "date": "1919-01-06",
            "location": "Oyster Bay",
            "country_code": "USA"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Theodore_Roosevelt_by_the_Pach_Bros.jpg/800px-Theodore_Roosevelt_by_the_Pach_Bros.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Theodore_Roosevelt#/media/File:Theodore_Roosevelt_by_the_Pach_Bros.jpg"
            }
          },
          "teachers": [
            {
              "id": "JDP-95",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1904,
                "end": 1904
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://ejmas.com/jcs/jcsart_svinth1_1000.htm",
                  "cite": "Professor Yamashita Goes to Washington (Journal of Combative Sport, Oct 2000)",
                  "citation": "So, during March and April 1904, Roosevelt practiced judo three afternoons a week, using a ground floor office in the White House as his workout space (...) Yamashita later said that while Roosevelt was his best pupil (...)"
                }
              ]
            },
            {
              "name": "James O'Brien",
              "style_id": null,
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "USJA",
              "teacher": null,
              "rank": "8 dan (honorary)",
              "date": 2007,
              "sources": [
                {
                  "uri": "https://ejmas.com/jcs/jcsart_svinth1_1000.htm",
                  "citation": "The USJA made Roosevelt an 8th Degree Black Belt, an honor usually bestowed on those who have been doing Judo over 50 years and occasionally on those of distinguished leadership who have bought Judo into the international limelight."
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ejmas.com/jcs/jcsart_svinth1_1000.htm",
              "cite": "Journal of Combative Sport: Yamashita goes to Washington"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Theodore_Roosevelt",
              "cite": "Theodore Roosevelt - Wikipedia"
            },
            {
              "uri": "https://martialarts.stackexchange.com/questions/2209/what-level-of-expertise-did-theodore-roosevelt-have-in-judo"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q33866",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Theodore_Roosevelt",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/USA/Theodore_Roosevelt.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-133",
          "name": "Ronda Rousey",
          "aka": [
            {
              "name": "Ronda Jean Rousey"
            }
          ],
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": "1987-02-01",
            "location": "Riverside, California",
            "country_code": "USA"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Rousey_HOF_2018_%28cropped%29.jpg/800px-Rousey_HOF_2018_%28cropped%29.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Ronda_Rousey#/media/File:Rousey_HOF_2018_(cropped).jpg",
              "cite": "WWE Hall of Fame (2018) - Wikipedia"
            }
          },
          "teachers": [
            {
              "id": "JDP-132",
              "style_id": "JDP-S-1",
              "period": {
                "start": "1998",
                "end": null
              },
              "quality": 3,
              "place": null,
              "sources": [
                {
                  "uri": "https://www.blackbeltmag.com/fists-of-love-the-mothers-who-raised-martial-arts-legends",
                  "cite": "Fists of Love: The Mothers Who Raised Martial Arts Legends - Black Belt Magazine",
                  "citation": "She began coaching Ronda at age 11, instilling a mindset that would later carry her daughter to Olympic bronze in judo and UFC glory"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "AAU",
              "rank": "6 dan",
              "date": "2018-03-03",
              "sources": [
                {
                  "uri": "http://www.freestylejudo.org/jbba/",
                  "cite": "JBBA Rank Promotions - Freestyle Judo Association",
                  "citation": "Rokudan (6th Dan): (...)Ronda Rousey, 3/3/2018, Gompers Judo"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Ronda_Rousey",
              "cite": "Ronda Rousey - Wikipedia"
            },
            {
              "uri": "https://www.judoinside.com/judoka/19130/Ronda_Rousey/judo-career",
              "cite": "JudoInside - Ronda Rousey Judoka"
            },
            {
              "uri": "https://www.ijf.org/judoka/2589",
              "cite": "Ronda ROUSEY / IJF.org"
            },
            {
              "uri": "https://www.usjf.com/ronda-rousey/",
              "cite": "Ronda Rousey | United States Judo Federation"
            }
          ],
          "source_yaml": "database/persons/USA/Ronda_Rousey.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-122",
          "name": "Kenneth Kuniyuki",
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": "1910-10-06",
            "location": "Seattle",
            "country_code": "USA"
          },
          "death": {
            "date": "2002-11-28",
            "location": null,
            "country_code": "USA"
          },
          "photo": {
            "url": "https://www.usjf.com/wp-content/uploads/2018/02/kuniyuki.png",
            "source": {
              "uri": "https://www.usjf.com/kenneth-kuniyuki/",
              "cite": "Kenneth Kuniyuki - USJF"
            }
          },
          "teachers": [
            {
              "id": "JDP-31",
              "style_id": "JDP-S-1",
              "place": "Keio University, Tokyo",
              "period": {
                "start": "1931",
                "end": "1932"
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://www.usjf.com/kenneth-kuniyuki/",
                  "cite": "Kenneth Kuniyuki - USJF",
                  "location": null,
                  "citation": "From 1931 to 1932 Kenneth studied under Kunisaburo Iizuka, 8-dan, and original student of Kano Sensei in Tokyo, Japan"
                },
                {
                  "uri": "https://shoyuzine.tripod.com/id14.html",
                  "cite": "Asian Americans who've made a difference - Shoyu Zine",
                  "citation": "In 1932 he went to Japan to train at Keio University under the instruction of Kunisaburo Iizuka, 8 dan at the time"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "USJF",
              "rank": "9 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.usjf.com/kenneth-kuniyuki/",
                  "cite": "Kenneth Kuniyuki - USJF"
                },
                {
                  "uri": "https://shoyuzine.tripod.com/id14.html",
                  "cite": "Asian Americans who've made a difference - Shoyu Zine"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.usjf.com/kenneth-kuniyuki/",
              "cite": "Kenneth Kuniyuki | United States Judo Federation"
            },
            {
              "uri": "https://shoyuzine.tripod.com/id14.html",
              "cite": "Obits"
            }
          ],
          "source_yaml": "database/persons/USA/Kenneth_Kuniyuki.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-52",
          "name": "Karl Geis",
          "aka": [
            {
              "name": "Karl Geis"
            }
          ],
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": 1933,
            "location": "Houston, Texas",
            "country_code": "USA"
          },
          "death": {
            "date": "2014-04-07",
            "location": null,
            "country_code": null
          },
          "photo_url": "https://ia601208.us.archive.org/9/items/karl_geis_formal_202312/karl_geis_formal.png",
          "teachers": [
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1952,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://www.karlgeis.com/his-resume",
                  "cite": "Karl Geis Martial Arts Resume (Karl Geis Ryu homepage)",
                  "citation": "During my studies in Japan I received significant personal instruction from the following Kodokan teachers: [...] Kobayashi Sensei, 8th Dan"
                }
              ]
            },
            {
              "id": "JDP-53",
              "style_id": "JDP-S-4",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://www.karlgeis.com/his-resume",
                  "cite": "Karl Geis Martial Arts Resume (Karl Geis Ryu homepage)",
                  "citation": "During my studies in Japan I received significant personal instruction from the following Kodokan teachers: [...] Miyake, Tsunako Sensei, 7th Dan"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "USJA",
              "teacher": null,
              "rank": "10 dan",
              "date": 2014,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-4",
              "org": null,
              "teacher": null,
              "rank": "10 dan",
              "date": 1997,
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-4",
              "org": null,
              "teacher": null,
              "rank": "6 dan",
              "date": 1980,
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Karl_Geis",
              "cite": "Karl Geis - Wikipedia"
            },
            {
              "uri": "https://www.karlgeis.com/his-resume",
              "cite": "His Resume | karlgeisryu"
            },
            {
              "uri": "https://media.usja.net/2014/04/Karl-Geis-Bio-4-14.pdf"
            },
            {
              "uri": "https://maytt.home.blog/2020/09/09/interview-with-david-witt-judo-aikido-and-karl-geis/",
              "cite": "Interview with David Witt: Judo, Aikido, and Karl Geis – Martial Arts of Yesterday, Today and Tomorrow"
            }
          ],
          "source_yaml": "database/persons/USA/Karl_Geis.yaml",
          "photo_url_local": "images/cache/f9bf4313ab12ede4973da500f2141d00.png"
        }
      },
      {
        "data": {
          "id": "JDP-123",
          "name": "James Cagney",
          "aka": [
            {
              "name": "James Francis Cagney Jr."
            }
          ],
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": "1899-07-17",
            "location": "New York City",
            "country_code": "USA"
          },
          "death": {
            "date": "1986-03-30",
            "location": "Stanford, New York",
            "country_code": "USA"
          },
          "photo": {
            "url": "https://archive.org/download/james_cagney/james_cagney.jpg",
            "source": {
              "uri": "https://archive.org/details/james_cagney",
              "cite": "Internet Archive"
            }
          },
          "teachers": [
            {
              "id": "JDP-122",
              "style_id": "JDP-S-1",
              "place": "Seinan Dojo, Los Angeles",
              "period": {
                "start": 1945,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://www.mixedmartialarts.com/judo/1945-film-fight-scene",
                  "cite": "1945 film fight scene - MixedMartialArts.com",
                  "citation": "James would train Judo at the Seinan Dojo under Kenneth Kuniyuki"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "rank": "1 dan",
              "date": null,
              "org": null,
              "quality": 0,
              "sources": [
                {
                  "uri": "urn:isbn:0831758058",
                  "cite": "CORCORAN, John; FARKAS, Emil. Martial Arts: Traditions, History. People, 1988",
                  "location": "p. 187",
                  "citation": "James Cagney, a certified judo black belt"
                },
                {
                  "uri": "https://www.e-budo.com/archive/index.php/t-13797.html",
                  "cite": "Cagney's Black Belt - E-Budo.com",
                  "citation": "He studied Judo just for the movie... up to Brown Belt"
                },
                {
                  "uri": "https://www.e-budo.com/archive/index.php/t-13797.html",
                  "cite": "Cagney's Black Belt - E-Budo.com",
                  "citation": "His judo dan ranking was honorary"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/James_Cagney",
              "cite": "James Cagney - Wikipedia"
            },
            {
              "uri": "https://www.mixedmartialarts.com/judo/1945-film-fight-scene"
            },
            {
              "uri": "https://www.e-budo.com/archive/index.php/t-13797.html"
            }
          ],
          "source_yaml": "database/persons/USA/James_Cagney.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-25",
          "name": "Hal Sharp",
          "aka": [
            {
              "name": "Harold Sharp"
            }
          ],
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": 1927,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": 2021,
            "location": null,
            "country_code": null
          },
          "photo_url": "https://article-imgs.scribdassets.com/2840m8mlj48oc26j/images/fileLKP2HSNH.jpg",
          "teachers": [
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1952,
                "end": null
              },
              "quality": 3
            },
            {
              "id": "JDP-119",
              "style_id": "JDP-S-1",
              "place": "Keishicho",
              "period": {
                "start": 1953,
                "end": 1955
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://www.usjf.com/takahiko-ishikawa/",
                  "cite": "Memories of My Sensei Takahiko Ishikawa, 9th Dan by Harold (Hal) E. Sharp (USJF)",
                  "citation": "I would like to share some of my experiences with you about my Sensei and dear friend, Takahiko Ishikawa (...) I first met Ishikawa in 1953 in Japan after I became a Shodan (1st degree black belt) and thus was allowed to workout at the Keishicho (Tokyo Police Dojo) (...)"
                }
              ]
            },
            {
              "id": "JDP-124",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1950,
                "end": null
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://judoinfo.com/oda/",
                  "cite": "Master Tsunetane Oda - JudoInfo",
                  "citation": "...I began to practice with Master Oda at Rikkyo University in Tokyo, during the early 1950’s and still remain fascinated by his bravado (...) I remained under Master Oda’s tutelage for many years practicing 3 times a day. Often I would accompany Master Oda to the Kodokan as well as the Dojo at Sugamo Prison."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Nanka Judo Yudanshakai",
              "teacher": null,
              "rank": "10 dan",
              "date": 2020,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Harold_Sharp",
              "cite": "Harold Sharp - Wikipedia"
            },
            {
              "uri": "https://youtu.be/B5B39yYPIlQ?t=169"
            },
            {
              "uri": "https://www.usjf.com/2018/02/harold-hal-sharp/"
            },
            {
              "uri": "urn:isbn:978-0804805421"
            },
            {
              "uri": "https://blackbeltmag.com/hal-sharp-judo"
            }
          ],
          "source_yaml": "database/persons/USA/Harold_Sharp.yaml",
          "photo_url_local": "images/cache/8a2641e4f643cea115938f9b84d9eb9f.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-120",
          "name": "Gene LeBell",
          "aka": [
            {
              "name": "Ivan Gene LeBell"
            }
          ],
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": "1932-10-09",
            "location": "Los Angeles",
            "country_code": "USA"
          },
          "death": {
            "date": "2022-08-09",
            "location": "Los Angeles",
            "country_code": "USA"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/en/9/95/Cropped_Photo_of_Gene_LeBell.jpg",
            "source": {
              "uri": "https://upload.wikimedia.org/wikipedia/en/9/95/Cropped_Photo_of_Gene_LeBell.jpg",
              "cite": "Cropped Photo of Gene LeBell (Wikipedia Commons)"
            }
          },
          "description": {
            "en": "Ivan Gene LeBell (October 9, 1932 – August 9, 2022) was an American judoka, stuntman, actor and professional wrestler. Nicknamed \"Judo Gene\" and \"The Godfather of Grappling\", he is credited with popularizing grappling in professional fighting circles, serving as a precursor to modern mixed martial arts. He worked on over 1,000 films and TV shows and authored 12 books."
          },
          "teachers": [
            {
              "id": "JDP-119",
              "style_id": "JDP-S-1",
              "place": "Keishicho",
              "period": {
                "start": 1953,
                "end": 1955
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://mokurendojo.blogspot.com/2008/05/mokuren-interview-judo-gene-lebell.html",
                  "cite": "Mokuren Interview: 'Judo' Gene LeBell (Mokuren Dojo)",
                  "citation": "Who do you think were the greatest judo teachers you ever got to learn from? Gene Lebell: In the U.S. Shig Tashma, Larry Coughran, Kenneth Kinyuki, Fuji Nazawa (who just died 2 days ago), and of course I learned a lot from training in Japan (Ishikawa)"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Harold_Sharp",
              "cite": "Harold Sharp - Wikipedia"
            },
            {
              "uri": "https://mokurendojo.blogspot.com/2008/05/mokuren-interview-judo-gene-lebell.html",
              "cite": "Mokuren Dojo: Mokuren Interview: 'Judo' Gene LeBell"
            }
          ],
          "source_yaml": "database/persons/USA/Gene_LeBell.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-111",
          "name": "Donn F. Draeger",
          "aka": [
            {
              "name": "Donald Frederick Draeger"
            }
          ],
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": "1922-04-15",
            "location": "Milwaukee, Wisconsin",
            "country_code": "USA"
          },
          "death": {
            "date": "1982-10-20",
            "location": "Milwaukee, Wisconsin",
            "country_code": "USA"
          },
          "photo": {
            "url": "https://archive.org/download/draeger/draeger.jpg",
            "source": {
              "uri": "https://judoinfo.com/kata/",
              "cite": "Nage no Kata and Katame no Kata, by Donn F. Draeger - JudoIndo"
            }
          },
          "teachers": [
            {
              "id": "JDP-112",
              "style_id": "JDP-S-6",
              "place": null,
              "period": {
                "start": 1967,
                "end": null
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "http://aiki-kohai.over-blog.com/2018/08/chronique-abregee-de-donn-f.draeger.html",
                  "cite": "Tatsusjin : la chronique abrégée de Donn F. Draeger (Aïki-Kohaï)",
                  "citation": "A partir de 1967, Il sera ensuite la premier pratiquant non japonais à entrer dans l'école Tenshin shoden Katori Shinto ryu alors sous la direction du célèbre Risuke Otake shihan, achevant son parcours dans cette école par l'obtention d'un grade d'instructeur."
                }
              ]
            },
            {
              "id": "JDP-117",
              "style_id": "JDP-S-17",
              "place": "Meiji Shrine",
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://kogenbudo.org/i-htm/",
                  "cite": "Donn Draeger & Robert Smith: Their Intersection Concerning Chinese Martial Arts (KogenBudo)",
                  "citation": "There was a famous xingyiquan and baguazhang teacher in Japan in those days, named Wang Shujin (...) Donn (and a number of other of his associates) began training with Wang on the grounds of the Meiji Shrine (...)"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Donn_F._Draeger",
              "cite": "Donn F. Draeger - Wikipedia"
            },
            {
              "uri": "https://budojapan.com/feature-articles/donn-f-draeger-the-pioneer/",
              "cite": "Donn F. Draeger: The Pioneer | BUDO JAPAN - Ttraditional Japanese martial-arts"
            }
          ],
          "source_yaml": "database/persons/USA/Donn_Draeger.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-132",
          "name": "AnnMaria De Mars",
          "aka": [
            {
              "name": "AnnMaria Burns"
            }
          ],
          "nationality": [
            "USA"
          ],
          "birth": {
            "date": "1958-06-15",
            "location": "Calumet, Michigan",
            "country_code": "USA"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/ann-maria/AnnMaria.jpeg",
            "source": {
              "uri": "https://www.historyoffighting.com/the-blog/dr-annmaria-de-mars",
              "cite": "The History of Fighting (AnnMaria de Mars)"
            }
          },
          "teachers": [
            {
              "id": "JDP-131",
              "style_id": "JDP-S-1",
              "place": "Waseda University, Tokyo",
              "period": {
                "start": "1976",
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://www.usjf.com/annmaria-de-mars-2/",
                  "cite": "AnnMaria De Mars - USJF",
                  "citation": "at the age of 18, as a college junior, De Mars was an exchange student at Waseda University in Tokyo, Japan. While there, she trained under Sensei Osawa"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "rank": "6 dan",
              "date": "2016",
              "org": null,
              "sources": [
                {
                  "uri": "https://www.fukudajudocamp.org/archives/2016-joshi-camp/",
                  "cite": "2016 Joshi Judo Camp - Fukuda Judo",
                  "citation": "2016 Joshi Judo Camp Guest Instructors: Dr. AnnMaria DeMars (6th Dan)"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/AnnMaria_De_Mars",
              "cite": "AnnMaria De Mars - Wikipedia"
            },
            {
              "uri": "https://www.usjf.com/annmaria-de-mars-2/",
              "cite": "AnnMaria De Mars | United States Judo Federation"
            },
            {
              "uri": "https://www.fukudajudocamp.org/archives/2016-joshi-camp/",
              "cite": "2016 Joshi Camp « Keiko Fukuda Joshi Judo Camp"
            },
            {
              "uri": "https://www.judoinside.com/judoka/6000/AnnMaria_Burns/judo-career",
              "cite": "JudoInside - AnnMaria Burns Judoka"
            }
          ],
          "source_yaml": "database/persons/USA/AnnMaria_De_Mars.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-100",
          "name": "Vladimir Putin",
          "native_name": {
            "name": "Влади́мир Влади́мирович Пу́тин",
            "lang": "ru"
          },
          "nationality": [
            "SUN",
            "RUS"
          ],
          "birth": {
            "date": "1952-10-07",
            "location": "Leningrad",
            "country_code": "SUN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/putin_202408/putin.png",
            "source": {
              "uri": "https://judo.ru/news/4783",
              "cite": "С днем рожденья! (ФЕДЕРАЦИЯ ДЗЮДО РОССИИ)"
            }
          },
          "teachers": [
            {
              "id": "JDP-99",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1964,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://judo.ru/news/4707",
                  "citation": "В 1964 году набрал первую группу юношей, среди которых были Аркадий Ротенберг, Валентин Степанов, Николай Кононов, Василий Шестаков, Владимир Путин.",
                  "cite": "Утрата"
                }
              ]
            },
            {
              "id": "JDP-99",
              "style_id": "JDP-S-15",
              "place": null,
              "period": {
                "start": 1964,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://vecherka-spb.ru/2023/08/08/chestnoe-i-dobrosovestnoe-otnoshenie-k-delu-kakim-bil-anatolii-rakhlin--lichnii-trener-vladimira-putina-",
                  "citation": "Хорошо помню, как Анатолий Соломонович проводил отбор в секцию самбо. Нужно было подтянуться — кто сколько сможет.",
                  "cite": "Вечерний Санкт-Петербург"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-15",
              "org": null,
              "teacher": null,
              "rank": "Master of Sports",
              "date": null,
              "sources": [
                {
                  "uri": "http://en.putin.kremlin.ru/interests/page-0",
                  "citation": "Putin is also multiple champion of St Petersburg in Sambo and Master of Sports in Sambo"
                }
              ],
              "style": "Sambo",
              "style_native": {
                "name": "сaмбо",
                "lang": "ru"
              }
            },
            {
              "style_id": "JDP-S-1",
              "org": "EJU",
              "teacher": null,
              "rank": "8 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.eju.net/8th-dan-attributed-to-vladimir-putin/",
                  "cite": "8th Dan attributed to Vladimir Putin (European Judo Union)",
                  "citation": "Following the festivities of the 60th anniversary of the International Judo Federation, celebrated last year in Paris on the occasion of the World Championships, the IJF had the honor of awarding the 8th dan to Vladimir Putin, President of the Russian Federation, who was also celebrating his 60th birthday on the 7th of october."
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ru.wikipedia.org/wiki/%D0%9F%D1%83%D1%82%D0%B8%D0%BD,_%D0%92%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80_%D0%92%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80%D0%BE%D0%B2%D0%B8%D1%87",
              "cite": "Путин, Владимир Владимирович — Википедия"
            },
            {
              "uri": "https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/",
              "cite": "Anatoliy Rakhlin: Person, Teacher, Coach | International SAMBO Federation (FIAS)"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q15088978",
              "cite": "Wikidata"
            }
          ],
          "source_yaml": "database/persons/SUN/Vladimir_Putin.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-97",
          "name": "Vasili Oshchepkov",
          "native_name": {
            "name": "Васи́лий Серге́евич Още́пков",
            "lang": "ru"
          },
          "nationality": [
            "RUS",
            "SUN"
          ],
          "birth": {
            "date": "1893-01-07",
            "location": "Sakhalin",
            "country_code": "RUS"
          },
          "death": {
            "date": "1938-10-10",
            "location": "Moscow",
            "country_code": "SUN"
          },
          "photo": {
            "url": "https://archive.org/download/vasili/vasili.jpg",
            "source": {
              "uri": "https://www.vokrug.tv/person/show/16914436371/"
            }
          },
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1911,
                "end": 1917
              },
              "quality": 0,
              "sources": [
                {
                  "uri": "https://oca.asia/sports/info/15/58/",
                  "citation": "Oshchepkov spent much of his life living in Japan and training judo under its founder Kano Jigoro."
                },
                {
                  "uri": "https://en.wikipedia.org/wiki/Vasili_Oshchepkov",
                  "citation": "",
                  "cite": "Vasili Oshchepkov - Wikipedia"
                }
              ]
            },
            {
              "name": "James O'Brien",
              "style_id": null,
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "2 dan",
              "date": 2007,
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20211028220427/http://kodokanjudoinstitute.org/en/news/2016/12/special-exhibition-of-the-material-concerning-mr-vasili-oshchepkov/",
                  "citation": "Mr. Oshchepkov became a disciple of the Kodokan in 1911 and then was promoted to 2nd Dan. A record book of initiation pleading shows his address and signature. Also his unique seal that says 'B.O' can be seen on it."
                },
                {
                  "uri": "https://en.wikipedia.org/wiki/Vasili_Oshchepkov",
                  "citation": "On June 15, 1913, Oshchepkov received the first degree black belt - shodan (first dan); in October 1917, during a trip to Japan, he passed the exams to receive his second degree black belt,becoming the first Russian and the third European to get a nidan in judo"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Vasili_Oshchepkov",
              "cite": "Vasili Oshchepkov - Wikipedia"
            },
            {
              "uri": "https://www.rbth.com/arts/2015/05/30/vasily_oshchepkov_the_founder_of_sambo_46477.html"
            },
            {
              "uri": "https://oca.asia/sports/info/15/58/"
            },
            {
              "uri": "https://ru.wikipedia.org/wiki/%D0%9E%D1%89%D0%B5%D0%BF%D0%BA%D0%BE%D0%B2,_%D0%92%D0%B0%D1%81%D0%B8%D0%BB%D0%B8%D0%B9_%D0%A1%D0%B5%D1%80%D0%B3%D0%B5%D0%B5%D0%B2%D0%B8%D1%87"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q4340844",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Vasili_Oshchepkov",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/SUN/Vasili_Oshchepkov.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-98",
          "name": "Sergei Dashkevich",
          "native_name": {
            "name": "Сергея Дашкевича",
            "lang": "ru"
          },
          "nationality": [
            "RUS",
            "SUN"
          ],
          "birth": {
            "date": "1896-10-18",
            "location": "Petrodvorets",
            "country_code": "RUS"
          },
          "death": {
            "date": "1955-03-17",
            "location": "Leningrad",
            "country_code": "SUN"
          },
          "photo": {
            "url": "https://archive.org/download/dashkevich/dashkevich.png",
            "source": {
              "uri": "https://judo.ru/news/9889"
            }
          },
          "teachers": [
            {
              "id": "JDP-97",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1931,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://judo.ru/news/9889",
                  "citation": "В 1931 году прошёл обучение в Москве у родоначальника отечественного дзюдо Василия Сергеевича Ощепкова на курсах преподавателей дзюдо для низовых заводских и вузовских коллективов"
                }
              ]
            },
            {
              "id": "JDP-97",
              "style_id": "JDP-S-15",
              "place": null,
              "period": {
                "start": 1931,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://judo.ru/news/9889",
                  "citation": "В 1931 году прошёл обучение в Москве у родоначальника отечественного дзюдо Василия Сергеевича Ощепкова на курсах преподавателей дзюдо для низовых заводских и вузовских коллективов"
                },
                {
                  "uri": "https://turbojudo.spb.ru/news/v-den-125letiya-so-dnya-rozhdeniya-osnovopolozhnika-leningradskogo-dzyudo-sergeya-dashkevicha-sostoyalos-pamyatnoe-meropriyatie",
                  "citation": "Вёл занятия в группе самбо, где его воспитанником с 1952 года был Анатолий Рахлин."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://judo.ru/news/9889"
            },
            {
              "uri": "https://turbojudo.spb.ru/news/v-den-125letiya-so-dnya-rozhdeniya-osnovopolozhnika-leningradskogo-dzyudo-sergeya-dashkevicha-sostoyalos-pamyatnoe-meropriyatie"
            }
          ],
          "source_yaml": "database/persons/SUN/Sergei_Dashkevich.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-101",
          "name": "Anatoly Kharlampiyev",
          "native_name": {
            "name": "Анато́лий Арка́дьевич Харла́мпиев",
            "lang": "ru"
          },
          "nationality": [
            "RUS",
            "SUN"
          ],
          "birth": {
            "date": "1906-10-29",
            "location": "Smolensk",
            "country_code": "RUS"
          },
          "death": {
            "date": "1979-04-16",
            "location": "Moscow",
            "country_code": "SUN"
          },
          "photo": {
            "url": "https://archive.org/download/kharlampiyev/kharlampiyev.jpeg",
            "source": {
              "uri": "https://dzen.ru/a/YgYnw0IeDT93JdjX"
            }
          },
          "teachers": [
            {
              "id": "JDP-97",
              "style_id": "JDP-S-1",
              "place": "State Central Order of Lenin Institute of Physical Culture",
              "period": {
                "start": 1931,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://ru.wikipedia.org/wiki/%D0%A5%D0%B0%D1%80%D0%BB%D0%B0%D0%BC%D0%BF%D0%B8%D0%B5%D0%B2,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%90%D1%80%D0%BA%D0%B0%D0%B4%D1%8C%D0%B5%D0%B2%D0%B8%D1%87",
                  "citation": "В 1936 г. окончил Государственный центральный ордена Ленина институт физической культуры (отделение дзюдо Василия Сергеевича Ощепкова)[...]Создавая «систему самбо», Харлампиев тщательно изучал дзюдо и осваивал его на практике. В дзюдо он видел основание нового вида борьбы в одежде, обогащённого наиболее эффективными приёмами других видов борьбы. Дзюдо он осваивал под руководством Василия Сергеевича Ощепкова, который во время многолетнего пребывания в Японии тренировался в школе дзюдо Кодокан."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-15",
              "org": "Soviet Union",
              "teacher": null,
              "rank": "Honored Master of Sports of the USSR",
              "date": 1947,
              "sources": [
                {
                  "uri": "https://ru.wikipedia.org/wiki/%D0%A5%D0%B0%D1%80%D0%BB%D0%B0%D0%BC%D0%BF%D0%B8%D0%B5%D0%B2,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%90%D1%80%D0%BA%D0%B0%D0%B4%D1%8C%D0%B5%D0%B2%D0%B8%D1%87",
                  "citation": "Заслуженный мастер спорта СССР (1947)"
                }
              ],
              "style": "Sambo",
              "style_native": {
                "name": "сaмбо",
                "lang": "ru"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ru.wikipedia.org/wiki/%D0%A5%D0%B0%D1%80%D0%BB%D0%B0%D0%BC%D0%BF%D0%B8%D0%B5%D0%B2,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%90%D1%80%D0%BA%D0%B0%D0%B4%D1%8C%D0%B5%D0%B2%D0%B8%D1%87"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Anatoly_Kharlampiyev"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q3615112",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Anatoly_Kharlampiyev",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/SUN/Anatoly_Kharlampiyev.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-99",
          "name": "Anatoliy Rakhlin",
          "native_name": {
            "name": "Анато́лий Соломо́нович",
            "lang": "ru"
          },
          "nationality": [
            "SUN",
            "RUS"
          ],
          "birth": {
            "date": "1938-05-23",
            "location": "Leningrad",
            "country_code": "SUN"
          },
          "death": {
            "date": "2013-08-07",
            "location": "Saint Petersburg",
            "country_code": "RUS"
          },
          "photo": {
            "url": "https://archive.org/download/raxlin-5/Raxlin5.jpg",
            "source": {
              "uri": "https://ekogradmoscow.ru/sreda/ekologija-kultury/sensej-dlya-prezidenta-anatolij-solomonovich-rakhlin",
              "cite": "Сенсей для президента - Анатолий Соломонович Рахлин ('ЭКОГРАД+')"
            }
          },
          "teachers": [
            {
              "id": "JDP-98",
              "style_id": "JDP-S-15",
              "place": "Leningrad Palace of the Pioneers",
              "period": {
                "start": 1955,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/",
                  "citation": "In 1953 he started taking SAMBO classes in the Palace of the Pioneers under the guidance of a highly experienced wrestler S. Dashkevich, a wrestling partner of Ivan Poddubny himself.",
                  "cite": "Anatoliy Rakhlin: Person, Teacher, Coach | International SAMBO Federation (FIAS)"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-15",
              "org": "Soviet Union",
              "teacher": null,
              "rank": "Master of Sports of the USSR",
              "date": null,
              "sources": [
                {
                  "uri": "https://fondsambo.ru/news/detail.php?ELEMENT_ID=26984",
                  "citation": "11 лет занятий с Анатолием Соломоновичем помогли будущему политическому лидеру России стать мастером спорта сначала по самбо, а потом по дзюдо.  Владимир Путин приглашал Анатолия Рахлина на значимые события своей жизни – от дней рождений до президентских инаугураций. Такие отношения можно без преувеличения назвать дружескими."
                }
              ],
              "style": "Sambo",
              "style_native": {
                "name": "сaмбо",
                "lang": "ru"
              }
            },
            {
              "style_id": "JDP-S-1",
              "org": null,
              "teacher": null,
              "rank": "8 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/",
                  "cite": "Anatoliy Rakhlin: person, teacher, coack (International Sambo Federation)",
                  "citation": "On August 7, 2013 in Saint Petersburg (Russia) after extended illness died Anatoliy Rakhlin, Honorary Coach of the Russian Federation, holder of the 8th dan rank in judo."
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ru.wikipedia.org/wiki/%D0%A0%D0%B0%D1%85%D0%BB%D0%B8%D0%BD,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%A1%D0%BE%D0%BB%D0%BE%D0%BC%D0%BE%D0%BD%D0%BE%D0%B2%D0%B8%D1%87"
            },
            {
              "uri": "https://rus.team/people/rakhlin-anatolij-solomonovich"
            },
            {
              "uri": "https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/",
              "cite": "Anatoliy Rakhlin: Person, Teacher, Coach | International SAMBO Federation (FIAS)"
            },
            {
              "uri": "https://www.kino-teatr.ru/kino/stuntman/sov/409209/bio/"
            },
            {
              "uri": "https://ria.ru/20130807/954840950.html"
            },
            {
              "uri": "https://web.archive.org/web/20120329141858/http://www.mir-judo.ru/territory/index.php?ELEMENT_ID=1380#"
            },
            {
              "uri": "https://www.lechaim.ru/ARHIV/258/kadish.htm"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q15088978",
              "cite": "Wikidata"
            }
          ],
          "source_yaml": "database/persons/SUN/Anatoliy_Rakhlin.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-63",
          "name": "Nuno Delgado",
          "aka": [
            {
              "name": "Nuno Miguel Delgado"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1976-08-27",
            "location": "Lisboa",
            "country_code": "PRT"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/nuno_delgado/nuno_delgado.jpg",
            "source": {
              "uri": "https://www.record.pt/jogo-da-vida/detalhe/nuno-delgado-quero-inspirar-cada-vez-mais-criancas-857704",
              "cite": "Fernando Ferreira (in: «Record», 9-XII-2013"
            }
          },
          "teachers": [
            {
              "id": "JDP-62",
              "style_id": "JDP-S-1",
              "place": "Sport Algés e Dafundo",
              "quality": 3,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.ulisboa.pt/sites/ulisboa.pt/files/public/aluno_de_kobayashi_moldou_o_campeao.pdf",
                  "cite": "José Costa Branco: Aluno de Kobayashi moldou o campeão (O Jogo, 22-II-2020)",
                  "citation": "... no histórico Sport Algés e Dafundo durante 28 anos. Foi lá que José Costa Branco encontrou Nuno Delgado, que saiu de Santarém, onde vivia e combatia, para regressar a Lisboa e se licenciar em Ciências do Desporto"
                },
                {
                  "uri": "https://www.record.pt/modalidades/detalhe/alges-conquista-nacional-de-seniores-por-equipas",
                  "cite": "Algés conquista Nacional de seniores por equipas (Record, 30-IV-2001)",
                  "citation": "Quero dedicar o triunfo ao ex-treinador José Branco, porque ele já merecia este título no ano passado, altura em que se retirou dos tapetes, considerou Nuno Delgado, medalha de bronze em Sydney 2000."
                }
              ]
            },
            {
              "id": "JDP-15",
              "style_id": "JDP-S-1",
              "place": null,
              "quality": 2,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.linkedin.com/posts/nunodelgadotpv_mestrebastosnunes-judo-portugaljudo-activity-7155564790885556225-5SnY?originalSubdomain=pt",
                  "cite": "Nuno Delgado",
                  "citation": "A par do meu Mestre Fernando Costa Matos, são as mais altas graduações Lusas, discípulos diretos de Kiyoshi Kobayashi, que tanto moldaram os nossos judocas, com a sua sabedoria e pedagogia"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "FPJ",
              "teacher": null,
              "rank": "3 dan",
              "date": 1982,
              "sources": [
                {
                  "uri": "http://fpj.pt/wp-content/uploads/2017/04/17ci175-Divulga%C3%A7%C3%A3o-Evento.pdf",
                  "cite": "Circular 175/17, FPJ",
                  "citation": "Nuno Delgado - Portugal - 6º Dan"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.nunodelgado.net/nuno-delgado"
            },
            {
              "uri": "https://www.record.pt/jogo-da-vida/detalhe/nuno-delgado-quero-inspirar-cada-vez-mais-criancas-857704"
            },
            {
              "uri": "https://pt.wikipedia.org/wiki/Nuno_Delgado"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Nuno_Delgado"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q1884969",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Kan%C5%8D_Jigor%C5%8D",
              "cite": "https://dbpedia.org/page/Nuno_Delgado"
            }
          ],
          "source_yaml": "database/persons/PRT/Nuno_Delgado.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-88",
          "name": "Mário Aguilar",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/mario_aguilar/mario_aguilar.jpg",
            "source": {
              "uri": "https://www.facebook.com/CDMaristaCarcavelos/photos/a.122820509363828/125020709143808/?type=3",
              "cite": "Clube Desportivo Marista de Carcavelos (Facebook)"
            }
          },
          "teachers": [
            {
              "id": "JDP-61",
              "style_id": "JDP-S-1",
              "place": "Judo Clube do Estoril",
              "quality": 2,
              "period": {
                "start": 1981,
                "end": 1982
              },
              "sources": [
                {
                  "uri": "https://github.com/Judo-Documentation-Project/budotree",
                  "cite": "Mário Aguilar, private communication, 2021",
                  "citation": "... os meus mestres por ordem cronológica foram: (...) António Roquete (...) no Judo Clube do Estoril - 1 ano"
                }
              ]
            },
            {
              "id": "JDP-128",
              "style_id": "JDP-S-1",
              "place": "Academia Petrucio Monteiro",
              "quality": 3,
              "period": {
                "start": 1980,
                "end": 1981
              },
              "sources": [
                {
                  "uri": "https://github.com/Judo-Documentation-Project/budotree",
                  "cite": "Mário Aguilar, private communication, 2021",
                  "citation": "... os meus mestres por ordem cronológica foram: (...) Mestre Petrúcio Monteiro (Brasil) - 1980 a 1981 e meio"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "FPJ",
              "teacher": null,
              "rank": "2 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://github.com/Judo-Documentation-Project/budotree",
                  "cite": "Mário Aguilar, private communication, 2021"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.facebook.com/CDMaristaCarcavelos/photos/a.122820509363828/125020709143808/?type=3"
            },
            {
              "uri": "https://cdmc.marista-carcavelos.org/judo/"
            }
          ],
          "source_yaml": "database/persons/PRT/Mario_Aguilar.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-75",
          "name": "Manuel Reis",
          "aka": [
            {
              "name": "Manuel Pereira de Matos Reis"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1922-07-23",
            "location": null,
            "country_code": "PRT"
          },
          "death": {
            "date": "2005-11-23",
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/manuel_reis/manuel_reis.png",
            "source": {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html"
            }
          },
          "teachers": [
            {
              "id": "JDP-74",
              "style_id": "JDP-S-1",
              "place": "Clube de Judo do Porto",
              "quality": 2,
              "period": {
                "start": 1968,
                "end": 1969
              },
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
                  "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
                  "citation": "Em 1968, ao abrigo do Fundo de Fomento Desportivo, chega ao Porto o jovem Mestre japonês, de 26 anos, Nabuaki Yamamoto, 5º Dan, aluno do Kodokan e antigo campeão universitário do Japão, tornando-se professor do Clube de Judo do Porto. No início de 1969, o Mestre Yamamoto parte para a Islândia e as aulas voltam a ser ministradas pelos judocas mais graduados, que contavam agora com o apoio muito esporádico de alguns elementos da Federação Portuguesa de Judo"
                },
                {
                  "uri": "https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/",
                  "citation": "Fernando Costa Matos encontrou-se com um dos mais antigos praticantes do judo em Portugal, Manuel Reis, que já tinha trazido o japonês Yamamoto nos anos 60 para orientar o clube e que aceitou de bom grado a vinda de Frigyes Torok para a direção técnica do tradicional clube da cidade Invicta."
                }
              ]
            },
            {
              "id": "JDP-76",
              "style_id": "JDP-S-14",
              "place": null,
              "quality": 2,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html",
                  "citation": "...Manuel Reis fora aluno de  Armando Gonçalves, um portuense Professor de Ju-Jutsu 柔術..."
                }
              ]
            },
            {
              "id": "JDP-78",
              "style_id": "JDP-S-1",
              "place": "Círculo de Judo do Porto",
              "quality": 2,
              "period": {
                "start": 1955,
                "end": 1965
              },
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
                  "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
                  "citation": "Em 1955, os judocas do Porto organizados em torno do professor Jackie Hugnet, criam o Círculo de Judo do Porto, onde Hugnet foi professor durante sete anos, lecionando três vezes por semana a primeira classe em que o Judo Kodokan foi ministrado de forma sistemática no Porto. Os professores Hugnet e Manuel Reis foram instrutores de Judo da Polícia de Segurança Pública do Porto, durante cerca de dois anos meio, coincidentes com parte do período em que o Comandante da corporação era o famoso Chefe Santos Júnior."
                },
                {
                  "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html",
                  "citation": "Este, impressionado com a determinação de Manuel Reis mas sem disponibilidade para ficar em Portugal, enviou para o Círculo de Judo do Porto o seu irmão Jackie Hugnet, 2º Dan de Judo, que connosco permaneceu por uma década"
                }
              ]
            },
            {
              "id": "JDP-79",
              "style_id": "JDP-S-1",
              "place": "Círculo de Judo do Porto",
              "quality": 2,
              "period": {
                "start": 1961,
                "end": 1963
              },
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
                  "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
                  "citation": "No Verão de 1961, o professor Hugnet é substituído pelo também francês, Gilbert Bryskine, 4º Dan, campeão de França, bicampeão da Europa (1952 e 1954) e professor diplomado pela Federação Francesa de Judo e Ju Jutsu. É com Bryskine que os atletas do Círculo começam a participar em provas federativas, quer individualmente, quer por equipas. Em 1963, Gilbert Bryskine regressou a França devido a um grave acidente de automóvel que o deixou incapacitado."
                },
                {
                  "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html",
                  "citation": "Na época, recebemos também os ensinamento de outro francês, Gilbert Briskine, 4º Dan de Judo e mestre de Karaté-Do 空手道, Disciplina a quem a divulgação em Portugal muito deve."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html"
            },
            {
              "uri": "https://www.jpn.up.pt/2015/04/21/clube-judo-do-porto-50-anos-continua-jovem/"
            },
            {
              "uri": "https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/"
            },
            {
              "uri": "https://judolandia.tripod.com/histport.htm"
            }
          ],
          "source_yaml": "database/persons/PRT/Manuel_Reis.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-82",
          "name": "Luís Franco Pires Martins",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1925",
            "location": null,
            "country_code": null
          },
          "death": {
            "date": "2003",
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/piresmartins1965/piresmartins1965.jpg",
            "source": {
              "uri": "https://www.ubu.pt/home/professores/dr-luis-franco-pires-martins/",
              "cite": "Dr. Luís Franco Pires Martins (1925-2003) - UBU"
            }
          },
          "teachers": [
            {
              "id": "JDP-83",
              "style_id": "JDP-S-1",
              "place": "Academia de Budo",
              "quality": 1,
              "period": {
                "start": 1951,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://repositorio.ipv.pt/handle/10400.19/448",
                  "cite": "FIGUEIREDO, Abel Aurélio Abreu. A institucionalização do karaté-os modelos organizacionais do karaté em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)",
                  "citation": "(...)Além de ser o primeiro cinto negro inscrito no Kodokan (Japão), Corrêa Pereira é o primeiro editor de revistas de Judo Kodokan (...) o Dr. João Luís Franco Pires Martins refere que por volta de 1946 é que se iniciou a prática de Judo na Academia de Judo, sendo aí que ele inicia a prática de Judo, em 1951"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-5",
              "org": "UBU",
              "teacher": null,
              "rank": "1 dan",
              "date": "1963-09-10",
              "sources": [
                {
                  "uri": "https://repositorio.ipv.pt/handle/10400.19/448",
                  "cite": "FIGUEIREDO, Abel Aurélio Abreu. A institucionalização do karaté-os modelos organizacionais do karaté em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)",
                  "citation": "sendo mesmo a data da sua graduação de 1º dan atribuída pela UBU, ou seja por Corrêa Pereira, um dos primeiros marcos de institucionalização do Karaté em Portugal, pelo que 10 de Setembro de 1963 poderá ser simbolicamente a data de início da «época» do Karaté Português. Note-se ainda que essa graduação, apesar de ser institucional e sem o vínculo directo de um mestre ou organização japonesa, tem algum reconhecimento posterior quando em 1971 a FAJKO (Federation of All Japan Karatedo Organizations) atribui a graduação honorífica de 4º dan a Pires Martins"
                }
              ],
              "style": "Karate",
              "style_native": {
                "name": "空手",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-5",
              "org": "FAJKO",
              "teacher": null,
              "rank": "1 dan",
              "date": "1971-12-15",
              "sources": [
                {
                  "uri": "https://repositorio.ipv.pt/handle/10400.19/448",
                  "cite": "FIGUEIREDO, Abel Aurélio Abreu. A institucionalização do karaté-os modelos organizacionais do karaté em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)",
                  "citation": "sendo mesmo a data da sua graduação de 1º dan atribuída pela UBU, ou seja por Corrêa Pereira, um dos primeiros marcos de institucionalização do Karaté em Portugal, pelo que 10 de Setembro de 1963 poderá ser simbolicamente a data de início da «época» do Karaté Português. Note-se ainda que essa graduação, apesar de ser institucional e sem o vínculo directo de um mestre ou organização japonesa, tem algum reconhecimento posterior quando em 1971 a FAJKO (Federation of All Japan Karatedo Organizations) atribui a graduação honorífica de 4º dan a Pires Martins"
                }
              ],
              "style": "Karate",
              "style_native": {
                "name": "空手",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.ubu.pt/home/professores/dr-luis-franco-pires-martins/"
            },
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm"
            },
            {
              "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_17-22.pdf"
            },
            {
              "uri": "https://repositorio.ipv.pt/handle/10400.19/448"
            },
            {
              "uri": "https://mestremanuelceia.webnode.pt/memorias/"
            },
            {
              "uri": "http://pks.pt/ROP1.php"
            }
          ],
          "notes": "As relações de aprendizagem entre os membros fundadores da UBU não\nsão claras, provavelmente apenas por não serem tópico que é\nexpressamente dito nas fontes, mas também provavelmente pela\ndinâmica de grande voluntarismo e inovação que caracterizam uma\norganização que foi pioneira. Uma leitura transversal das várias\nfontes apontam para relações de aprendizagem mútua, com posterior\nvalidação/homologação em alguns casos (como no do Karate).  Assim,\na identificação das relações aluno/professor provavelmente\ndemonstrarão uma relação em rede, sendo que a figura de Corrêa\nPereira se apresenta como agregadora, mesmo não sendo na maior\nparte das vezes claro a influência directa (em termos de treino)\nque existiu, em especial a partir do final dos anos 50.  Isto é\nparticularmente aplicável ao Judo (e jujutsu), visto que para o\nAikido e Karate a evolução posterior na UBU permitem leituras mais\nconcretas. Sobre o Judo, antes de Shirooka não é claro quem faz a\ninstrução, assumindo-se que Corrêa Pereira é uma das fontes (e.g.,\na demonstração com Sebastião Durão).\n",
          "source_yaml": "database/persons/PRT/Luís_Pires_Martins.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-85",
          "name": "Leopoldo Ferreira",
          "aka": [
            {
              "name": "Leopoldo António Serra Ferreira"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": "2014-01-06",
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/leopoldo_ferreira/leopoldo_ferreira.jpg",
            "source": {
              "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm",
              "cite": "Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)"
            }
          },
          "teachers": [
            {
              "name": "JDP-87",
              "style_id": "JDP-S-4",
              "place": "Academia de Budo",
              "quality": 3,
              "period": {
                "start": 1971,
                "end": 1972
              },
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm",
                  "cite": "Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "Não, eu só comecei a praticar em 1971, mais precisamente a 30 de Dezembro de 1971, quinta-feira, às 18.30h (Risos), na Academia de Budo, com Misao Honda (...) Eu só conheci o Mestre Stobbaerts, em Agosto ou Setembro de 1972, pelo simples motivo que quando o Honda se foi embora, como eu era o aluno mais graduado, e também porque era estudante de Educação Física, o Dr. Pires Martins insistiu para que eu ficasse a dar as aulas de Aikido"
                }
              ]
            },
            {
              "id": "JDP-86",
              "style_id": "JDP-S-4",
              "place": "Budokai Cascais",
              "quality": 3,
              "period": {
                "start": 1972,
                "end": 1976
              },
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm",
                  "cite": "Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)",
                  "citation": " Eu só conheci o Mestre Stobbaerts, em Agosto ou Setembro de 1972 (...) Portanto, durante anos, os meus fins-de-semana eram passados em Cascais a praticar Aikido. Pratiquei com o Mestre Stobbaerts talvez uns três ou quatro anos."
                },
                {
                  "uri": "https://web.archive.org/web/20081021195508/http://www.cao.pt/surya/pe_17_1.htm",
                  "cite": "Entrevista ao Professor Georges Stobbaerts (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "Nessa altura o ambiente no Aikido era muito bom, toda a gente praticava com toda gente, mesmo os alunos da escola do Kobayashi, como o Leopoldo Ferreira, que chegou a ser meu aluno."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": "UBU",
              "teacher": null,
              "rank": "Yudansha",
              "date": null,
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm",
                  "cite": "Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)",
                  "citation": " O meu nome é Leopoldo António Serra Ferreira, tenho 48 anos e sou cinto negro de Aikido da União Portuguesa de Budo. (...) Na União Portuguesa de Budo não temos graduações. A graduação mais elevada é o cinto negro, a partir daí acabaram-se os exames. Não existe 2º, 3º dan., etc."
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.ubu.pt/home/professores/mestre-luis-fernando/"
            },
            {
              "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm"
            },
            {
              "uri": "https://www.fpaikido.pt/sites/default/files/docs/HistoPt%20-%20atualizacao%20MSendim.pdf"
            }
          ],
          "source_yaml": "database/persons/PRT/Leopoldo_Ferreira.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-62",
          "name": "José Costa Branco",
          "aka": [
            {
              "name": "José Branco"
            },
            {
              "name": "José da Costa Branco"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1937-03-13",
            "location": "Lourenço Marques",
            "country_code": "MOZ"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/screenshot-from-2024-02-13-15-42-24/jose_branco.png",
            "source": {
              "uri": "https://delagoabay.wordpress.com/2011/01/16/jose-branco-olimpico-e-campeao-de-judo-e-de-tiro/",
              "cite": "Diário de Lisboa, 1980 (in: The Delagoa Bay Company)"
            }
          },
          "teachers": [
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": null,
              "period": {
                "start": 1975,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://judomagazine.pt/2021/07/04/1980-moscovo/",
                  "cite": "José Branco não boicotou o seu sonho (Judo Magazine)",
                  "citation": "O judo passou a ser central na sua vida que tinha levado uma volta muito grande. No Judo Clube de Portugal teve por mestre Kiyoshi Kobayashi e os seus colegas de clube passaram a ser os seus amigos para todos os momentos da vida quotidiana."
                },
                {
                  "uri": "https://delagoabay.wordpress.com/2011/01/16/jose-branco-olimpico-e-campeao-de-judo-e-de-tiro/",
                  "cite": "José Branco, Olímpico e Campeão de Tiro e Judo (The Delagoa Bay Company blog)",
                  "citation": "Ao lado de josé branco, um amigo muito especial , mestre Kobayaschi . Refere o José: no período mais difícil da minha vida, então com 22 anos, quando me encontrava completamente atolado, foi o único que me lançou a mão. No último segundo da minha vida, ele fará parte dos meus pensamentos."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "FPJ",
              "teacher": null,
              "rank": "3 dan",
              "date": 1982,
              "sources": [
                {
                  "uri": "https://search.worldcat.org/title/817030285?oclcNum=817030285",
                  "cite": "Judo: da iniciação à competição (1983), p. 23",
                  "citation": "1982: (...) José Branco: 3º Dan . J. C. Portugal"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judomagazine.pt/2021/07/04/1980-moscovo/"
            },
            {
              "uri": "https://delagoabay.wordpress.com/2011/01/16/jose-branco-olimpico-e-campeao-de-judo-e-de-tiro/"
            },
            {
              "uri": "https://archive.is/cMx9V"
            }
          ],
          "source_yaml": "database/persons/PRT/José_Costa_Branco.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-80",
          "name": "José Araújo",
          "aka": [
            {
              "name": "José Manuel da Silva Araújo"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1955",
            "location": "Lisboa",
            "country_code": "PRT"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/luis-araujo/Luis_Araujo.png",
            "source": {
              "uri": "https://aikidomdc.wixsite.com/brpd/untitled-c1eb9",
              "cite": "Aikido Marcial Dôjo Clube - Mestre José Araújo"
            }
          },
          "teachers": [
            {
              "id": "JDP-81",
              "style_id": "JDP-S-5",
              "place": "Academia de Budo",
              "quality": 3,
              "period": {
                "start": 1966,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://aikidomdc.wixsite.com/brpd/untitled-c1eb9",
                  "cite": "Aikido Marcial Dôjo Clube - Mestre José Araújo",
                  "citation": "Inicia a prática do Aikido e Karatedo em 1966, na Academia de Budo, com a idade de 10 anos, sendo seus professores Carlos Pereira, aluno de Mestre Georges Stobbaerts, e Fragoso Fernandes, aluno de Pires Martins, introdutor do Karatedo em Portugal."
                },
                {
                  "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
                  "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o responsável pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem séria, rigorosa e profundamente empenhada."
                }
              ]
            },
            {
              "id": "JDP-84",
              "style_id": "JDP-S-4",
              "place": "Academia de Budo",
              "quality": 3,
              "period": {
                "start": 1966,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
                  "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o responsável pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem séria, rigorosa e profundamente empenhada."
                }
              ]
            },
            {
              "id": "JDP-85",
              "style_id": "JDP-S-4",
              "place": "Academia de Budo",
              "quality": 3,
              "period": {
                "start": 1973,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
                  "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "Foi o Leopoldo Ferreira (...) Mas quem ficou na Academia, em permanência, a dar aulas de Aikido foi o Leopoldo Ferreira."
                },
                {
                  "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm",
                  "cite": "Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "Quando o José Araújo recomeçou a praticar já estava eu a dar aulas, portanto, foi por volta de 1973, creio."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": "UBU",
              "teacher": null,
              "rank": "7 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.ubu.pt/home/professores/prof-doutor-jose-manuel-araujo/",
                  "citation": "7º Dan Aikido UBU"
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-4",
              "org": "Dai Nippon Butokukai",
              "teacher": null,
              "rank": "Renshi",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.ubu.pt/home/professores/prof-doutor-jose-manuel-araujo/",
                  "citation": "6º Dan Aikido Dai Nippon Butokukai – Renshi"
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-1",
              "org": "IMAF",
              "teacher": null,
              "rank": "Kyoshi",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.ubu.pt/home/professores/prof-doutor-jose-manuel-araujo/",
                  "citation": "6º Dan Aikido – International Martial Arts Federation – Kyoshi"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.ubu.pt/home/professores/prof-doutor-jose-manuel-araujo/"
            },
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm"
            }
          ],
          "source_yaml": "database/persons/PRT/José_Araújo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-64",
          "name": "Henrique Nunes",
          "aka": [
            {
              "name": "Henrique Carinhas Martins Nunes"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1948-03-28",
            "location": "Benguela",
            "country_code": "AGO"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/henrique_nunes/henrique_nunes.jpeg",
            "source": {
              "uri": "https://www.fpj.pt/wp-content/uploads/2019/03/19ci052-Divulgação-de-Eventos.pdf",
              "cite": "Divulgação de Eventos (FPJ)"
            }
          },
          "teachers": [
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": 3,
              "period": {
                "start": 1959,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://judomagazine.pt/2023/03/19/reportagem-no-santuario-com-henrique-nunes-1/",
                  "cite": "No «santuário» com Henrique Nunes (Judo Magazine)",
                  "citation": "«Ali em frente é a área reservada ao meu Mestre, à pessoa que mais admiro e de quem tenho imensas saudades» adiantou o nosso anfitrião sinalizando uma grande fotografia de Kiyoshi Kobayashi, aquela que é marca global do japonês que desde 1958 referencia o judo nacional em todas as suas dimensões, técnicas, culturais, profissionais e até institucionais. Ao lado uma fotografia datada de 1966 com Henrique Nunes a receber de KK uma medalha de campeão nacional, uma das muitas, ao ponto de ser difícil recordar-se de todas."
                },
                {
                  "uri": "https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381",
                  "cite": "Seis histórias à volta do Tatami _ Gala 60º Aniversário FPJ",
                  "citation": "... o mestre Kobayashi em Portugal, em '58 (...) foi o meu mestre."
                }
              ]
            },
            {
              "id": "JDP-65",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": 3,
              "period": {
                "start": 1954,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381",
                  "cite": "Seis histórias à volta do Tatami _ Gala 60º Aniversário FPJ",
                  "citation": "...Tive óptimos professores no princípio. Era o Comandante Afonso Henriques Maia Loureiro, era o dr. Nuno Ribeiro..."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "FPJ",
              "teacher": null,
              "rank": "8 dan",
              "date": "2019-07-12",
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/06/Relat%C3%B3rio-Anual-FPJ-2019-23jun2020.pdf",
                  "cite": "Relatório Anual FPJ 2019",
                  "citation": "Henrique Nunes (...) 8º Dan"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judomagazine.pt/2023/03/19/reportagem-no-santuario-com-henrique-nunes-1/"
            },
            {
              "uri": "https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381"
            },
            {
              "uri": "https://judolandia.tripod.com/hnunes.htm"
            }
          ],
          "source_yaml": "database/persons/PRT/Henrique_Nunes.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-81",
          "name": "Fragoso Fernandes",
          "aka": [
            {
              "name": "António Luis Rivara Fragoso Fernandes"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": "JDP-82",
              "style_id": "JDP-S-5",
              "place": "Academia de Budo",
              "quality": 3,
              "period": {
                "start": 1966,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_17-22.pdf",
                  "cite": "ARAÚJO, José, O Dr. Pires Martins e a União Portuguesa de Budo. In: A Génese do Karaté em Portugal",
                  "citation": "Guardo ainda a imagem das minhas primeiras aulas de Karate-do, orientadas por essa extraordinária ﬁgura que era o Doutor Fragoso Fernandes, para mim, naquela época, a incarnação das virtudes físicas, técnicas e morais do Budoka (...)  Aluno desde o primeiro dia do Dr. Pires Martins, transpôs para o contacto com os alunos que se iniciavam a sua visão, como tive desde então o ensejo de conﬁrmar"
                },
                {
                  "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
                  "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o responsável pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem séria, rigorosa e profundamente empenhada."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": "UBU",
              "teacher": null,
              "rank": "1 dan",
              "date": "1968-08-14",
              "sources": [
                {
                  "uri": "https://www.fnkp.pt/wp-content/uploads/2020/06/ProgramaForma__o2012-2015_-_Passado_e_Futuro_dos_Treinadores_de_Karate_-_Abel_Figueiredo.pdf",
                  "cite": "50 Anos da carreira de treinador de Karate em Portugal (Federação Nacional de Karate)",
                  "citation": "António Luiz Rivara Fragoso Fernandes -  14-08-68 - 1º Dan"
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.ubu.pt/home/professores/prof-doutor-antonio-fragoso-fernandes/"
            },
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm"
            },
            {
              "uri": "https://sites.google.com/campus.ul.pt/df-flul/professores/mem%C3%B3ria"
            }
          ],
          "source_yaml": "database/persons/PRT/Fragoso_Fernandes.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-87",
          "name": "Fernando Seabra",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/fernando_seabra/fernando_seabra.png",
            "source": {
              "uri": "https://judomagazine.pt/2024/01/23/mestre-ze-manel/",
              "cite": "Mestre Zé Manel (Judo MAGAZINE, 2024)"
            }
          },
          "teachers": [
            {
              "id": "JDP-16",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Sintra - Judokai",
              "quality": 2,
              "period": {
                "start": 1980,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://judomagazine.pt/2024/01/23/mestre-ze-manel/",
                  "citation": "Foi com o «Mestre Zé Manel», como carinhosamente os alunos mais chegados se atreviam a tratá-lo, que iniciei a minha prática do Judo no Judo Clube de Sintra – Judokai, no Cacém, em 1980, e foi essencialmente com Ele que aprendi grande parte do pouco que hoje sei neste meu percurso pelo Judo"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "FPJ",
              "teacher": null,
              "rank": "5 dan",
              "date": "2017-01-13",
              "sources": [
                {
                  "uri": "https://fpj.pt/wp-content/uploads/2018/01/18ci019-Exames-Nacionais-Gradua%C3%A7%C3%A3o-Resultados.pdf",
                  "cite": "Exames Nacionais de Graduação - Resultados (FPJ, 13-1-2017)",
                  "citation": "Exames para 5º DAN (...) Fernando Seabra (...) APROVADO"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.judokai.pt/judokai/mestres-treinadores-e-graduados/"
            },
            {
              "uri": "https://site.judototal.com/seccao/treinadores-e-cintos-negros"
            },
            {
              "uri": "https://judobeirainterior.blogspot.com/2011/04/"
            }
          ],
          "source_yaml": "database/persons/PRT/Fernando_Seabra.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-73",
          "name": "Fernando Sarmento",
          "aka": [
            {
              "name": "Fernando Duarte Sarmento"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1950",
            "location": "Maia",
            "country_code": "PRT"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/franciso_sarmento/fernando_sarmento.jpg",
            "source": {
              "uri": "http://escolamurakamimaia.weebly.com/fernando-sarmento.html",
              "cite": "Fernando Duarte Sarmento (Escola Murakami da Maia)"
            }
          },
          "teachers": [
            {
              "id": "JDP-74",
              "style_id": "JDP-S-1",
              "place": "Clube de Judo do Porto",
              "quality": 3,
              "period": {
                "start": 1968,
                "end": 1969
              },
              "sources": [
                {
                  "uri": "http://escolamurakamimaia.weebly.com/fernando-sarmento.html",
                  "cite": "Fernando Duarte Sarmento (Escola Murakami da Maia)",
                  "citation": "Inicia o seu percurso nas «Artes Marciais» em 1968 como praticante de Judo no Clube de Judo do Porto (Rua Duque de Loulé), treinando sob a orientação directa do Mestre Nobuaki Yamamoto (5º Dan)"
                }
              ]
            },
            {
              "id": "JDP-72",
              "style_id": "JDP-S-4",
              "place": "Mussubi Escola de Aikido",
              "quality": 3,
              "period": {
                "start": 2006,
                "end": null
              },
              "sources": [
                {
                  "uri": "http://escolamurakamimaia.weebly.com/fernando-sarmento.html",
                  "cite": "Fernando Duarte Sarmento (Escola Murakami da Maia)",
                  "citation": "A 17 de Março de 2006 inicia a prática do Aikido na Mussubi Escola de Aikido / Takemusu Aiki Portugal sob a direcção técnico-pedagógica do Mestre Carlos Portas, com quem continua a praticar regularmente até ao presente momento. É graduado por Carlos Portas em 1º Dan a 11 de Agosto de 2007 e 2º Dan em 8 de Agosto de 2009."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": "Aikikai",
              "teacher": null,
              "rank": "2 dan",
              "date": 2009,
              "sources": [
                {
                  "uri": "http://escolamurakamimaia.weebly.com/fernando-sarmento.html",
                  "cite": "Fernando Duarte Sarmento (Escola Murakami da Maia)",
                  "citation": "A 17 de Março de 2006 inicia a prática do Aikido na Mussubi Escola de Aikido / Takemusu Aiki Portugal sob a direcção técnico-pedagógica do Mestre Carlos Portas, com quem continua a praticar regularmente até ao presente momento. É graduado por Carlos Portas em 1º Dan a 11 de Agosto de 2007 e 2º Dan em 8 de Agosto de 2009."
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://sportmagazine.pt/carlos-portas-a-pratica-e-a-evolucao-do-aikido-em-aveiro-temos-que-nos-reinventar/"
            },
            {
              "uri": "https://aikidomdc.wixsite.com/brpd/untitled-c1nrv"
            },
            {
              "uri": "https://web.archive.org/web/20081021192343/http://www.cao.pt/surya/pe_12_1.htm"
            }
          ],
          "source_yaml": "database/persons/PRT/Fernando_Sarmento.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-15",
          "name": "Fernando Costa Matos",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1941-04-01",
            "location": "Ponta Delgada",
            "country_code": "PRT"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": "https://ia800306.us.archive.org/5/items/costamatos/costamatos1.jpg",
          "teachers": [
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "INEF",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.facebook.com/ipatj/photos/a.243433975668608/1073113529367311/?type=3&locale=pt_PT",
                  "cite": "Renato Santos Kobayashi, in Instituto Português de Artes Tradicionais Japonesas - Facebook",
                  "citation": "Em 1958 o Mestre K.K. assinou então um contrato para ficar em Portugal por um período de dois anos. Nesta sequência, aceita o convite para integrar o corpo docente do então Instituto Nacional de Educação Física (INEF), onde lecionou durante dez anos (...)  Destaca-se o nome do Fernando Costa Matos, atleta olímpico que iniciou o Judo no INEF em 1959 e em 1964 participou pela 1.ª vez nos J. Olímpicosde Tóquio."
                }
              ]
            },
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20240212151508/https://www.linkedin.com/posts/nunodelgadotpv_mestrebastosnunes-judo-portugaljudo-activity-7155564790885556225-5SnY/?originalSubdomain=pt",
                  "cite": "Nuno Delgado LinkedIn post",
                  "citation": "O Mestre Bastos Nunes, juntou-se ao seu querido Mestre Kobayashi que serviu com verdadeira alma Samurai, «linha dura» como dizia sempre. A par do meu Mestre Fernando Costa Matos, são as mais altas graduações Lusas, discípulos diretos de Kiyoshi Kobayashi, que tanto moldaram os nossos judocas, com a sua sabedoria e pedagogia."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Federação Portuguesa de Judo",
              "teacher": null,
              "rank": "9 dan",
              "date": 2019,
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/03/20ci057-Relat%C3%B3rio-de-Atividades-e-Contas-do-Exerc%C3%ADcio-de-2019_.pdf",
                  "cite": "Relatório de Atividade e Contas 2019, FPJ",
                  "citation": "E, grande momento da Gala e absolutamente inédito em Portugal, os Mestres José Manuel Bastos Nunes (ausente por motivos de saúde, tendo enviado uma linda mensagem) e Fernando Costa Matos receberam o Diploma de Graduação de 9.º Dan, a mais alta graduação nacional e naturalmente, das maiores do Mundo!"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://correiodosacores.pt/NewsDetail/ArtMID/383/ArticleID/31195/%E2%80%9CA-not237cia-de-que-iria-aos-Jogos-Ol237mpicos-foi-um-pouco-inesperada-mas-recebida-com-emo231227o-e-alegria%E2%80%9D"
            },
            {
              "uri": "http://www.fpj.pt/wp-content/uploads/2019/12/19ci344-Premiados-na-Gala-do-60%C2%BA-Anivers%C3%A1rio-da-FPJ.pdf"
            },
            {
              "uri": "https://judolandia.tripod.com/costamatos-bi.htm"
            },
            {
              "uri": "https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/"
            },
            {
              "uri": "https://judomagazine.pt/2023/04/30/entrevista-fernando-costa-matos-um-velejador-navegador-de-judogi/"
            }
          ],
          "source_yaml": "database/persons/PRT/Fernando_Costa_Matos.yaml",
          "photo_url_local": "images/cache/a1694772c78a2a3234bedc9f5abe5ca1.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-72",
          "name": "Carlos Portas",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1956",
            "location": null,
            "country_code": "PRT"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/carlos_portas/carlos_portas.png",
            "source": {
              "uri": "https://aikidomdc.wixsite.com/brpd/untitled-c1nrv",
              "cite": "Mestre Carlos Portas (Aikido Marcial Dojo Clube)"
            }
          },
          "teachers": [
            {
              "id": "JDP-71",
              "style_id": "JDP-S-4",
              "place": "Iwama Dōjō",
              "quality": null,
              "period": {
                "start": 1985,
                "end": 1993
              },
              "sources": [
                {
                  "uri": "https://aikidomdc.wixsite.com/brpd/untitled-c1nrv",
                  "cite": "Mestre Carlos Portas (Aikido Marcial Dojo Clube)",
                  "citation": " Em 1985, viu no jornal o anúncio de uma demonstração de Aikido por um mestre japonês (Mestre Tomita), em Estocolmo, e foi ver. Achou que tinha caído num poço de luz e logo ali perguntou ao Mestre se o aceitava como aluno, o que veio a acontecer. Regressou a Portugal em 1993"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": "Aikikai",
              "teacher": null,
              "rank": "6 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://sportmagazine.pt/carlos-portas-a-pratica-e-a-evolucao-do-aikido-em-aveiro-temos-que-nos-reinventar/",
                  "cite": "Carlos Portas, a prática e a evolução do Aikido em Aveiro: «Temos que nos reinventar» (Sport Magazine)",
                  "citation": "Com graduação de 6º dan, Aikikai recomendada por Ulf Evenas Shihan e atribuída pelo Hombo Dojo Aikikai Tokyo, Carlos Portal é uma referência na prática do Aikido em Portugal."
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://sportmagazine.pt/carlos-portas-a-pratica-e-a-evolucao-do-aikido-em-aveiro-temos-que-nos-reinventar/"
            },
            {
              "uri": "https://aikidomdc.wixsite.com/brpd/untitled-c1nrv"
            },
            {
              "uri": "https://web.archive.org/web/20081021192343/http://www.cao.pt/surya/pe_12_1.htm"
            }
          ],
          "source_yaml": "database/persons/PRT/Carlos_Portas.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-84",
          "name": "Carlos Pereira",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": "JDP-86",
              "style_id": "JDP-S-4",
              "place": null,
              "quality": 2,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
                  "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o responsável pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem séria, rigorosa e profundamente empenhada."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm"
            },
            {
              "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm"
            }
          ],
          "source_yaml": "database/persons/PRT/Carlos_Pereira.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-16",
          "name": "José Manuel Bastos Nunes",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1937-03-13",
            "location": "Sintra",
            "country_code": "PRT"
          },
          "death": {
            "date": "2024-01-20",
            "location": null,
            "country_code": "PRT"
          },
          "photo": {
            "url": "https://archive.org/download/bastos_nunes/bastos_nunes.jpg",
            "source": {
              "uri": "https://catalogo.bnportugal.gov.pt/ipac20/ipac.jsp?uri=full=3100024~!97548~!0",
              "cite": "Tele-Judo e Karate-do (revista quinzenal), 1. 1977"
            }
          },
          "teachers": [
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            },
            {
              "id": "JDP-66",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "http://judokai.pt/JUDO%20-%20MANUAL.pdf",
                  "cite": "Judokai: Manual de Formação para Graduaçãoem 1º Dan - Judo (Judo Clube de Sintra - Judokai)",
                  "citation": "Quase na mesma altura [1955] chega a Lisboao Suiço Antony Stryker, 1º Dan,que abre uma sala no Largo do Intendente, onde teve como aluno, entre outros, José Manuel Bastos Nunes."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "FPJ",
              "teacher": null,
              "rank": "9 dan",
              "date": 2019,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "http://www.fpj.pt/wp-content/uploads/2019/12/19ci344-Premiados-na-Gala-do-60%C2%BA-Anivers%C3%A1rio-da-FPJ.pdf"
            },
            {
              "uri": "https://judolandia.tripod.com/bastosnunes.htm"
            },
            {
              "uri": "https://judomagazine.pt/2024/01/22/jose-manuel-bastos-nunes-uma-despedida-suave/"
            },
            {
              "uri": "https://www.abola.pt/mais-desporto/noticias/faleceu-jose-bastos-nunes-2024012118301165539"
            }
          ],
          "source_yaml": "database/persons/PRT/Basto_Nunes.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-127",
          "name": "Augusto de Oliveira Cordeiro",
          "nationality": [
            "PRT",
            "BRA"
          ],
          "birth": {
            "date": "1920",
            "location": "Guarda",
            "country_code": "PRT"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/augusto-cordeiro-c/Augusto%20Cordeiro%20c.jpg",
            "source": {
              "uri": "https://blogoterohermanny.blogspot.com/2009/09/o-mestre-augusto-cordeiro.html",
              "cite": "O MESTRE AUGUSTO CORDEIRO (Rudolf Hermanny)"
            }
          },
          "teachers": [
            {
              "id": "JDP-126",
              "style_id": "JDP-S-1",
              "place": "Budokan (SP)",
              "period": {
                "start": "1950",
                "end": null
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://blogoterohermanny.blogspot.com/2009/09/o-mestre-augusto-cordeiro.html",
                  "cite": "Rudolf Hermanny's Blog",
                  "citation": "ao estabelecer contato com a Associação Budokan do Prof. Riuzo Ogawa se apaixonou pelo magnífico Judô que ali se ensinava e praticava. Após uma temporada residindo em casa do mestre e praticando com seus alunos, o Prof. Cordeiro adotou a nova metodologia e a forma de competição oficial do judô"
                },
                {
                  "uri": "https://revistabudo.com.br/georges-mehdi-e-rudolf-hermanny-uma-historia-que-transcende-o-tempo-e-os-tatamis/",
                  "cite": "Revista Budô",
                  "citation": "discípulo direto do mestre japonês Ryuzo Ogawa"
                },
                {
                  "uri": "https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php",
                  "cite": "Maçaneiro (2024)",
                  "location": "pp. 91-92",
                  "citation": "Cordeiro continuou a procurar pelo judô e, no início da década de 1950, chegou à um acordo com Ryuzo Ogawa, tornando-se sua primeira filial no Rio de Janeiro"
                }
              ]
            },
            {
              "id": "JDP-105",
              "style_id": "JDP-S-1",
              "place": "Rio de Janeiro",
              "period": {
                "start": "1937",
                "end": "1948"
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php",
                  "cite": "MAÇANEIRO, Gustavo Goulart Braga. Desenvolvimento organizacional do judô brasileiro. São Paulo : Escola de Educação Física e Esporte, Universidade de São Paulo, 2024. Dissertação de Mestrado em Estudos Socioculturais e Comportamentais da Educação Física e Esporte",
                  "location": "p. 91",
                  "citation": "em 1944 a ACM promoveu competições e graduações (...) Por esse período é que Takeo Yano foi responsável pela graduação de professores no Rio de Janeiro e, dentre eles, aquele que se tornou, anos mais tarde, o primeiro presidente da CBJ, Augusto Cordeiro"
                },
                {
                  "uri": "https://memoria.bn.gov.br/DocReader/DocReader.aspx?bib=221961_03&&pasta=ano%20195&pagfis=59293",
                  "cite": "Diario da Noite",
                  "location": "Ed. 06066, 11 de Dezembro de 1957, p. 3",
                  "citation": "Corria o ano de 1937 e tratei de inscrever o meu nome entre os alunos do professor Takeo Yama [sic], que afinal de contas, funcionou como o meu descobridor"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Federação Guanabarina de Judô",
              "rank": "5 dan",
              "date": "1963",
              "sources": [
                {
                  "uri": "https://judotradicionalgoshinjutsukan.blogspot.com/2009/04/",
                  "cite": "O JUDÔ NO RIO DE JANEIRO (Wanderley, 2001)",
                  "citation": "Boletim Informativo nº 1, de 1963... Prof. Cordeiro - 5º dan"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://blogoterohermanny.blogspot.com/2009/09/o-mestre-augusto-cordeiro.html"
            },
            {
              "uri": "https://pt.wikipedia.org/wiki/Jud%C3%B4_do_Brasil"
            },
            {
              "uri": "https://revistabudo.com.br/georges-mehdi-e-rudolf-hermanny-uma-historia-que-transcende-o-tempo-e-os-tatamis/"
            },
            {
              "uri": "https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php"
            },
            {
              "uri": "https://judotradicionalgoshinjutsukan.blogspot.com/2009/04/"
            }
          ],
          "source_yaml": "database/persons/PRT/Augusto_Cordeiro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-76",
          "name": "Armando Gonçalves",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/armando_goncalves/armando_goncalves.png",
            "source": {
              "uri": "http://id.bnportugal.gov.pt/bib/catbnp/735884",
              "cite": "GONÇALVES, Armando. Opiniões do meu amigo Fabrício: crónicas acêrca da Educação Física e dos Desportos. 1942."
            }
          },
          "teachers": [
            {
              "id": "JDP-77",
              "style_id": "JDP-S-14",
              "place": null,
              "quality": 2,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "http://id.bnportugal.gov.pt/bib/catbnp/732683",
                  "cite": "GONÇALVES, Armando; O fraco vence o forte. 1941",
                  "citation": "Ex-discípulo do Professor japonês, Hirano (...) O nosso saudoso ex-professor Hirano não tinha admiração nenhuma pelo sistema Kano"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://judolandia.tripod.com/histport.htm"
            },
            {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html"
            },
            {
              "uri": "https://www.fjjdap.pt/jujitsu/"
            },
            {
              "uri": "https://www.ungoshin.pt/correa-pereira-historia-budo"
            },
            {
              "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf"
            }
          ],
          "source_yaml": "database/persons/PRT/Armando_Gonçalves.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-61",
          "name": "António Roquette de Andrade",
          "aka": [
            {
              "name": "António Roquette"
            },
            {
              "name": "António Roquete"
            },
            {
              "name": "Tona"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1955-05-26",
            "location": "Estoril",
            "country_code": "PRT"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/tona1980/tona1980.jpg",
            "source": {
              "uri": "https://fcmjudo.pt/moscovo.html",
              "cite": "Diário de Lisboa, 1980 (in: FCM Judo)"
            }
          },
          "teachers": [
            {
              "id": "JDP-15",
              "style_id": "JDP-S-1",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.ahbe.pt/portfolio-item/judo/",
                  "cite": "A História Do Judo na AHBE",
                  "citation": "O professor Costa Matos leccionou Judo na AHBE entre 1970 e 1976, altura em que, por motivos de saúde, foi substituído pelo seu melhor aluno, o professor António Roquete de Andrade, o qual assumiu definitivamente o cargo de treinador principal da AHBE em 1977, após ter participado como atleta nos Jogos Olímpicos de MONTREAL em 1976."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Federação Portuguesa de Judo",
              "teacher": null,
              "rank": "7 dan",
              "date": 2009,
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/03/20ci057-Relat%C3%B3rio-de-Atividades-e-Contas-do-Exerc%C3%ADcio-de-2019_.pdf",
                  "cite": "Relatório de Atividades e Contas, 2019. FPJ",
                  "citation": "Os Diplomas de 7.º Dan foram atribuídos aos Mestres António Roquete de Andrade, Artur Alves da Mata, José Pinto Farias, Nelson Trindade e Frygyes Torok. O de 8.º Dan ao Mestre Henrique Nunes"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judolandia.tripod.com/roquete.htm"
            },
            {
              "uri": "https://www.olympedia.org/athletes/34295"
            },
            {
              "uri": "https://judomagazine.pt/2023/04/30/entrevista-fernando-costa-matos-um-velejador-navegador-de-judogi/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q20973014",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Ant%C3%B3nio_Roquete_(judoka)",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/PRT/António_Roquette.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-83",
          "name": "António Corrêa Pereira",
          "aka": [
            {
              "name": "António Hilmar Schalck Corrêa Pereira"
            },
            {
              "name": "António Correia Pereira"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/correapereira3/correapereira3.jpg",
            "source": {
              "uri": "https://www.ubu.pt/home/professores/p1/https://www.ubu.pt/home/professores/dr-luis-franco-pires-martins/",
              "cite": "Mestre António Corrêa Pereira (1906-1982) -UBU"
            }
          },
          "teachers": [
            {
              "id": "JDP-109",
              "style_id": "JDP-S-14",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "1 dan",
              "date": "1963-09-10",
              "sources": [
                {
                  "uri": "https://repositorio.ipv.pt/handle/10400.19/448",
                  "cite": "FIGUEIREDO, Abel Aurélio Abreu. A institucionalização do karaté-os modelos organizacionais do karaté em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)",
                  "citation": "Mas o arranque institucional que mais influenciará a história do Karaté está na Academia de Judo, propriedade de António Corrêa Pereira, no 3º andar, do n.º 140, da Rua de S. Paulo, em Lisboa. Além de ser o primeiro cinto negro inscrito no Kodokan (Japão) (...) António LIMA retira dos estatutos respectivos a referência de que, em 23 de Fevereiro de 1958, Corrêa Pereira funda a Academia de Budo, sendo «o primeiro Português a possuir a graduação de cinto negro conferida na Alemanha» (LIMA, 1990, p. 121)"
                },
                {
                  "uri": "https://www.ubu.pt/home/arquivo-fotografico/correapereirakodokan/",
                  "citation": "Diploma do Kodokan, atribuido ao Mestre Corrêa Pereira [1 dan / 3-III-1958 / Risei Kano]"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.ubu.pt/home/professores/p1/"
            },
            {
              "uri": "https://www.ubu.pt/home/historia/"
            },
            {
              "uri": "https://judolandia.tripod.com/histport.htm"
            }
          ],
          "notes": "As relações de aprendizagem entre os membros fundadores da UBU não\nsão claras, provavelmente apenas por não serem tópico que é\nexpressamente dito nas fontes, mas também provavelmente pela\ndinâmica de grande voluntarismo e inovação que caracterizam uma\norganização que foi pioneira. Uma leitura transversal das várias\nfontes apontam para relações de aprendizagem mútua, com posterior\nvalidação/homologação em alguns casos (como no do Karate).  Assim,\na identificação das relações aluno/professor provavelmente\ndemonstrarão uma relação em rede, sendo que a figura de Corrêa\nPereira se apresenta como agregadora, mesmo não sendo na maior\nparte das vezes claro a influência directa (em termos de treino)\nque existiu, em especial a partir do final dos anos 50.  Isto é\nparticularmente aplicável ao Judo (e jujutsu), visto que para o\nAikido e Karate a evolução posterior na UBU permitem leituras mais\nconcretas. Sobre o Judo, antes de Shirooka não é claro quem faz a\ninstrução, assumindo-se que Corrêa Pereira é uma das fontes (e.g.,\na demonstração com Sebastião Durão). O 1º dan Kodokan é dado como\natribuido na Alemanha (Figueiredo 2006), em entrevista Luis\nAntunes indica que Corrêa Pereira treinou Jujutsu em Berlim com\nEric Rahm.\n",
          "source_yaml": "database/persons/PRT/Antonio_Correa_Pereira.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-67",
          "name": "Alexandre Gueifão",
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1940-12-07",
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/alexandre_gueifao/alexandre_gueifao.png",
            "source": {
              "uri": "https://www.bushidoespadaepena.com/entrevistas",
              "cite": "Bushido: a Espada e a Pena"
            }
          },
          "teachers": [
            {
              "id": "JDP-66",
              "style_id": "JDP-S-1",
              "place": "Judokai de Lisboa",
              "quality": 3,
              "period": {
                "start": 1958,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf",
                  "cite": "Gueifão, Alexandre, «À volta de Homens com sério Código de Honra», in «A Génese do Karate em Portugal»",
                  "citation": "Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orientação de Tony Stricker e H. Bouchend-Homme da Organização Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."
                }
              ]
            },
            {
              "id": "JDP-68",
              "style_id": "JDP-S-1",
              "place": "Judokai de Lisboa",
              "quality": 3,
              "period": {
                "start": 1958,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf",
                  "cite": "Gueifão, Alexandre, «À volta de Homens com sério Código de Honra», in «A Génese do Karate em Portugal»",
                  "citation": "Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orientação de Tony Stricker e H. Bouchend-Homme da Organização Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."
                }
              ]
            },
            {
              "id": "JDP-82",
              "style_id": "JDP-S-5",
              "place": "Academia de Budo",
              "quality": 3,
              "period": {
                "start": 1964,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.suishinkan.com.pt/biografia.html",
                  "citation": "Foi co-introdutor da prática do Karate em Portugal na Academia de Budo, em Lisboa, onde começou a praticar em 1964 sob a orientação do seu primeiro Mestre de Karate-Do - Mestre Pires Martins da UBU"
                }
              ]
            },
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": 3,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf",
                  "cite": "Gueifão, Alexandre, «À volta de Homens com sério Código de Honra», in «A Génese do Karate em Portugal»",
                  "citation": "Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orientação de Tony Stricker e H. Bouchend-Homme da Organização Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."
                }
              ]
            },
            {
              "id": "JDP-94",
              "style_id": "JDP-S-5",
              "place": null,
              "quality": 2,
              "period": {
                "start": 1969,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.suishinkan.com.pt/biografia.html",
                  "citation": "O seu segundo Mestre foi Tetsuji Murakami Sensei, de quem foi aluno desde 1969, data que marca o nascimento efectivo da prática do estilo Shotokai em Portugal com a realização do primeiro estágio de Mestre Murakami."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "UBU",
              "teacher": null,
              "rank": "1 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.suishinkan.com.pt/biografia.html",
                  "citation": "Graduação de 1º. Dan de Judo certificada pela UBU."
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.suishinkan.com.pt/biografia.html"
            },
            {
              "uri": "https://www.ubu.pt/home/professores/mestre-alexandre-gueifao/"
            },
            {
              "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf"
            },
            {
              "uri": "https://www.youtube.com/watch?v=BkBldZFIcBY"
            }
          ],
          "source_yaml": "database/persons/PRT/Alexandre_Gueifão.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-65",
          "name": "Afonso Henriques Maia de Loureiro",
          "aka": [
            {
              "name": "Afonso Henriques Ivens-Ferraz Maia de Loureiro"
            }
          ],
          "nationality": [
            "PRT"
          ],
          "birth": {
            "date": "1917-06-27",
            "location": "Ilha de Moçambique",
            "country_code": "MOZ"
          },
          "death": {
            "date": "1999-11-08",
            "location": "Lisboa",
            "country_code": "PRT"
          },
          "photo": {
            "url": "https://archive.org/download/maialoureiro-1/Maialoureiro1.gif",
            "source": {
              "uri": "https://www.fcmjudo.pt/Socioshonorarios.html",
              "cite": "Sócios Honorários da F.P. Judo"
            }
          },
          "teachers": [
            {
              "id": "JDP-66",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": 3,
              "period": {
                "start": 1954,
                "end": 1958
              },
              "sources": [
                {
                  "uri": "https://judolandia.tripod.com/histport.htm",
                  "cite": "História do Judo em Portugal (Judolândia, texto de «Judo: da iniciação à competição», Costa Branco et. al",
                  "citation": "Quase na mesma altura chega a Lisboa Antony Striker (Suíço) 1º Dan, o qual abre uma sala no Largo do Intendente, onde despontaram para o Judo, entre outros, Afonso Maia de Loureiro, Vasco de Sousa e José Manuel Bastos Nunes."
                },
                {
                  "uri": "https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=243",
                  "cite": "Seis histórias à volta do Tatami _ Gala 60º Aniversário FPJ",
                  "citation": "Em 1954. O professor era um tal belga, Anton Stricker, que era segurança do Reino Belga"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "FPJ",
              "teacher": null,
              "rank": "3 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
                  "cite": "Relatório de Atividades e Contas do Exercício de 2019",
                  "citation": "Afonso Henriques I. F. Maia de Loureiro (3º Dan)"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judolandia.tripod.com/histport.htm"
            },
            {
              "uri": "https://www.fcmjudo.pt/Socioshonorarios.html"
            },
            {
              "uri": "https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=243"
            }
          ],
          "source_yaml": "database/persons/PRT/Afonso_Maia_de_Loureiro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-9",
          "name": "Yokoyama Sakujiro",
          "native_name": {
            "name": "横山 作次郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1864,
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "death": {
            "date": "1912-09-23",
            "location": null,
            "country_code": "JPN"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Yokoyama-Sakujiro.jpg/220px-Yokoyama-Sakujiro.jpg",
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1886,
                "end": null
              }
            },
            {
              "id": "JDP-10",
              "style_id": "JDP-S-3",
              "place": "Yushima Tenjin dojo",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E6%A8%AA%E5%B1%B1%E4%BD%9C%E6%AC%A1%E9%83%8E"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Kan%C5%8D_Jigor%C5%8D"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q3276775",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Yokoyama_Sakujiro",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Yokoyama_Sakujiro.yaml",
          "photo_url_local": "images/cache/3326476096b40cabee471bb36cde6755.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-105",
          "name": "Yano Takeo",
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1909",
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": "1988",
            "location": "Belo Horizonte",
            "country_code": "BRA"
          },
          "photo": {
            "url": "https://archive.org/download/yano_20240827/yano.png",
            "source": {
              "uri": "https://simonbjj.com/takeo-yano",
              "cite": "Takeo Yano in a pre-fight publicity photo (Simon BJJ)"
            }
          },
          "teachers": [
            {
              "id": "JDP-43",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://simonbjj.com/takeo-yano",
                  "cite": "The Eastern Demon, Takeo Yano (Simon BJJ)",
                  "citation": "There is not much information known about Takeo Yano, but it is believed he may have been born in 1909 and trained at the Dai Nippon Butoko Kai academy in Kioto under famed Judoka, Hajime Isogai."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Dai Nippon Butoku Kai",
              "teacher": null,
              "rank": "3 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://simonbjj.com/takeo-yano",
                  "cite": "The Eastern Demon, Takeo Yano (Simon BJJ)",
                  "citation": " Yano trained at the academy until he received his 3rd dan and then began travelling internationally."
                },
                {
                  "uri": "https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php",
                  "cite": "MAÇANEIRO, Gustavo Goulart Braga. Desenvolvimento organizacional do judô brasileiro. São Paulo : Escola de Educação Física e Esporte, Universidade de São Paulo, 2024. Dissertação de Mestrado em Estudos Socioculturais e Comportamentais da Educação Física e Esporte",
                  "citation": "A Marinha há muito contratou um japonês, Yano, 3º dan, como instrutor para a prática do judô japonês para os soldados"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Takeo_Yano"
            },
            {
              "uri": "https://simonbjj.com/takeo-yano"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php"
            }
          ],
          "source_yaml": "database/persons/JPN/Yano_Takeo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-95",
          "name": "Yamashita Yoshitsugu",
          "native_name": {
            "name": "山下 義韶",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1865-02-16",
            "location": "Kanazawa",
            "country_code": "JPN"
          },
          "death": {
            "date": "1935-10-26",
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/d/d6/YoshiakiYamashita.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Yamashita_Yoshitsugu#/media/File:YoshiakiYamashita.jpg"
            }
          },
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1884,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.judo-ch.jp/english/legend/yamasita/",
                  "cite": "Kodokan hall of fame: Yoshitsugu Yamashita (Judo Channel)",
                  "citation": "Yoshitsugu Yamashita was the son of an Odawara Han martial arts instructor, and he entered Kodokan in August of 1884."
                },
                {
                  "uri": "https://en.wikipedia.org/wiki/Yamashita_Yoshitsugu",
                  "citation": "In August 1884, he joined the Kodokan judo dojo of his childhood friend Kano Jigoro as its nineteenth member"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "10 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.judo-ch.jp/english/legend/yamasita/",
                  "cite": "Kodokan hall of fame: Yoshitsugu Yamashita (Judo Channel)",
                  "citation": "At the memorial ceremony held at Kodokan, Jigoro Kano posthumously awarded Mr. Yamashita the 10th Dan rank as of October 24th, making Mr. Yamashita the first holder of the Kodokan 10th Dan rank in recognition of his service."
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Yamashita_Yoshitsugu"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%B1%B1%E4%B8%8B%E7%BE%A9%E9%9F%B6"
            },
            {
              "uri": "https://www.judo-ch.jp/english/legend/yamasita/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q3236604",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Yamashita_Yoshitsugu",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Yamashita_Yoshitsugu.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-74",
          "name": "Yamamoto Nobuaki",
          "native_name": {
            "name": null,
            "lang": null
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/yamamoto73_1/yamamoto73_1.jpg",
            "source": {
              "uri": "https://www.fcmjudo.pt/visitantes.html"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://www.fcmjudo.pt/visitantes.html"
            },
            {
              "uri": "https://www.jpn.up.pt/2015/04/21/clube-judo-do-porto-50-anos-continua-jovem/"
            }
          ],
          "source_yaml": "database/persons/JPN/Yamamoto_Nobuaki.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-90",
          "name": "Ushijima Tatsukuma",
          "native_name": {
            "name": "牛島辰熊",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1904-03-10",
            "location": "Kumamoto",
            "country_code": "JPN"
          },
          "death": {
            "date": "1985-05-26",
            "location": null,
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/3/33/Tatsukuma_Ushijima.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Tatsukuma_Ushijima#/media/File:Tatsukuma_Ushijima.jpg",
              "cite": "Tatsukuma Ushijima. (2023, March 12). In Wikipedia. https://en.wikipedia.org/wiki/Tatsukuma_Ushijima"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "9 dan",
              "date": 1984,
              "sources": [
                {
                  "uri": "https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio's_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques",
                  "cite": "De Crée, Carl. (2014). Nanatsu-no-kata, Endō-no-kata, and Jōge-no-kata ―A pedagogical and qualitative biomechanical evaluation of Hirano Tokio’s kuzushi (unbalancing) concept as part of skill acquisition for throwing techniques in Kōdōkan jūdō. Revista de Artes Marciales Asiáticas. 9. 69-96. 10.18002/rama.v9i2.1162.",
                  "citation": "While still at Kyōto, Hirano later also became an uchi deshi to Ushijima Tatsukuma 牛島辰熊 (1904‐1985) (Figure 2), famous for his competitive achievements and who too was a Busen jūdō teacher and future (1984) 9th dan holder"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Tatsukuma_Ushijima"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E7%89%9B%E5%B3%B6%E8%BE%B0%E7%86%8A"
            },
            {
              "uri": "https://judo.forumotion.com/t1770-tatsukuma-ushijima"
            },
            {
              "uri": "https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio's_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q11570129",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Tatsukuma_Ushijima",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Ushijima_Tatsukuma.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-27",
          "name": "Ueshiba Morihei",
          "native_name": {
            "name": "植芝 盛平",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1883-12-14",
            "location": "Tanabe",
            "country_code": "JPN"
          },
          "death": {
            "date": "1969-04-26",
            "location": "Iwama",
            "country_code": "JPN"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/en/thumb/0/0f/Morihei_Ueshiba_Portrait.jpg/220px-Morihei_Ueshiba_Portrait.jpg",
          "teachers": [
            {
              "id": "JDP-28",
              "style_id": "JDP-S-10",
              "place": null,
              "quality": null,
              "period": {
                "start": 1915,
                "end": 1922
              }
            },
            {
              "id": "JDP-47",
              "style_id": "JDP-S-3",
              "place": null,
              "quality": null,
              "period": {
                "start": 1901,
                "end": 1901
              },
              "sources": [
                {
                  "uri": "http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf",
                  "cite": "BUYENS, Guy. Introduction to Traditional martial systems. 2016",
                  "citation": "Iso Mataemon Masatomo had amongst his students Inoue Keitaro and Tozawa Tokusaburo, who were the teachers of Miyamoto Hanzo). Morihei Ueshiba, founder of aikido, studied Tenjin Shinyo-ryu with Tozawa Tokusaburo"
                },
                {
                  "uri": "https://aikidojournal.com/2011/08/27/tokusaburo-tozawa/",
                  "citation": "[Tokusaburo Tozawa]. Teacher of TENJIN SHIN’YO-RYU JUJUTSU in Tokyo in late 1800s and early 1900s. Taught Morihei UESHIBA for brief period in 1901",
                  "events": [
                    "period"
                  ]
                }
              ]
            },
            {
              "id": "JDP-50",
              "style_id": "JDP-S-11",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB",
                  "citation": "Morihei Ueshiba, the founder of Aikido, was a student of Yagyū Shingan-ryū. In 1908, after five years of training, he received the rank of Shoden from Masakatsu Nakai, a Shihan of the Edo-line of Yagyū Shingan-ryū"
                },
                {
                  "uri": "https://aikidojournal.com/2016/09/24/interview-with-morihei-ueshiba-and-kisshomaru-ueshiba/",
                  "citation": "O-Sensei: At about the age of 14 or 15. First I learned Tenshinyo-ryu Jiujitsu from Tokusaburo Tozawa Sensei, then Kito-ryu, Yagyu-ryu, Aioi-ryu, Shinkage-ryu, all of them jujutsu forms."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-10",
              "org": null,
              "teacher": "JDP-28",
              "rank": "Kyōju Dairi",
              "date": 1922,
              "style": "Daitō-ryū Aiki-jūjutsu",
              "style_native": {
                "name": "大東流 合気柔術",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-13",
              "org": null,
              "teacher": "JDP-50",
              "rank": "Shoden",
              "date": 1908,
              "style": "Shuri-te",
              "style_native": {
                "name": "首里手",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Morihei_Ueshiba",
              "events": [
                "name native_name birth death"
              ]
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%AF%8C%E6%9C%A8%E8%AC%99%E6%B2%BB",
              "events": [
                "name native_name birth death"
              ]
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB",
              "events": [
                "rank"
              ]
            },
            {
              "uri": "https://aikidojournal.com/2016/09/24/interview-with-morihei-ueshiba-and-kisshomaru-ueshiba/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q182130",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Morihei_Ueshiba",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Ueshiba_Morihei.yaml",
          "photo_url_local": "images/cache/8443eb7fc742180dd0257abdd1bc1414.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-39",
          "name": "Ueda Heitaro",
          "native_name": {
            "name": "植田平太郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1877-08-14",
            "location": "Ikenishi",
            "country_code": "JPN"
          },
          "death": {
            "date": "1949-07-25",
            "location": null,
            "country_code": null
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/%E5%8D%81%E4%B8%83%E4%BB%A3%E5%AE%97%E5%AE%B6%E6%A4%8D%E7%94%B0%E5%B9%B3%E5%A4%AA%E9%83%8E.png/169px-%E5%8D%81%E4%B8%83%E4%BB%A3%E5%AE%97%E5%AE%B6%E6%A4%8D%E7%94%B0%E5%B9%B3%E5%A4%AA%E9%83%8E.png",
          "teachers": [
            {
              "id": "JDP-60",
              "style_id": "JDP-S-8",
              "place": "Bujutsu Kyoin Yoseijo",
              "quality": 3,
              "period": {
                "start": 1905,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://kenshi247.net/blog/2022/01/24/the-iron-will-of-the-kendo-god-ueda-heitaro/",
                  "cite": "The iron will of the kendo god Ueda Heitaro - Kenshi 24/7",
                  "citation": "At the Yoseijo he was there as a koshusei or a part-time student there to learn kendo only (full time students also did academic study). There he studied directly under Naito Takaharu and crossed shinai with the likes of Saimura, Nakano, Oshima, and Shimatani (this was slightly before Mochida, Ogawa, Miyazaki, and Oasa, etc arrived). "
                }
              ]
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://kenshi247.net/blog/2022/01/24/the-iron-will-of-the-kendo-god-ueda-heitaro/"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E6%A4%8D%E7%94%B0%E5%B9%B3%E5%A4%AA%E9%83%8E"
            }
          ],
          "source_yaml": "database/persons/JPN/Ueda_Heitaro.yaml",
          "photo_url_local": "images/cache/dedfe9883a7b4ce53c0e4aa65e674a05.png"
        }
      },
      {
        "data": {
          "id": "JDP-48",
          "name": "Uchida Ryōhei",
          "native_name": {
            "name": "内田良平",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1873-02-11",
            "location": "Fukuoka",
            "country_code": "JPN"
          },
          "death": {
            "date": "1937-07-26",
            "location": null,
            "country_code": "JPN"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Ryohei_Uchida_Close-up.jpg/200px-Ryohei_Uchida_Close-up.jpg",
          "description": {
            "en": "Ryōhei Uchida (内田 良平, Uchida Ryōhei, 11 February 1873 – 26 July 1937) was a Japanese ultranationalist political theorist, Pan-Asianist, and martial artist, active in the pre-war Empire of Japan. He was also an accomplished jūdōka, a favorite of Kanō shihan 師範 (master), one of the three most senior 5th dan rank holders in Kodokan history, and a noted street brawler.  He was the son of Shinto Muso-ryu practitioner Uchida Ryōgorō, and from an early age was interested in many forms of Japanese traditional martial arts, including kyūdō, kendo, judo and sumo.\n",
            "ja": "内田 良平（うちだ りょうへい、1874年〈明治7年〉2月11日 - 1937年 〈昭和12年〉7月26日）は、日本の国家主義者・右翼運動家・アジア主 義者。黒龍会主幹、大日本生産党総裁。 旧福岡藩士であり、武芸の達 人として知られた内田良五郎の三男として現在の福岡県福岡市大円寺町 （現・唐人町）に生まれる[1]。幼名良助、のち甲（きのえ）。明治34 年（1902年）に良平と改名した。幼時より弓道、剣道、柔術、相撲、射 撃を父に学んだ。なお、父・良五郎の神道夢想流杖術の門下には、[2] 「昭和の剣聖」の一人である中山博道がいる。\n"
          },
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1893,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.researchgate.net/publication/277665808_Kodokan_Judo's_three_orphaned_forms_of_counter_techniques_-_Part_1_The_gonosen-no-kata_-_Forms_of_post-attack_initiative_counter_throws",
                  "citation": "Miyakawa remained a Gen’yōshamember and became a Kōdōkan top-executive (Kōdōkan Saikō  Kanbu講道館最高幹部)  closely  associated  with Kanō Jigorō, as was Uchida Ryōhei"
                },
                {
                  "uri": "https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/",
                  "citation": "He was also an accomplished jūdōka, a favorite of Kanō shihan 師範 (master), one of the three most senior 5th dan rank holders in Kodokan history, and a noted street brawler."
                }
              ],
              "quality": 1
            },
            {
              "id": "JDP-49",
              "style_id": "JDP-S-12",
              "place": "Meikokan dojo",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/",
                  "citation": "宮川太一郎嘉永元年（1848）生正林又七郎の高弟・免許皆伝代々黒田家の臣である。一万流剣術，自剛天真流組討を極め，明治10年(1877) 11月玄洋社附属の向浜塾で自聞天真流を教授したのが，後の明道館道場の起源とされている。"
                },
                {
                  "uri": "https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/",
                  "citation": "He learned a number of martial arts, most notably Jigō Tenshin Ryū Jūjutsu in Fukuoka’s Meidokan dōjō, an art in which he was notably successful. In 1893 he moved to Tokyo to live with his wealthy coal mine owner uncle Hiraoka Kōtarō, a supporter of the Genyōsha, and began to study Russian at a Tokyo school and jūdō at Kanō Jigorō’s Kodokan."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "5 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/",
              "events": [
                "name",
                "native_name",
                "birth",
                "death",
                "rank"
              ]
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Ry%C5%8Dhei_Uchida",
              "events": [
                "name",
                "native_name",
                "birth",
                "death"
              ]
            }
          ],
          "tags": [
            "Kokuryūkai",
            "Genyōsha",
            "Omoto"
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q120662",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Ry%C5%8Dhei_Uchida",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Uchida_Ryohei.yaml",
          "photo_url_local": "images/cache/02cd85debf9ee87b78b2972ea0f4abfc.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-47",
          "name": "Tozawa Tokusaburo",
          "native_name": {
            "name": "戸沢徳三郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1848,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": 1912,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": "JDP-4",
              "style_id": "JDP-S-3",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "http://www.tenyokai.com/booklet.php",
                  "citation": "Geneology of Tenjin Shinyo Ryu Jujutsu: (...) Iso Matauemon Masatomo -> Tozawa Tokusaburo"
                },
                {
                  "uri": "http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf",
                  "citation": "Iso Mataemon Masatomo had amongst his students Inoue Keitaro and Tozawa Tokusaburo, who were the teachers of Miyamoto Hanzo). Morihei Ueshiba, founder of aikido, studied Tenjin Shinyo-ryu with Tozawa Tokusaburo"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://aikidojournal.com/2011/08/27/tokusaburo-tozawa/",
              "events": [
                "name",
                "native_name",
                "birth",
                "death"
              ]
            },
            {
              "uri": "https://www.google.pt/books/edition/Koryu_Bujutsu/ZNetk-lJ_O4C"
            },
            {
              "uri": "http://www.tenyokai.com/booklet.php"
            },
            {
              "uri": "http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf"
            }
          ],
          "source_yaml": "database/persons/JPN/Tozawa_Tokusaburo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-17",
          "name": "Tomita Tsunejirō",
          "native_name": {
            "name": "富田 常次郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1864-02-28",
            "location": "Namazu, Shizuoka",
            "country_code": "JPN"
          },
          "death": {
            "date": "1937-01-13",
            "location": null,
            "country_code": null
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Tomita-Tsunejiro.jpg/454px-Tomita-Tsunejiro.jpg",
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1882,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "7 dan",
              "date": 1937,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%AF%8C%E7%94%B0%E5%B8%B8%E6%AC%A1%E9%83%8E"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q2672426",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Tomita_Tsunejir%C5%8D",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Tomita_Tsunejiro.yaml",
          "photo_url_local": "images/cache/f2ca4e8be5ae3fb80bbca86e4bd3b51c.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-71",
          "name": "Tomita Takeji",
          "native_name": {
            "name": "斉藤 守弘",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1928-03-31",
            "location": "Ibaraki",
            "country_code": "JPN"
          },
          "death": {
            "date": "2002-05-13",
            "location": "Iwama",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://archive.org/download/takeji_tomita/takeji_tomita.png",
            "source": {
              "uri": "https://www.aikidojournal.eu/docs/238/393_946_en.pdf",
              "cite": "TAKEJI TOMITA: From studying with O-Sensei to the creation of Aïki Shin Myo Den (Aikido Journal)"
            }
          },
          "teachers": [
            {
              "id": "JDP-70",
              "style_id": "JDP-S-4",
              "place": "Iwama Dōjō",
              "quality": null,
              "period": {
                "start": 1962,
                "end": 1
              },
              "sources": [
                {
                  "uri": "https://www.aikidojournal.eu/docs/238/393_946_en.pdf",
                  "cite": "TAKEJI TOMITA: From studying with O-Sensei to the creation of Aïki Shin Myo Den (Aikido Journal)",
                  "citation": "From 1962 on, after his first visit in Iwama, he decides to follow the teaching of O'Sensei and of his assistant, Morihiro Saito Sensei (...) In 1968, he becomes Morihiro Saito's Uchideshi and is rapidly adopted by the Master's family (...) Tomita Sensei practiced for about 7 years at the Iwama Dojo. Those years were for him formativeyears dedicated to education and to discovering the way of Budo."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": "Aikikai",
              "teacher": null,
              "rank": "8 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.aikidojournal.eu/docs/238/393_946_en.pdf",
                  "cite": "TAKEJI TOMITA: From studying with O-Sensei to the creation of Aïki Shin Myo Den (Aikido Journal)",
                  "citation": "Today an 8th Dan, Tomita Sensei still lives in Stockholm."
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.takemusuaiki.eu/master/"
            },
            {
              "uri": "https://www.aikidojournal.eu/docs/238/393_946_en.pdf"
            },
            {
              "uri": "https://aikidojournal.com/2011/08/27/takeji-tomita/"
            },
            {
              "uri": "https://takemusuaikichel.ru/en/tomita-sensei/"
            }
          ],
          "source_yaml": "database/persons/JPN/Tomita_Takeji.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-26",
          "name": "Tomiki Kenji",
          "native_name": {
            "name": "富木 謙治",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1900-03-15",
            "location": "Yokomachi",
            "country_code": "JPN"
          },
          "death": {
            "date": "1979-12-25",
            "location": null,
            "country_code": null
          },
          "photo_url": "https://3.bp.blogspot.com/_Cwm1bGlUfkA/R7R9fVsP72I/AAAAAAAAANg/NjJTk4KTUqg/s400/tomiki_10.jpg",
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": null,
              "quality": null,
              "period": {
                "start": 1895,
                "end": 1896
              }
            },
            {
              "id": "JDP-27",
              "style_id": "JDP-S-4",
              "place": null,
              "quality": null,
              "period": {
                "start": 1926,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "8 dan",
              "date": 1971,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-4",
              "org": null,
              "teacher": "JDP-27",
              "rank": "8 dan",
              "date": 1971,
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Kenji_Tomiki"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%AF%8C%E6%9C%A8%E8%AC%99%E6%B2%BB"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q6389379",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Kenji_Tomiki",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Tomiki_Kenji.yaml",
          "photo_url_local": "images/cache/01597240280937ae594546b0b42191db.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-32",
          "name": "Tamai Narimichi",
          "native_name": {
            "name": null,
            "lang": null
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2"
            }
          ],
          "source_yaml": "database/persons/JPN/Tamai_Narimichi.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-8",
          "name": "Takino Yūken",
          "native_name": {
            "name": "滝野遊軒",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1659,
            "location": "Tamba",
            "country_code": "JPN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": null,
              "style": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E8%B5%B7%E5%80%92%E6%B5%81"
            },
            {
              "uri": "https://doi.org/10.18002/rama.v13i2.5700"
            },
            {
              "uri": "https://www.ryoishintokai.com/2022/03/24/1819/",
              "events": [
                "birth"
              ]
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q11565323",
              "cite": "Wikidata"
            }
          ],
          "source_yaml": "database/persons/JPN/Takino_Yūken.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-6",
          "name": "Takenaka Tetsunosuke Issei",
          "native_name": {
            "name": "竹中鉄之助一清",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1800,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": "JDP-7",
              "style_id": "JDP-S-2",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E8%B5%B7%E5%80%92%E6%B5%81"
            },
            {
              "uri": "https://doi.org/10.18002/rama.v13i2.5700"
            }
          ],
          "source_yaml": "database/persons/JPN/Takenaka_Tetsunosuke.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-7",
          "name": "Takenaka  Motonoshin",
          "native_name": {
            "name": "竹中元之進",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1775,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": "JDP-8",
              "style_id": "JDP-S-2",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E8%B5%B7%E5%80%92%E6%B5%81"
            },
            {
              "uri": "https://doi.org/10.18002/rama.v13i2.5700"
            }
          ],
          "source_yaml": "database/persons/JPN/Takenaka_Motonoshin.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-28",
          "name": "Takeda Sōkaku",
          "native_name": {
            "name": "武田 惣角",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1859-10-10",
            "location": "Aizu",
            "country_code": "JPN"
          },
          "death": {
            "date": "1943-04-25",
            "location": null,
            "country_code": "JPN"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Takeda_Sokaku.jpg/220px-Takeda_Sokaku.jpg",
          "teachers": [
            {
              "name": null,
              "style": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": "Daitō-ryū Aiki-jūjutsu",
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%AF%8C%E6%9C%A8%E8%AC%99%E6%B2%BB"
            },
            {
              "uri": "https://aikidojournal.com/2011/09/02/interview-with-kenji-tomiki-1-2/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q503880",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Takeda_S%C5%8Dkaku",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Takeda_Sokaku.yaml",
          "photo_url_local": "images/cache/88929a754386f464b40986a0ba0da928.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-14",
          "name": "Takahashi Kazuyoshi",
          "native_name": {
            "name": "高橋数良",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1855,
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": 1942,
            "location": null,
            "country_code": null
          },
          "description": null,
          "photo_url": null,
          "teachers": [
            {
              "id": "JDP-9",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "8 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.researchgate.net/publication/277665808_Kodokan_Judo's_three_orphaned_forms_of_counter_techniques_-_Part_1_The_gonosen-no-kata_-_Forms_of_post-attack_initiative_counter_throws"
            }
          ],
          "source_yaml": "database/persons/JPN/Takahashi_Kazuyoshi.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-30",
          "name": "Sugino Yoshio",
          "native_name": {
            "name": "杉野嘉男",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1904-12-12",
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "death": {
            "date": "1998-06-13",
            "location": "Narutō, Chiba",
            "country_code": "JPN"
          },
          "photo_url": "https://2.bp.blogspot.com/-y8nNNMaK3cs/VLvcojO-fRI/AAAAAAAAbOM/HzykaZ2XkJw/s1600/Yoshio%2BSugino.jpg",
          "teachers": [
            {
              "id": "JDP-31",
              "style_id": "JDP-S-1",
              "place": "Keiō Gijuku Daigaku",
              "period": {
                "start": 1918,
                "end": 1919
              },
              "quality": 2
            },
            {
              "id": "JDP-27",
              "style_id": "JDP-S-4",
              "place": "Wakamatsu-cho dojo",
              "period": {
                "start": 1931,
                "end": 1935
              },
              "quality": 2
            },
            {
              "id": "JDP-32",
              "style_id": "JDP-S-6",
              "place": "Kawasaki",
              "period": {
                "start": 1927,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-33",
              "style_id": "JDP-S-6",
              "place": "Kawasaki",
              "period": {
                "start": 1927,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-34",
              "style_id": "JDP-S-6",
              "place": "Kawasaki",
              "period": {
                "start": 1927,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-35",
              "style_id": "JDP-S-6",
              "place": "Kawasaki",
              "period": {
                "start": 1927,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-36",
              "style_id": "JDP-S-7",
              "place": null,
              "period": {
                "start": 1928,
                "end": null
              },
              "quality": 1
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E6%9D%89%E9%87%8E%E5%98%89%E7%94%B7"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Yoshio_Sugino"
            },
            {
              "uri": "https://ejmas.com/jcs/jcsart_svinth_0702.htm"
            },
            {
              "uri": "https://www.judo-ch.jp/english/legend/iizuka/"
            },
            {
              "uri": "https://www.aikidosangenkai.org/blog/interview-yoshio-sugino-katori-shinto/"
            },
            {
              "uri": "https://aikidojournal.com/2018/10/08/the-last-swordsman-the-yoshio-sugino-story-part-1/"
            },
            {
              "uri": "https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2/"
            },
            {
              "uri": "https://web.archive.org/web/20111204190328/http://www.aikidojournal.com/article.php?articleID=3"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q8056250",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Yoshio_Sugino",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Sugino_Yoshio.yaml",
          "photo_url_local": "images/cache/204acc1061913636de7a1118afce89fe.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-40",
          "name": "Shingai Tadaatsu",
          "native_name": {
            "name": "真貝忠篤",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1842-03-01",
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": "1920-02-09",
            "location": null,
            "country_code": "JPN"
          },
          "photo_url": null,
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E7%9C%9F%E8%B2%9D%E5%BF%A0%E7%AF%A4"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Kenjutsu"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Tamiya-ry%C5%AB_(Tsumaki)"
            }
          ],
          "source_yaml": "database/persons/JPN/Shingai_Tadaatsu.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-35",
          "name": "Shiina Ichizo",
          "native_name": {
            "name": "椎名市蔵",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "teachers": [
            {
              "id": "JDP-116",
              "style_id": "JDP-S-6",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
                  "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
                  "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô"
                }
              ]
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2"
            },
            {
              "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E8%AC%9B%E9%81%93%E9%A4%A8"
            }
          ],
          "source_yaml": "database/persons/JPN/Shiina_Ichizo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-22",
          "name": "Satake Soshihiro",
          "aka": [
            {
              "name": "Antônio Satake"
            },
            {
              "name": "Nobushiro Satake"
            }
          ],
          "nationality": [
            "JPN",
            "BRA"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": "https://2.bp.blogspot.com/_NjSHIRBuf3Y/S84w0kJnWrI/AAAAAAAABrg/eFg_AlSH4Cw/s1600/Nobushiro_Satake.jpg",
          "teachers": [
            {
              "id": "JDP-9",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1892,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://simonbjj.com/satake",
                  "cite": "The Sumo wrestle who taught BJJ, Soshiro Satake",
                  "citation": "At some point later, probably in the late 1890’s, he joined the Kodokan and would become peers of Mitsuyo Maeda. The two judoka trained together under Sakujiro Yokoyama, who was known as one of the Four Guardians of the Kodokan"
                },
                {
                  "uri": "https://ja.wikipedia.org/wiki/%E4%BD%90%E7%AB%B9%E4%BF%A1%E5%9B%9B%E9%83%8E",
                  "citation": "1892年（明治25年）5月に講道館に入門"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "3 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Soshihiro_Satake"
            },
            {
              "uri": "https://repositorio.ufsc.br/handle/123456789/103771"
            },
            {
              "uri": "https://web.archive.org/web/20240507104820/https://www.faddabjj.com/historia-fadda"
            },
            {
              "uri": "http://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"
            }
          ],
          "source_yaml": "database/persons/JPN/Satake_Soshihiro.yaml",
          "photo_url_local": "images/cache/5a789699a4256fc5c95059913972a8fd.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-70",
          "name": "Saitō Morihiro",
          "native_name": {
            "name": "斉藤 守弘",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1928-03-31",
            "location": "Ibaraki",
            "country_code": "JPN"
          },
          "death": {
            "date": "2002-05-13",
            "location": "Iwama",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://archive.org/download/morihiro-saito_formal/morihiro-saito_formal.jpg",
            "source": {
              "uri": "https://aikidojournal.com/2003/02/28/interview-with-morihiro-saito-part-1-1987/",
              "cite": "Interview with Morihiro Saito - Part 1 (Aikido Journal)"
            }
          },
          "description": {
            "en": "Morihiro Saito (斉藤 守弘 Saitō Morihiro) was a teacher of the Japanese martial art of aikido, with many students around the world. Saito's practice of aikido spanned 56 years, from the age of 18, when he first met aikido founder Morihei Ueshiba, until his death in 2002.  The kind of aikido that Saito's students do is often referred to as Iwama aikido or Iwama style. In Europe, Saito, along with many of his students, formed a dan-ranking network of dojos called Iwama Ryu, with ranks received directly from Saito rather than or in addition to those from the Aikikai although Saito never left that organization.\n"
          },
          "teachers": [
            {
              "id": "JDP-27",
              "style_id": "JDP-S-4",
              "place": "Iwama Dōjō",
              "quality": null,
              "period": {
                "start": 1946,
                "end": 1969
              },
              "sources": [
                {
                  "uri": "https://en.wikipedia.org/wiki/Morihiro_Saito",
                  "citation": "It was at this time, at the age of 18, that Saito joined Ueshiba for training (...) From 1946 until Ueshiba’s passing in 1969, Saito served as Ueshiba's assistant in a variety of ways at Iwama while his wife served Mrs. Ueshiba. During Saito’s period as a deshi he taught classes in the Iwama dojo."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": "Aikikai",
              "teacher": null,
              "rank": "9 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.saitosensei.com/1990s/",
                  "citation": "1992. Mrs. Saito and Saito Sensei in regal formal attire at his huge first party in Iwama’s Kabuki Wedding Palace, celebrating his promotion to 9th dan by Honbu Aikikai and the 50th anniversary of aikido in Iwama"
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://saito-sensei.org/"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Morihiro_Saito"
            },
            {
              "uri": "https://www.saitosensei.com"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q550626",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Morihiro_Saito",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Saito_Morihiro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-121",
          "name": "Saigō Shirō",
          "native_name": {
            "name": "西郷四郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1866-01-04",
            "location": "Aizuwakamatsu, Fukushima",
            "country_code": "JPN"
          },
          "death": {
            "date": "1922-12-22",
            "location": "Onomichi",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/f/f6/Saigo_Shirou.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Shiro_Saigo#/media/File:Saigo-Shiro.jpg",
              "cite": "Saigo Shiro, Wikimedia Commons"
            }
          },
          "description": {
            "en": "Shiro Saigo (西郷四郎, Saigō Shirō, February 4, 1866 – December 22, 1922) was one of the earliest disciples of Judo. Saigo, together with Tsunejiro Tomita, became first in history of judo to be awarded Shodan by the founder of judo Jigoro Kano, who established the kyu-dan ranking system. He was one of the Kōdōkan Shitennō or Four Guardians of the Kodokan along with Yoshitsugu Yamashita, Sakujiro Yokoyama, and Tsunejiro Tomita.\n"
          },
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1882,
                "end": 1890
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "urn:isbn:1425163491",
                  "cite": "WATSON, Brian N. Judo memoirs of Jigoro Kano. Trafford Publishing, 2008",
                  "location": "p. 20",
                  "citation": "Shortly thereafter, in August 1882, the now famous Shiro Saigo became a student of mine"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": "JPN/Kano_Jigoro",
              "rank": "6 dan",
              "date": "1923-01-14",
              "sources": [
                {
                  "uri": "https://www.judo-ch.jp/english/legend/saigou/",
                  "citation": "January, 1923: 6th Dan (...) Upon receiving news of his death, Jigoro Kano awarded him a posthumous promotion to the 6th Dan on January 14, 1923"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.judo-ch.jp/english/legend/saigou/"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/西郷四郎"
            },
            {
              "uri": "https://judoinfo.com/saigo/"
            }
          ],
          "source_yaml": "database/persons/JPN/Saigo_Shiro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-112",
          "name": "Ōtake Risuke",
          "native_name": {
            "name": "大竹利典",
            "lang": "ja"
          },
          "aka": [
            {
              "name": "Ōtake Risuke Minamoto no Takeyuki"
            },
            {
              "name": "大竹利典源健之",
              "lang": "ja"
            }
          ],
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1926-03-10",
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": "2021-06-07",
            "location": null,
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/7/78/Risuke_%C5%8Ctake.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Risuke_Otake#/media/File:Risuke_%C5%8Ctake.jpg",
              "cite": "Risuke Ōtake, Japanese swordsman (Wikipedia Commons)"
            }
          },
          "teachers": [
            {
              "id": "JDP-113",
              "style_id": "JDP-S-6",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
                  "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
                  "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô (...) Hayashi Saiichirô –> Hayashi Yazaemon –> Ôtake Risuke"
                }
              ]
            }
          ],
          "rank": [
            {
              "style": "JDP-S-6",
              "org": null,
              "teacher": "JDP-113",
              "rank": "Gokui kaiden",
              "date": 1967,
              "sources": [
                {
                  "uri": "https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/",
                  "cite": "Otake Risuke Nippon Budōkan Magazine Interview (Shobukan Dojo)",
                  "citation": "That year, I received the Gokui Kaiden scroll and a proof signifying that I have attained Gokui Sōden from Hayashi-sensei. Sensei told me, “Call yourself Gokui Kaiden once you are 42 years old.” At the time I was 32 years old, so I think it was to be in accordance with the rules of our school."
                },
                {
                  "uri": "https://shinbukan-katorishintoryu.org/?page_id=898&lang=en",
                  "cite": "Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo",
                  "citation": "Shinbukan Dojo’s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."
                }
              ]
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Risuke_Otake"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%A4%A7%E7%AB%B9%E5%88%A9%E5%85%B8"
            },
            {
              "uri": "https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q3433225",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Risuke_Otake",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Otake_Risuke.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-46",
          "name": "Oshima Masateru",
          "native_name": {
            "name": null,
            "lang": null
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://kanochronicles.com/the-kodokan-and-bojutsu-jo-staff-fighting-and-judo/"
            },
            {
              "uri": "https://www.worldcat.org/title/952578913"
            }
          ],
          "source_yaml": "database/persons/JPN/Oshima_Masateru.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-131",
          "name": "Ōsawa Yoshimi",
          "native_name": {
            "name": "大沢 吉己",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1926-03-06",
            "location": "Munakata, Inba District, Chiba Prefecture",
            "country_code": "JPN"
          },
          "death": {
            "date": "2022-10-21",
            "location": "",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/9/96/Yoshimi_%C5%8Csawa.jpg",
            "source": {
              "uri": "https://upload.wikimedia.org/wikipedia/commons/9/96/Yoshimi_%C5%8Csawa.jpg",
              "cite": "Japanese judoka Yoshimi Osawa, pictured here after winning the 4th Tokyo Judoka Championship in 1953 (Wikipedia)"
            }
          },
          "teachers": [
            {
              "id": "JDP-11",
              "style_id": "JDP-S-1",
              "place": "Waseda University Judo Club",
              "period": {
                "start": "1943",
                "end": null
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://ja.wikipedia.org/wiki/%E5%A4%A7%E6%B2%A2%E6%85%B6%E5%B7%B1",
                  "cite": "大沢吉己 - 日本語版ウィキペディア",
                  "citation": "1943年4月に早稲田大学に入学し柔道部に入部すると、師範には三船久蔵や徳三宝らが顔を揃え、月に1度ほどではあったが指導に来てその薫陶を受けた"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "rank": "10 dan",
              "date": "2006",
              "sources": [
                {
                  "uri": "https://judoinfo.com/judan2/",
                  "cite": "Kodokan 10th Dan Promotions - JudoInfo",
                  "citation": "Ichiro Abe (83 years old), Toshiro Daigo (80 years old) and Yoshimi Osawa (79 years old) were promoted to 10th Dan"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Yoshimi_Osawa"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%A4%A7%E6%B2%A2%E6%85%B6%E5%B7%B1"
            },
            {
              "uri": "https://judoinfo.com/judan2/"
            }
          ],
          "source_yaml": "database/persons/JPN/Osawa_Yoshimi.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-103",
          "name": "Geo Omori",
          "native_name": {
            "name": "大森 城司",
            "lang": "ja"
          },
          "aka": [
            "Jyoji Omori"
          ],
          "nationality": [
            "BRA",
            "JPN"
          ],
          "birth": {
            "date": "1898",
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "death": {
            "date": "1938-03-02",
            "location": "Belo Horizonte",
            "country_code": "BRA"
          },
          "photo": {
            "url": "https://archive.org/download/geo-omori/geo-omori.jpg",
            "source": {
              "uri": "https://forum.bjjforum.com.br/",
              "cite": "BJJ Forum"
            }
          },
          "teachers": [
            {
              "id": "JDP-104",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 153",
                  "citation": "Foi discípulo de um dos maiores lutadores do Kodokan, Tokugoro Ito"
                },
                {
                  "uri": "https://en.wikipedia.org/wiki/Geo_Omori",
                  "citation": "He learned under Tokugoro Ito and was a training partner of the famed Sanpo Toku"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": null,
              "teacher": null,
              "rank": "2 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php",
                  "cite": "MAÇANEIRO, Gustavo Goulart Braga. Desenvolvimento organizacional do judô brasileiro. São Paulo : Escola de Educação Física e Esporte, Universidade de São Paulo, 2024. Dissertação de Mestrado em Estudos Socioculturais e Comportamentais da Educação Física e Esporte",
                  "citation": "Geo Omori 2º dan não oficial"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Geo_Omori"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://podcasters.spotify.com/pod/show/budokast0/episodes/Budokast-04---Geo-Omori-e-o-Jiu-Jitsu-Brasileiro-e8cbdt"
            }
          ],
          "source_yaml": "database/persons/JPN/Omori_Jyoji.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-38",
          "name": "Okano Yoshitaro",
          "native_name": {
            "name": "岡野好太郎",
            "lang": "ja"
          },
          "aka": [
            {
              "name": "Okano Kotaru",
              "native_name": [
                {
                  "name": "岡野好太郎",
                  "lang": "ja"
                }
              ]
            }
          ],
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1885-04-24",
            "location": "Tonoshō",
            "country_code": "JPN"
          },
          "death": {
            "date": "1967-06-02",
            "location": null,
            "country_code": "JPN"
          },
          "photo_url": "https://archive.org/download/okano/okano.jpg",
          "teachers": [
            {
              "name": null,
              "style_id": "JDP-S-3",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-42",
              "style_id": "JDP-S-9",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 0
            },
            {
              "id": "JDP-43",
              "style_id": "JDP-S-1",
              "place": "Butokuden",
              "period": {
                "start": 1906,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-44",
              "style_id": "JDP-S-1",
              "place": "Butokuden",
              "period": {
                "start": 1906,
                "end": null
              },
              "quality": 1
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "10 dan",
              "date": "1967-06-02",
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "http://kodokanjudoinstitute.org/doctrine/palace/yoshitaro-okano/"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E7%84%A1%E7%9B%B8%E6%B5%81"
            }
          ],
          "source_yaml": "database/persons/JPN/Okano_Yoshitaro.yaml",
          "photo_url_local": "images/cache/ef589301a9079949fe6001e90aa1e174.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-126",
          "name": "Ogawa Ryuzo",
          "native_name": {
            "name": "小川 龍造",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1885",
            "location": "Taira, Fukushima",
            "country_code": "JPN"
          },
          "death": {
            "date": "1974",
            "location": "",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://archive.org/download/ogawa/ogawa.jpg",
            "source": {
              "uri": "https://fpj.com.br/",
              "cite": "Mestre Ryuzo Ogawa, fundador do Hombu Dojô Budokan (FPJudo)"
            }
          },
          "teachers": [
            {
              "name": "",
              "style_id": "",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "urn:isbn:1425163491",
                  "cite": "Os Pioneiros do Judô no Brazil, Chiaki Ishii, 2015"
                }
              ]
            },
            {
              "name": "",
              "style_id": "",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "urn:isbn:1425163491",
                  "cite": "Os Pioneiros do Judô no Brazil, Chiaki Ishii, 2015"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "rank": "5 dan",
              "date": "1954",
              "org": "Dai Nippo Butokukai",
              "quality": 2,
              "sources": [
                {
                  "uri": "https://judo.forumotion.com/t3031-japanese-certificate-help-again",
                  "cite": "Japanese Certificate - Help Again [Ryuzo Ogawa] (E-Judo)",
                  "citation": "Ogawa Ryuzo signed far left. The three vertical columns are his positions, right to left: 5th dan judo, Dai Nihon Butokukai / Member, Greater Japan Ancient Martial Arts Preservation Society / Shihan, Kashima Shin'yo Ryu Jujutsu Judo"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-1",
              "rank": "8 dan",
              "date": "1954",
              "org": "Dai Nippo Butokukai",
              "quality": 2,
              "sources": [
                {
                  "uri": "https://revistabudo.com.br/a-partir-de-2022-a-federacao-paulista-de-judo-realizara-os-campeonatos-do-hombu-dojo-budokan/",
                  "cite": "A partir de 2022, a Federação Paulista de Judô realizará os campeonatos do Hombu Dojô Budokan (Revista Budô)",
                  "citation": "Após o falecimento de Ryuzo, que conquistara a graduação hachi-dan (8º dan), quem assumiu foi o pai de Hitoshi e Hatiro, Matsuo Ogawa"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "urn:isbn:1425163491"
            },
            {
              "uri": "https://books.google.pt/books?id=WtgDAAAAMBAJ&pg=PA23"
            },
            {
              "uri": "https://ge.globo.com/judo/noticia/2014/09/precursor-na-difusao-do-judo-no-pais-ryuzo-ogawa-e-uma-lenda-do-esporte.html"
            },
            {
              "uri": "https://pt.wikipedia.org/wiki/Jud%C3%B4_do_Brasil"
            },
            {
              "uri": "https://www.revistas.usp.br/rbefe/article/view/52889/56819"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            }
          ],
          "source_yaml": "database/persons/JPN/Ogawa_Ryuzo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-59",
          "name": "Ogawa Kinnosuke",
          "native_name": {
            "name": "小川 金之助",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1884",
            "location": "Aiichi",
            "country_code": "JPN"
          },
          "death": {
            "date": "1962",
            "location": null,
            "country_code": null
          },
          "description": {
            "en": "Ogawa Kinnosuke was born in 1884 in Aiichi prefecture. He began kendo whilst in school, at around 13/15 years of age, under kendo hanshi Kato Kiichi and later under Kohori Yasutada. In his late teens and very early 20s he taught kendo at a middle school and joined the army (field gunnery position) before being employed by Nagoya police department. He was a student and later an instructor at the Budo Senmon Gakko, as well as in the Nagoya police. He was a Butokukai hanshi and was Busen's principle kendo instructor in the 1930's and up until 1945."
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/%E5%B0%8F%E5%B7%9D%E9%87%91%E4%B9%8B%E5%8A%A9.png/220px-%E5%B0%8F%E5%B7%9D%E9%87%91%E4%B9%8B%E5%8A%A9.png",
            "source": {
              "uri": "https://commons.wikimedia.org/wiki/File:%E5%B0%8F%E5%B7%9D%E9%87%91%E4%B9%8B%E5%8A%A9.png",
              "cite": "小川金之助 - Wikimedia Commons"
            }
          },
          "teachers": [
            {
              "id": "JDP-60",
              "style_id": "JDP-S-8",
              "place": "Budō Senmon Gakko",
              "period": {
                "start": 1907,
                "end": 1910
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm",
                  "cite": "Ogawa Kinnosuke - Kenshi 24/7",
                  "citation": "In 1905 a school was formally opened to teach kendo instructors and Naito was selected as the senior teacher. At this time the school was known as the Bujutsu Kyoin Yoseijo, but eventually (after a few re-organisations and renames) it would be known to everyone as Busen (Budo Senmon Gakko). It was to this school that Ogawa was dispatched by the Nagoya police department in 1907. Ogawa would spend 3 years studying kendo directly under Naito."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-8",
              "org": "Dai-Nippon Butoku Kai",
              "teacher": null,
              "rank": "Hanshi",
              "date": null,
              "style": "Kendo",
              "style_native": {
                "name": "剣道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-8",
              "org": "Zen Nippon Kendo Renmei",
              "teacher": null,
              "rank": "10 dan",
              "date": 1957,
              "style": "Kendo",
              "style_native": {
                "name": "剣道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://kenshi247.net/blog/2015/05/22/ogawa-kinnosuke/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q11460626",
              "cite": "Wikidata"
            }
          ],
          "source_yaml": "database/persons/JPN/Ogawa_Kinnosuke.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-124",
          "name": "Oda Tsunetane",
          "aka": [
            {
              "name": "Join Oda"
            }
          ],
          "native_name": {
            "name": "田常胤",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1892-03-10",
            "location": "Yamanashi Prefecture",
            "country_code": "JPN"
          },
          "death": {
            "date": "1955-02-11",
            "location": "Shinjuku",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/b/b7/J%C5%8Din_Oda.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Tsunetane_Oda",
              "cite": "Japanese judoka Oda - Wikipedia"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "rank": "9 dan",
              "date": "1948",
              "quality": 3,
              "sources": [
                {
                  "uri": "https://judoinfo.com/oda/",
                  "cite": "Master Tsunetane Oda - JudoInfo",
                  "citation": "Many years later in 1948, on the occasion of his promotion to 9th Dan, Master Oda published his third edition of Koshita Judo Wa Sushume"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judoinfo.com/oda/"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Tsunetane_Oda"
            }
          ],
          "source_yaml": "database/persons/JPN/Oda_Tsunetane.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-60",
          "name": "Naitō Takaharu",
          "native_name": {
            "name": "内藤高治",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1862",
            "location": "Mito",
            "country_code": "JPN"
          },
          "death": {
            "date": "1929",
            "location": null,
            "country_code": null
          },
          "description": {
            "en": "A swordsman of the Hokushin Ittō-ryū, Naitō taught kendo to the Japanese Police force, and was also the first teacher at the Budo Senmon Gakko. He helped to create the Dai Nihon Teikoku Kendo Kata, a group that promulgated the practice of kendo in Japanese schools and universities under the auspices of the Dai Nippon Butoku Kai."
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Nait%C5%8D_Takaharu_%28%E5%86%85%E8%97%A4%E9%AB%98%E6%B2%BB%29.jpg/220px-Nait%C5%8D_Takaharu_%28%E5%86%85%E8%97%A4%E9%AB%98%E6%B2%BB%29.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Nait%C5%8D_Takaharu#/media/File:Nait%C5%8D_Takaharu_(%E5%86%85%E8%97%A4%E9%AB%98%E6%B2%BB).jpg",
              "cite": "Naitō Takaharu (内藤高治) - Wikimedia Commons"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-8",
              "org": "Dai-Nippon Butoku Kai",
              "teacher": null,
              "rank": "Hanshi",
              "date": null,
              "sources": [
                {
                  "uri": "https://kenshi247.net/blog/2013/10/16/monna-tadashi/",
                  "cite": "Monna Tadashi - Kenshi 24/7",
                  "citation": "In 1913, at the same time as Naito Takaharu and Takano Sasaburo, he was awarded hanshi."
                }
              ],
              "style": "Kendo",
              "style_native": {
                "name": "剣道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Nait%C5%8D_Takaharu"
            },
            {
              "uri": "https://kenshi247.net/blog/2020/06/17/finding-naito/"
            },
            {
              "uri": "https://kenshi247.net/blog/2012/12/04/naito-takaharu/"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%86%85%E8%97%A4%E9%AB%98%E6%B2%BB"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q11394577",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Nait%C5%8D_Takaharu",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Naito_Takaharu.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-44",
          "name": "Nagaoka Shūichi",
          "native_name": {
            "name": "永岡 秀一",
            "lang": "ja"
          },
          "aka": [
            {
              "name": "Nagaoka Hideichi"
            }
          ],
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1876-09-17",
            "location": "Okayama",
            "country_code": "JPN"
          },
          "death": {
            "date": "1952-11-22",
            "location": null,
            "country_code": null
          },
          "photo_url": "https://archive.org/download/nagaoka_hideichi/nagaoka_hideichi.jpg",
          "teachers": [
            {
              "name": "Noda Kensaburo",
              "style_id": "JDP-S-2",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            },
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1891,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "10 dan",
              "date": "1937-12-27",
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Shuichi_Nagaoka"
            },
            {
              "uri": "https://www.judo-ch.jp/english/legend/nagaoka/"
            }
          ],
          "source_yaml": "database/persons/JPN/Nagaoka_Shuici.yaml",
          "photo_url_local": "images/cache/11a297ba540c94bd025868da5eb45e1b.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-94",
          "name": "Murakami Tetsuji",
          "native_name": {
            "name": "村上 哲次",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1927-03-31",
            "location": "Shizuoka",
            "country_code": "JPN"
          },
          "death": {
            "date": "1987-01-24",
            "location": "Paris",
            "country_code": "FRA"
          },
          "photo": {
            "url": "https://archive.org/download/mura-4/Mura4.jpg",
            "source": {
              "uri": "https://karate-shotokai.blogspot.com/2014/08/mestre-tetsuji-murakami.html",
              "cite": "Mestre Tetsuji Murakami (Karate-do Shotokai)"
            }
          },
          "teachers": [
            {
              "id": "JDP-93",
              "style_id": "JDP-S-5",
              "place": null,
              "quality": 2,
              "period": {
                "start": 1968,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://shotokai.com/tetsuji-murakami/",
                  "cite": "Tetsuji Murakami Sensei (Shotokai Encyclopedia)",
                  "citation": "In 1968 he travels to Japan where he meets Master Shigeru Egami. Very impressed by Master Egami and the technique he observes, he decides to make a profound and very difficult transformation in his technique and his practice. He returns to Europe as the representative of the Nihon Karate-do Shotokai."
                },
                {
                  "uri": "https://kogenbudo.org/interview-with-master-nuno-russo-by-pedro-escudeiro/",
                  "cite": "https://kogenbudo.org/interview-with-master-nuno-russo-by-pedro-escudeiro/",
                  "citation": " A couple of years later, though, we had our first international seminar with a Japanese karate master: Murakami Tetsuji, from Shotokai Karate, a student of Egami Shigeru sensei. After this seminar, Murakami sensei became the leader of our karate group"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null,
              "quality": null
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Tetsuji_Murakami"
            },
            {
              "uri": "https://shotokai.com/tetsuji-murakami/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q3519204",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Tetsuji_Murakami",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Murakami_Tetsuji.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-29",
          "name": "Mochizuki Minoru",
          "native_name": {
            "name": "望月 稔",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1907-04-07",
            "location": "Shizuoka",
            "country_code": "JPN"
          },
          "death": {
            "date": "2003-05-30",
            "location": "Aix-en-Provence",
            "country_code": "FRA"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/9/97/Minoru_Mochizuki_c1930.jpg",
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1925,
                "end": 1930
              }
            },
            {
              "id": "JDP-11",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1925,
                "end": 1930
              }
            },
            {
              "id": "JDP-27",
              "style_id": "JDP-S-4",
              "place": "Kobukan dojo",
              "quality": null,
              "period": {
                "start": 1930,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://aikidojournal.com/2002/11/18/interview-with-minoru-mochizuki-1/",
                  "citation": "That was back in 1930 when Ueshiba Sensei still didn’t have a place of his own and was teaching in the living room of a regular private house in the Mejiro area of Tokyo. But just after we started going there, we all moved to the newly finished Ushigome dojo (site of the present Hombu Dojo)"
                }
              ]
            },
            {
              "id": "JDP-41",
              "style_id": "JDP-S-5",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://www.ffkarate.fr/hiroo-mochizuki-interview-yoseikan-budo/",
                  "citation": "Elève de Jigoro Kano, qui l’avait envoyé apprendre l’aïkido auprès de Morihei Ueshiba, Minoru Mochizuki avait aussi travaillé avec Gichin Funakoshi. [...]  C’était la responsabilité d’une vie pour lui, car c’est la mission que lui avait confié Jigoro Kano. Mais il se trouvait un peu faible du point de vue des atémis, qu’il avait pourtant étudié avec Funakoshi"
                },
                {
                  "uri": "https://books.google.pt/books?id=SdYDAAAAMBAJ&pg=PA34#v=onepage&q&f=false",
                  "cite": "A Man of Many Budo (interview with Minoru Mochizuki), Black Belt, Aug 1989.",
                  "citation": "Minoru Mochizuki holds the distinction of being the only living man to have studied with aikido founder Morihei Uyeshiba, judo founder Jigoro Kano, and \"the father of Japanese karate, Gichin Funakoshi."
                }
              ]
            },
            {
              "name": "Sanjuro Oshima",
              "style": "Gyokushin Ryu",
              "place": null,
              "quality": null,
              "period": {
                "start": 1924,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": "Gyokushin Ryu",
              "org": null,
              "teacher": "Sanjuro Oshima",
              "rank": "Shoden Kirishi Mokuroku",
              "date": 1924
            },
            {
              "style_id": "JDP-S-10",
              "org": null,
              "teacher": "JDP-27",
              "rank": null,
              "date": 1924,
              "style": "Daitō-ryū Aiki-jūjutsu",
              "style_native": {
                "name": "大東流 合気柔術",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "8 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://aikidojournal.com/2002/11/18/interview-with-minoru-mochizuki-1/"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Minoru_Mochizuki"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q1937662",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Minoru_Mochizuki",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Mochizuki_Minoru.yaml",
          "photo_url_local": "images/cache/10306b68d5b5a690b5c86d083c61657f.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-53",
          "name": "Tsunako Miyake",
          "native_name": {
            "name": "三宅綱子",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1926,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": "https://4.bp.blogspot.com/-0_CB4s36WbI/TWq2YuGRTbI/AAAAAAAAAOo/XfncjJ-MHQ4/s320/Miyake.GIF",
          "teachers": [
            {
              "id": "JDP-26",
              "style_id": "JDP-S-4",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://aikidojournal.com/2004/05/06/hiroaki-kogure-sensei-part-two",
                  "cite": "Interview with Hiroaki Kogure Sensei, part 2 (interview by Josh Gold, 2004, Aikido Journal)",
                  "citation": "Tomiki Sensei had three top students. they were Hideo Oba, Senta Yamada, and Tsunako Miyake Sensei."
                }
              ]
            },
            {
              "id": "JDP-26",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://studygrouptomikiaikido.blog/2022/09/05/simplification-or-sportification",
                  "cite": "MIYAKE Sensei, Extracts from an Interview by R.J.Lawrance, The E.A.A. Newsletter, Issue 90.2 (in: Study Group Tomiki Aikido - The simplification of Ueshiba’s Aikido)",
                  "citation": "Then, I met Tomiki sensei at the Kodokan (...) Now that he is gone, I think that it is very important for us to understand his idea, that to improve judo we must train in judo and aikido together."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": null,
              "teacher": "JDP-26",
              "rank": "8 dan",
              "date": null,
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "7 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            },
            {
              "style_id": null,
              "teacher": null,
              "rank": "7 dan",
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://studygrouptomikiaikido.blog/2022/01/24/judo-taiso-a-scientific-vehicle-for-aikido/"
            },
            {
              "uri": "https://tomikiaikido.blogspot.com/2010/01/miyake-cultural-treasure.html"
            },
            {
              "uri": "https://web.archive.org/web/20120320033257/http://homepage3.nifty.com/-samidare-/ennkaku3.html"
            },
            {
              "uri": "https://aikidojournal.com/2004/05/06/hiroaki-kogure-sensei-part-two/"
            },
            {
              "uri": "https://www.dentonaikido.com/instructor.html"
            },
            {
              "uri": "https://www.youtube.com/watch?v=K__3OoJ_hhM"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Karl_Geis",
              "cite": "Karl Geis - Wikipedia"
            },
            {
              "uri": "https://www.karlgeis.com/his-resume",
              "cite": "His Resume | karlgeisryu"
            }
          ],
          "source_yaml": "database/persons/JPN/Miyake_Tsunako.yaml",
          "photo_url_local": "images/cache/57ee38fb484c838bde16ecc98bd671bb.gif"
        }
      },
      {
        "data": {
          "id": "JDP-49",
          "name": "Miyagawa Taichiro",
          "native_name": {
            "name": "宮川太",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1848,
            "location": "Fukuoka",
            "country_code": "JPN"
          },
          "death": {
            "date": "1920-06-20",
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "description": {
            "en": "Miyagawa Taichiro was born on Kaei first. He served the Kuroda clan as a retainer. He was an accomplished martial artist, having learned Itto-ryu kenjutsu and Jigo Tenshin Ryu jujutsu, which he taught at the Genyosha-linked dojo that would be the origin of the Meidokan. He participated in the Hagi Rebellion against the Meiji government.\n",
            "ja": "宮川太一郎、名は鍜キタウ。筑前の人。嘉永元年七月二十四日福岡に生 る。世、黒田氏に仕へ、其の藩士たり。夙に文武館に入り、専ら武技を 講修し、撃剣（一刀流）柔術（自得天心流）の奥技を究む。維新後藩の 併心隊に入り、青年派の牛耳を執る。明治三年、事を以て就義隊の領袖 箱田六輔等と争ひ、屏居を命ぜらる。後、節を折り、六輔、及、進藤喜 平太等と共に、高場乱の門に入る。七年二月、佐賀の変、福岡臨時鎮撫 隊の組織せらるゝや、太一郎、六輔と共に、其半隊長たり。八年、六輔、 及、頭山満等と矯志社を起し、九年十二月、萩の事変に坐せられて、六 輔等と共に獄に下り、十一年三月、始めて釈さる。後、開墾社を博多向 浜に開き、爾来志を政治上に断ち、専ら実業に従事す。 宮川太一郎嘉永元年（1848）生正林又七郎の高弟・免許皆伝代々黒田家 の臣である。一万流剣術，自剛天真流組討を極め，明治10年(1877) 11 月玄洋社附属の向浜塾で自聞天真流を教授したのが，後の明道館道場の 起源とされている。大正9年(1920)6月20日77才にて病没。長男．宮川彦 之助も目録まで進み，自剛天真流の普及に務めた。\n"
          },
          "teachers": [
            {
              "id": "JDP-51",
              "style_id": "JDP-S-12",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/",
                  "citation": "宮川太一郎嘉永元年（1848）生正林又七郎の高弟・免許皆伝代々黒田家の臣である。一万流剣術，自剛天真流組討を極め，明治10年(1877) 11月玄洋社附属の向浜塾で自聞天真流を教授したのが，後の明道館道場の起源とされている。大正9年(1920)6月20日77才にて病没。長男．宮川彦之助も目録まで進み，自剛天真流の普及に務めた。"
                }
              ],
              "quality": 2
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-12",
              "org": null,
              "teacher": "庄林又七郎",
              "rank": "Menkyokaiden (免許皆伝)",
              "date": null,
              "style": "Jigō Tenshin Ryū",
              "style_native": {
                "name": "自剛天真流",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "http://www5e.biglobe.ne.jp/~isitaki/page048.html",
              "events": [
                "name",
                "native_name",
                "birth",
                "death"
              ]
            },
            {
              "uri": "http://www5e.biglobe.ne.jp/~isitaki/page045.html"
            },
            {
              "uri": "https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/",
              "events": [
                "name",
                "native_name",
                "birth",
                "death"
              ]
            }
          ],
          "tags": [
            "Genyōsha"
          ],
          "source_yaml": "database/persons/JPN/Miyagawa_Taichiro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-107",
          "name": "Miyako Sada",
          "native_name": {
            "name": "三浦鑿",
            "lang": "ja"
          },
          "aka": [
            "Miura Saku"
          ],
          "nationality": [
            "BRA",
            "JPN"
          ],
          "birth": {
            "date": "1881",
            "location": "Ehime",
            "country_code": "JPN"
          },
          "death": {
            "date": "1945-10-26",
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://archive.org/download/sada_miyako/sada_miyako.jpg",
            "source": {
              "uri": "https://www.ndl.go.jp/brasil/e/data/R/084/084-002r.html",
              "cite": "100 Japanese Emigration to Brazil - Saku Miura (National Diet Library)"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": 2,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://judotradicionalgoshinjutsukan.blogspot.com/2009/10/capoeira-vs-jujutsu.html"
            },
            {
              "uri": "https://www.ndl.go.jp/brasil/e/data/R/084/084-002r.html"
            },
            {
              "uri": "https://cenb.org.br/articles/display/240"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "location": "vol. II, p. 100"
            },
            {
              "uri": "https://podcasters.spotify.com/pod/show/budokast0/episodes/Budokast-04---Geo-Omori-e-o-Jiu-Jitsu-Brasileiro-e8cbdt"
            }
          ],
          "source_yaml": "database/persons/JPN/Miura_Saku.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-11",
          "name": "Mifune Kyūzō",
          "native_name": {
            "name": "三船 久蔵",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1883-04-21",
            "location": "Iwate",
            "country_code": "JPN"
          },
          "death": {
            "date": "1965-01-27",
            "location": null,
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://1.bp.blogspot.com/_NjSHIRBuf3Y/SHlsXVS7iGI/AAAAAAAAAk0/d-EnhgFOBPk/s400/kyuzomifune.jpg",
            "source": {
              "uri": "http://judotradicionalgoshinjutsukan.blogspot.com/2008/07/kyuzo-mifune.html",
              "cite": "Judo Tradicional Goshinjutsukan - Kyuzo Miffing"
            }
          },
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1903,
                "end": 1965
              }
            },
            {
              "id": "JDP-9",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1903,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "10 dan",
              "date": 1945,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E4%B8%89%E8%88%B9%E4%B9%85%E8%94%B5"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Kan%C5%8D_Jigor%C5%8D"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q2453372",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Kyuzo_Mifune",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Mifune_Kyuzo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-54",
          "name": "Matsumura Sōkon",
          "native_name": {
            "name": "松村 宗棍",
            "lang": "ryu"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1809,
            "location": "Shuri, Okinawa",
            "country_code": "JPN"
          },
          "death": {
            "date": 1899,
            "location": null,
            "country_code": null
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/0/04/S%C5%8Dkon_Matsumura.jpg",
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%AE%89%E9%87%8C%E5%AE%89%E6%81%92"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Matsumura_S%C5%8Dkon#/media/File:S%C5%8Dkon_Matsumura.jpg"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q715769",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Matsumura_S%C5%8Dkon",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Matsumura_Sokon.yaml",
          "photo_url_local": "images/cache/d3d8d5f6459ab8ddf5dc181c0fd1042b.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-42",
          "name": "Matsui Sanzo",
          "native_name": {
            "name": "松井三蔵",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1861-05-16",
            "location": "Higashikaji",
            "country_code": "JPN"
          },
          "death": {
            "date": "1932-06-08",
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E6%9D%BE%E4%BA%95%E4%B8%89%E8%94%B5"
            }
          ],
          "source_yaml": "database/persons/JPN/Matsui_Sanzo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-51",
          "name": "Matashichiro Shobayashi",
          "native_name": {
            "name": "庄林又七郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "description": null,
          "teachers": [
            {
              "name": "JDP-52",
              "style_id": "JDP-S-12",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/",
                  "citation": "宮川太一郎嘉永元年（1848）生正林又七郎の高弟・免許皆伝代々黒田家の臣である。一万流剣術，自剛天真流組討を極め，明治10年(1877) 11月玄洋社附属の向浜塾で自聞天真流を教授したのが，後の明道館道場の起源とされている。大正9年(1920)6月20日77才にて病没。長男．宮川彦之助も目録まで進み，自剛天真流の普及に務めた。"
                }
              ],
              "quality": 2
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-12",
              "org": null,
              "teacher": "庄林又七郎",
              "rank": "Menkyokaiden (免許皆伝)",
              "date": null,
              "style": "Jigō Tenshin Ryū",
              "style_native": {
                "name": "自剛天真流",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/",
              "events": [
                "name",
                "native_name"
              ]
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E8%87%AA%E5%89%9B%E5%A4%A9%E7%9C%9F%E6%B5%81"
            }
          ],
          "source_yaml": "database/persons/JPN/Matashichiro_Shobayashi.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-50",
          "name": "Masakatsu Naka",
          "native_name": {
            "name": "中井 正勝",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Yagy%C5%AB_Shinkage-ry%C5%AB",
              "events": [
                "name native_name"
              ]
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB"
            }
          ],
          "source_yaml": "database/persons/JPN/Masakatsu_Nakai.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-18",
          "name": "Maeda Mitsuyo",
          "native_name": {
            "name": "前田 光世",
            "lang": "ja"
          },
          "aka": [
            "Otávio Maeda",
            "Conde Koma"
          ],
          "nationality": [
            "JPN",
            "BRA"
          ],
          "birth": {
            "date": "1878-11-18",
            "location": "Hirosaki",
            "country_code": "JPN"
          },
          "death": {
            "date": "1941-11-28",
            "location": "Belém, Pará",
            "country_code": "BRA"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Mitsuyo_Maeda_c1910.jpg/346px-Mitsuyo_Maeda_c1910.jpg",
          "teachers": [
            {
              "name": "Saito Mohei",
              "style": "Hongaku Kokki-ryû",
              "place": null,
              "quality": null,
              "period": {
                "start": 1895,
                "end": 1896
              }
            },
            {
              "id": "JDP-9",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": 1,
              "period": {
                "start": 1897,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://ja.wikipedia.org/wiki/%E6%A8%AA%E5%B1%B1%E4%BD%9C%E6%AC%A1%E9%83%8E",
                  "cite": "横山作次郎 (ウィキペディア)",
                  "citation": "また、三船久蔵や前田光世の師匠としても知られる"
                },
                {
                  "uri": "https://simonbjj.com/satake",
                  "cite": "The Sumo wrestle who taught BJJ, Soshiro Satake",
                  "citation": "At some point later, probably in the late 1890’s, he joined the Kodokan and would become peers of Mitsuyo Maeda. The two judoka trained together under Sakujiro Yokoyama, who was known as one of the Four Guardians of the Kodokan"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "7 dan",
              "date": 1941,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Mitsuyo_Maeda"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q2456537",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Mitsuyo_Maeda",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Maeda_Mitsuyo.yaml",
          "photo_url_local": "images/cache/3f7c419cc1985a2cb0d3581aa3adf353.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-115",
          "name": "Kumajiro Yamaguchi",
          "native_name": {
            "name": "山口熊次郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "teachers": [
            {
              "id": "JDP-116",
              "style_id": "JDP-S-6",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
                  "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
                  "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô (...) Hayashi Saiichirô –> Hayashi Yazaemon –> Ôtake Risuke"
                }
              ]
            }
          ],
          "rank": [
            {
              "style": "JDP-S-6",
              "org": null,
              "teacher": null,
              "rank": "Kyoju",
              "date": null,
              "sources": [
                {
                  "uri": "https://inoshishikukan.com/budo/katori/woman-of-katori-shinto-ryu",
                  "cite": "Women of Katori Shintō-ryū",
                  "citation": "In the official history of our school, the 18th Soke Iizasa Morisada died suddenly, without a male successor. For a time, under these conditions, the school was then led by the then Shihan with Yamaguchi Kumajiro as Kyoju."
                }
              ]
            }
          ],
          "sources": [
            {
              "uri": "https://shinbukan-katorishintoryu.org/?page_id=898&lang=en"
            },
            {
              "uri": "https://inoshishikukan.com/budo/katori/woman-of-katori-shinto-ryu"
            },
            {
              "uri": "https://shinbukan-katorishintoryu.org/?page_id=927&lang=ja",
              "citation": "天真正伝香取神道流 (天真正伝香取神道流)"
            }
          ],
          "source_yaml": "database/persons/JPN/Kumajiro_Yamaguchi.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-33",
          "name": "Kuboki Sozaemon",
          "native_name": {
            "name": null,
            "lang": null
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2"
            }
          ],
          "source_yaml": "database/persons/JPN/Kuboki_Sozaemon.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-37",
          "name": "Konishi Yasuhiro",
          "native_name": {
            "name": "小西康裕",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1893,
            "location": "Takamatsu, Kagawa",
            "country_code": "JPN"
          },
          "death": {
            "date": 1983,
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Konishi.JPG/200px-Konishi.JPG",
          "teachers": [
            {
              "id": "JDP-38",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1906,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-39",
              "style_id": "JDP-S-8",
              "place": null,
              "period": {
                "start": 1906,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-42",
              "style_id": "JDP-S-9",
              "place": null,
              "period": {
                "start": 1906,
                "end": null
              },
              "quality": 0
            },
            {
              "id": "JDP-40",
              "style_id": "JDP-S-8",
              "place": "Keiō Gijuku Daigaku",
              "period": {
                "start": 1913,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-41",
              "style_id": "JDP-S-5",
              "place": "Keiō Gijuku Daigaku",
              "period": {
                "start": 1924,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://ryukyu-bugei.com/?p=6586",
                  "citation": "When he [Konishi] met Funakoshi Gichin in June 1925, he was finally able to learn Karate. However, since its contents was only Kata, together with Ōtsuka Hironori 大塚博紀 (1892–1982, founder of Wadō-ryū Karate-dō and Jūjutsu Kenpō) who was also a disciple of Funakoshi, Konishi began to devise Yakusoku Kumite 約束組手 and the like. Later Konishi studied Karate with Motobu Chōki and Mabuni Kenwa."
                }
              ]
            },
            {
              "name": "Ōtsuka Hironori",
              "style_id": "JDP-S-5",
              "place": "Keiō Gijuku Daigaku",
              "period": {
                "start": 1924,
                "end": null
              },
              "quality": 1
            },
            {
              "id": "JDP-27",
              "style_id": "JDP-S-4",
              "place": null,
              "period": {
                "start": 1924,
                "end": null
              },
              "quality": 1
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%B0%8F%E8%A5%BF%E5%BA%B7%E8%A3%95_(%E7%A9%BA%E6%89%8B%E5%AE%B6)"
            },
            {
              "uri": "https://ryukyu-bugei.com/?p=6586"
            },
            {
              "uri": "https://blackbeltmag.com/konishi-yasuhiro"
            },
            {
              "uri": "https://www.jkr-uk.org.uk/yasuhiro-konishi"
            }
          ],
          "source_yaml": "database/persons/JPN/Konishi_Yasuhiro.yaml",
          "photo_url_local": "images/cache/8b2d9702cc96e4583e32d0bf958873fd.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-12",
          "name": "Kobayashi Kiyoshi",
          "native_name": {
            "name": "小林清",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1925-04-09",
            "location": "Gunma",
            "country_code": "JPN"
          },
          "death": {
            "date": "2013-04-09",
            "location": null,
            "country_code": "JPN"
          },
          "photo_url": "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcSuhkNSuXgXEFBZToZ69C3M_dfMhOmheEPZiLctfs0KLWtq9UNC",
          "description": {
            "en": "Kobayashi Kiyoshi (小林清) was the «father» of Portuguese Judo and one of the founders of the Portuguese Judo Federation, and the greatest promoter of Judo in Portugal. Sensei Kobayashi was one of the highest grades in the world, 9th dan given Kodokan by in 1999.",
            "pt": "O Mestre Kiyoshi Kobayashi, uma das mais altas graduações da Modalidade – 9º Dan, foi um dos grandes responsáveis pelo crescimento e desenvolvimento da modalidade em Portugal, sendo conhecido inclusive como \"o pai do judo português\". Foi Selecionador e Treinador da Equipa Nacional e acompanhou-as em Campeonatos da Europa e do Mundo, assim como nas edições dos Jogos Olímpicos de Montreal (1976), Los Angeles(1984) e Seul (1988)."
          },
          "teachers": [
            {
              "id": "JDP-11",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1903,
                "end": 1965
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "9 dan",
              "date": 2013,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "http://kodokanjudoinstitute.org/news/2012/04/epost-15/"
            },
            {
              "uri": "http://kodokanjudoinstitute.org/magazine/201401/"
            },
            {
              "uri": "https://www.eju.net/judo-father-sensei-kiyoshi-kobayashi-passed-away/"
            },
            {
              "uri": "http://archive.today/YkEjw"
            },
            {
              "uri": "http://www.judo.crcharnequense.net/index.php/judo-menu/historia-do-judo-menu-item/judo-portugal-menu-item"
            }
          ],
          "source_yaml": "database/persons/JPN/Kobayashi_Kiyoshi.yaml",
          "photo_url_local": "images/cache/9f54fb588b61dd606a167494c564c23e.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-89",
          "name": "Kimura Masahiko",
          "native_name": {
            "name": "木村 政彦",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1917-09-10",
            "location": "Kumamoto",
            "country_code": "JPN"
          },
          "death": {
            "date": "1993-04-18",
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/4/4b/Masahiko_Kimura_2.jpg",
            "source": {
              "uri": "https://de.wikipedia.org/wiki/Kimura_Masahiko_%28Judoka%29#/media/Datei:Masahiko_Kimura_2.jpg"
            }
          },
          "teachers": [
            {
              "id": "JDP-90",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1925,
                "end": 1930
              }
            },
            {
              "id": "JDP-41",
              "style_id": "JDP-S-5",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.bjjee.com/articles/my-judo-by-masahiko-kimura-his-story-vision-in-his-own-words-part-1/",
                  "cite": "'My Judo' by Masahiko Kimura, His Story & Vision in His Own Words Part 1 (BJJ EE)",
                  "citation": "Later on, I [ed. Kimura] got interested in karate, and learned Shorinji-ryu (Note: today’s Shotokan karate) under the guidance of Master Funakoshi for a little over 2 years."
                }
              ]
            },
            {
              "name": "JDP-xx",
              "style_id": "JDP-S-5",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.bjjee.com/articles/my-judo-by-masahiko-kimura-his-story-vision-in-his-own-words-part-1/",
                  "cite": "'My Judo' by Masahiko Kimura, His Story & Vision in His Own Words Part 1 (BJJ EE)",
                  "citation": "After this, I learned Goju-ryu karate from Master So, who was a great master of Gojuryu, and eventually became an assistant instructor in his dojo."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "7 dan",
              "date": 1947,
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20120622122136/http://judoinfo.com/kimura3.htm",
                  "cite": "Masahiko Kimura (1917-1993): The Man Who Defeated Helio Gracie (by Jim Chen M.D, in Judoinfo.com [Archived])",
                  "citation": "His shichidan rank was frozen after disputes with Kodokan over becoming a professional wrestler, refusal to return the All Japan Judo Championship Flag"
                },
                {
                  "uri": "https://en.wikipedia.org/wiki/Masahiko_Kimura",
                  "citation": "He was promoted to 7th dan at age 30"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Masahiko_Kimura"
            },
            {
              "uri": "https://www.aikidosangenkai.org/blog/aikido-judo-gozo-shioda-masahiko-kimura/"
            },
            {
              "uri": "https://web.archive.org/web/20120622122136/http://judoinfo.com/kimura3.htm"
            },
            {
              "uri": "https://www.bjjee.com/articles/my-judo-by-masahiko-kimura-his-story-vision-in-his-own-words-part-1/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q270727",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Masahiko_Kimura",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Kimura_Masahiko.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-13",
          "name": "Kawaishi Mikinosuke",
          "native_name": {
            "name": "川石 酒造之助",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1899-08-13",
            "location": "Himeji",
            "country_code": "JPN"
          },
          "death": {
            "date": "1969-01-30",
            "location": "Paris",
            "country_code": "FRA"
          },
          "description": {
            "en": "Mikinosuke Kawaishi (川石 酒造之助, Kawaishi Mikinosuke, born 13 August 1899 – 30 January 1969) was a Japanese master of jujutsu and judo who achieved the rank of 7th Dan. He led the development of Judo in France, with Shozo Awazu, and much of Europe and is credited with introducing the colored belt system for differentiating early grades. However, written accounts from the archives of London's Budokwai judo club, founded in 1918, record the use of colored judo belts at the 1926 9th annual Budokwai Display, and a list of ranked colored judokas appears in the Budokwai Committee Minutes of June 1927. Kawaishi visited London and the Budokwai in 1928, and was probably inspired to bring the colored belt system to France. The Fédération Française posthumously awarded him 10th Dan in judo and jujutsu."
          },
          "photo_url": "https://archive.org/download/kawaishi_mikinosuke/kawaishi_mikinosuke.jpg",
          "teachers": [
            {
              "name": "Yoshida Kōtarō",
              "style_id": "JDP-S-1",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            },
            {
              "name": "Miyakawa Ikkan",
              "style_id": "JDP-S-1",
              "place": "Waseda University",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            },
            {
              "id": "JDP-14",
              "style_id": "JDP-S-1",
              "place": "Waseda University",
              "quality": null,
              "period": {
                "start": 1881,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "7 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-1",
              "org": "FFJDA",
              "teacher": null,
              "rank": "10 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.researchgate.net/publication/277665808_Kodokan_Judo's_three_orphaned_forms_of_counter_techniques_-_Part_1_The_gonosen-no-kata_-_Forms_of_post-attack_initiative_counter_throws"
            },
            {
              "uri": "https://doi.org/10.4471/hse.2013.15"
            },
            {
              "uri": "https://judoinfo.com/kawaishi/"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%B7%9D%E7%9F%B3%E9%85%92%E9%80%A0%E4%B9%8B%E5%8A%A9"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q3090191",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Mikinosuke_Kawaishi",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Kawaishi_Mikinosuke.yaml",
          "photo_url_local": "images/cache/b1183f842d638260d7b449d81deefacd.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-1",
          "name": "Kanō Jigorō",
          "native_name": {
            "name": "嘉納 治五郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1860-10-28",
            "location": "Kobe",
            "country_code": "JPN",
            "sources": [
              {
                "uri": "https://martialhistoryteam.blogspot.com/2020/04/when-was-professor-kano-born.html",
                "citation": "10月28日 refers to October 28. In other words, by the Gregorian calendar, Kano was born on October 28, 1860."
              }
            ]
          },
          "death": {
            "date": "1928-05-04",
            "location": "Pacific Ocean",
            "country_code": null
          },
          "description": {
            "en": "Jigoro Kano (嘉納 治五郎, 10 December 1860 – 4 May 1938[3]) was a Japanese educator, athlete, and the founder of Judo. Along with Ju-Jutsu, Judo was one of the first Japanese martial arts to gain widespread international recognition, and the first to become an official Olympic sport. Pedagogical innovations attributed to Kanō include the use of black and white belts, and the introduction of dan ranking to show the relative ranking among members of a martial art style. Well-known mottoes attributed to Kanō include \"good use of energy\" (精力善用 seiryoku zen'yō) and \"mutual welfare and benefit\" (自他共栄 jita kyōei).\n",
            "ja": "嘉納 治五郎（かのう じごろう、万延元年10月28日〈1860年12月10日〉-昭 和13年〈1938年〉5月4日）は、日本の柔道家・教育者・貴族院議員。兵 庫県出身。別表記：加納治五郎[1]。講道館柔道の創始者であり[2]、柔 道・スポーツ・教育分野の発展や日本のオリンピック初参加に尽力する など、明治から昭和にかけて日本におけるスポーツの道を開いた。「柔 道の父」と呼ばれ、また、「日本の体育の父」とも称される\n",
            "pt": "Jigoro Kano (em japonês: 嘉納治五郎, Kanō Jigorō) (Mikage, 28 de outubro de 1860 – 4 de maio de 1938) foi o fundador da arte marcial Judo.\n"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/0/0c/Kano_Jigoro.jpg",
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/0/0c/Kano_Jigoro.jpg",
            "source": {
              "uri": "https://commons.wikimedia.org/wiki/Category:Photographs_of_Kan%C5%8D_Jigor%C5%8D#/media/File:Kano_Jigoro.jpg",
              "cite": "Jigoro Kano, Wikimedia Commons"
            }
          },
          "teachers": [
            {
              "id": "JDP-2",
              "style_id": "JDP-S-3",
              "place": "Fukuda Hachinosuke dojo",
              "period": {
                "start": 1877,
                "end": 1879
              },
              "quality": 3
            },
            {
              "id": "JDP-4",
              "style_id": "JDP-S-3",
              "place": "Iso Masatomo dojo",
              "period": {
                "start": 1879,
                "end": 1881
              },
              "quality": 3
            },
            {
              "id": "JDP-5",
              "style_id": "JDP-S-2",
              "place": "Eishōji",
              "period": {
                "start": 1881,
                "end": null
              },
              "quality": 3
            },
            {
              "id": "JDP-46",
              "style_id": "JDP-S-11",
              "place": null,
              "period": {
                "start": 1881,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://kanochronicles.com/the-kodokan-and-bojutsu-jo-staff-fighting-and-judo/",
                  "citation": "When I was young, I practiced Yagyū-ryū bōjutsu with a man named Oshima. As my practice of this discipline had not reached the level of shugyō (NOTE: dedicated, austere study), usually I do not mention it. However, since then I thought there was value in bōjutsu shugyō"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "Shihan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-2",
              "org": null,
              "teacher_id": "JDP-5",
              "rank": "Menkyo kaiden",
              "date": null,
              "style": "Kitō-ryū",
              "style_native": {
                "name": "起倒流",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-3",
              "org": null,
              "teacher_id": "JDP-4",
              "rank": "Menkyo kaiden",
              "date": null,
              "style": "Tenjin Shin'yō-ryū",
              "style_native": {
                "name": "天神真楊流",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%98%89%E7%B4%8D%E6%B2%BB%E4%BA%94%E9%83%8E"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9781425163495"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Kan%C5%8D_Jigor%C5%8D"
            },
            {
              "uri": "https://doi.org/10.18002/rama.v9i2.1162"
            },
            {
              "uri": "https://martialhistoryteam.blogspot.com/2020/04/when-was-professor-kano-born.html"
            },
            {
              "uri": "https://kanochronicles.com/the-kodokan-and-bojutsu-jo-staff-fighting-and-judo/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q190141",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Kan%C5%8D_Jigor%C5%8D",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Kano_Jigoro.yaml",
          "photo_url_local": "images/cache/2d37934d8f5ff0af610d77918dbf5da6.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-36",
          "name": "Kanaya Genro",
          "native_name": {
            "name": null,
            "lang": null
          },
          "aka": [
            {
              "name": "Kanaya Motoyoshi"
            }
          ],
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://www.e-budo.com/forum/showthread.php?48591-Yoshin-koryu-Jujutsu"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Yoshio_Sugino"
            },
            {
              "uri": "urn:isbn:9784770026194"
            }
          ],
          "source_yaml": "database/persons/JPN/Kanaya_Genro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-55",
          "name": "Itosu Ankō",
          "native_name": {
            "name": "糸洲 安恒",
            "lang": "ryu"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1831,
            "location": "Shuri, Okinawa",
            "country_code": "JPN"
          },
          "death": {
            "date": "1915-03-11",
            "location": "Shuri, Okinawa",
            "country_code": "JPN"
          },
          "photo_url": "https://ia601205.us.archive.org/27/items/anko-itosu/Anko_Itosu.jpg",
          "teachers": [
            {
              "id": "JDP-54",
              "style_id": "JDP-S-13",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Asato",
                  "citation": "In a 1934 article, Funakoshi noted that Asato and Itosu had studied karate together under Sōkon Matsumura."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Itosu"
            },
            {
              "uri": "https://web.archive.org/web/20100227032428/http://www.shotokai.jp/english/about/teacher.html"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q527422",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Ank%C5%8D_Itosu",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Itosu_Anko.yaml",
          "photo_url_local": "images/cache/73451543abe5bd9fa0165442c90132b7.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-104",
          "name": "Itō Tokugorō",
          "native_name": {
            "name": "伊藤 徳五郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1878",
            "location": "Misato, Akita",
            "country_code": "JPN"
          },
          "death": {
            "date": "1939",
            "location": null,
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/en/5/5c/Ito_PI_nov_6_1909jpg.JPG",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Tokugoro_Ito#/media/File:Ito_PI_nov_6_1909jpg.JPG",
              "cite": "Tokugoro Ito appeared in the Seattle Post-Intelligencer on November 6, 1909 (Wikipedia)"
            }
          },
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://www.city.daisen.lg.jp/docs/2013110800147/file_contents/3.pdf",
                  "cite": "Cosmos, Daisen City Lifelong Learning Information Magazine, No. 3 , Daisen City Lifelong Learning Promotion Headquarters, December 15, 2008",
                  "location": "pp. 31-32"
                },
                {
                  "uri": "https://ja.wikipedia.org/wiki/%E4%BC%8A%E8%97%A4%E5%BE%B3%E4%BA%94%E9%83%8E",
                  "citation": "中退後は講道館で嘉納治五郎門下となって磯貝一・徳三宝・三船久蔵らと共に柔道に励んだ"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "5 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.attacktheback.com/catch-wrestling/",
                  "citation": "One of the first major intercultural clashes of the 20th century in martial arts, between the American wrestler Ad Santel and the Japanese Tokugoro Ito, black belt judo of the fifth degree."
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E4%BC%8A%E8%97%A4%E5%BE%B3%E4%BA%94%E9%83%8E"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://www.attacktheback.com/catch-wrestling/"
            }
          ],
          "source_yaml": "database/persons/JPN/Ito_Tokugoro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-34",
          "name": "Ito Tanekichi",
          "native_name": {
            "name": "伊藤種吉",
            "lang": null
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": null,
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://aikidojournal.com/2018/10/15/the-last-swordsman-the-yoshio-sugino-story-part-2"
            }
          ],
          "source_yaml": "database/persons/JPN/Ito_Tanekichi.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-43",
          "name": "Isogai Hajime",
          "native_name": {
            "name": "磯貝",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1871-10-26",
            "location": "Miyazaki",
            "country_code": "JPN"
          },
          "death": {
            "date": "1947-04-19",
            "location": null,
            "country_code": null
          },
          "photo_url": "https://archive.org/download/isogai_hajime/isogai_hajime.jpg",
          "teachers": [
            {
              "id": "JDP-9",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "quality": null,
              "period": {
                "start": 1891,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "10 dan",
              "date": "1927-12-22",
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "http://kodokanjudoinstitute.org/en/doctrine/palace/"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Hajime_Isogai"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q11973675",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Hajime_Isogai",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Isogai_Hajime.yaml",
          "photo_url_local": "images/cache/473c6f563fa53cadd82ceda396295ca0.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-4",
          "name": "Iso Masatomo",
          "native_name": {
            "name": "磯正智",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1818,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": 1881,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": "JDP-3",
              "style_id": "JDP-S-3",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "http://www.tenyokai.com/history.html"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E7%A3%AF%E6%AD%A3%E6%99%BA"
            }
          ],
          "source_yaml": "database/persons/JPN/Iso_Masatomo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-3",
          "name": "Iso Masatari Mataemon",
          "native_name": {
            "name": "磯又右衛門",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1790,
            "location": "Matsuzaka",
            "country_code": "JPN"
          },
          "death": {
            "date": 1863,
            "location": "Otamagaike",
            "country_code": "JPN"
          },
          "teachers": [
            {
              "name": "Hitotsu Yanagi Oribe",
              "style_id": "JDP-S-3",
              "place": null,
              "quality": null,
              "period": {
                "start": 1785,
                "end": 1792
              }
            },
            {
              "name": "Homma Jouemon",
              "style": "Shin no Shinto-ryu",
              "place": null,
              "quality": null,
              "period": {
                "start": 1792,
                "end": 1798
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "http://www.tenyokai.com/history.html"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E7%A3%AF%E5%8F%88%E5%8F%B3%E8%A1%9B%E9%96%80"
            }
          ],
          "source_yaml": "database/persons/JPN/Iso_Masatari_Mataemon.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-119",
          "name": "Ishikawa Takahiko",
          "native_name": {
            "name": "石川隆彦",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1917-05-15",
            "location": "Mitoyo, Kagawa",
            "country_code": "JPN"
          },
          "death": {
            "date": "2008-06-09",
            "location": null,
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/c/c6/Takahiko_Ishikawa_%281949%29.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Takahiko_Ishikawa#/media/File:Takahiko_Ishikawa_(1949).jpg",
              "cite": " Takahiko Ishikawa (1949) (Wikipedia Commons)"
            }
          },
          "description": {
            "en": "Takahiko Ishikawa (石川隆彦, Ishikawa Takahiko, 1917–2008) was an All Japan Judo Champion. In the 1949 All-Japan Judo Championships Tahahiko fought Masahiko Kimura to a draw. In the following year he became the champion and subsequently placed three more times in the semi-finals and then retired.      ",
            "ja": "石川 隆彦（いしかわ たかひこ、1917年〈大正6年〉5月15日 - 2008年 〈平成20年〉6月9日）は日本の柔道家（講道館9段）。戦前から戦後に かけて昭和天覧試合準優勝、第2回・第3回全日本選手権優勝等の成績を 残し、晩年は米国で柔道普及を行った。身長175cm、体重82kg。"
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "9 dan",
              "date": 1984,
              "sources": [
                {
                  "uri": "https://ja.wikipedia.org/wiki/%E7%9F%B3%E5%B7%9D%E9%9A%86%E5%BD%A6",
                  "cite": "石川隆彦 (Wikipedia)",
                  "citation": "1963年に8段を許され、1984年の講道館創立100周年記念に際して9段へ昇段。"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E7%9F%B3%E5%B7%9D%E9%9A%86%E5%BD%A6"
            },
            {
              "uri": "https://www.usjf.com/takahiko-ishikawa/"
            }
          ],
          "source_yaml": "database/persons/JPN/Ishikawa_Takahiko.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-10",
          "name": "Inoe Keitaro",
          "native_name": {
            "name": "井上敬太郎",
            "lang": "ja"
          },
          "aka": [
            {
              "name": "Okusawa Keitaro"
            },
            {
              "native_name": {
                "name": "奥澤敬太郎",
                "lang": "ja"
              }
            }
          ],
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1847,
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "death": {
            "date": "1912-09-23",
            "location": null,
            "country_code": "JPN"
          },
          "teachers": [
            {
              "id": "JDP-3",
              "style_id": "JDP-S-3",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            },
            {
              "name": "Okuzawa Sanzo",
              "style": "Kiraku-ryu",
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%A5%A5%E6%BE%A4%E6%95%AC%E5%A4%AA%E9%83%8E"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E6%A8%AA%E5%B1%B1%E4%BD%9C%E6%AC%A1%E9%83%8E"
            }
          ],
          "source_yaml": "database/persons/JPN/Inoue_Keitaro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-31",
          "name": "Iizuka Kunisaburō",
          "native_name": {
            "name": "飯塚 国三郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1875-02-13",
            "location": "Mikamo",
            "country_code": "JPN"
          },
          "death": {
            "date": "1958-07-25",
            "location": null,
            "country_code": null
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/7/79/Iiduka_kunisaburo.jpg",
          "teachers": [
            {
              "id": "JDP-9",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1891,
                "end": null
              },
              "quality": null
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "10 dan",
              "date": 1946,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://ejmas.com/jcs/jcsart_svinth_0702.htm"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E9%A3%AF%E5%A1%9A%E5%9B%BD%E4%B8%89%E9%83%8E"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q6444749",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Kunisaburo_Iizuka",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Iizuka_Kunisaburu.yaml",
          "photo_url_local": "images/cache/4f34b5221e2c9496072d5abbecb3e67b.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-116",
          "name": "Iizasa Shuri-no-suke Morisada",
          "native_name": {
            "name": "飯篠修理亮盛貞",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/a/ad/XVIII_Dai_S%C5%8Dke_Iizasa_Shuri-no-suke_Morisada.jpg",
            "source": {
              "uri": "https://commons.wikimedia.org/wiki/File:XVIII_Dai_S%C5%8Dke_Iizasa_Shuri-no-suke_Morisada.jpg",
              "cite": "XVIII Dai Sōke Iizasa Shuri-no-suke Morisada (Wikimedia Commons)"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2
            }
          ],
          "rank": [
            {
              "style": "JDP-S-6",
              "org": null,
              "teacher": null,
              "rank": "Soke",
              "date": null,
              "sources": [
                {
                  "uri": "https://inoshishikukan.com/budo/katori/woman-of-katori-shinto-ryu",
                  "cite": "Women of Katori Shintō-ryū",
                  "citation": "In the official history of our school, the 18th Soke Iizasa Morisada died suddenly, without a male successor. For a time, under these conditions, the school was then led by the then Shihan with Yamaguchi Kumajiro as Kyoju."
                }
              ]
            }
          ],
          "sources": [
            {
              "uri": "https://shinbukan-katorishintoryu.org/?page_id=898&lang=en"
            },
            {
              "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/"
            },
            {
              "uri": "https://inoshishikukan.com/budo/katori/woman-of-katori-shinto-ryu"
            },
            {
              "uri": "https://shinbukan-katorishintoryu.org/?page_id=927&lang=ja",
              "citation": "天真正伝香取神道流 (天真正伝香取神道流)"
            }
          ],
          "source_yaml": "database/persons/JPN/Iizasa_Morisada.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-5",
          "name": "Iikubo Tsunetoshi",
          "aka": [
            {
              "name": "Iikubo Kōnen"
            }
          ],
          "native_name": {
            "name": "飯久保鍬吉恒年先生",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1835,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": 1889,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": "JDP-6",
              "style_id": "JDP-S-2",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E8%B5%B7%E5%80%92%E6%B5%81"
            },
            {
              "uri": "https://doi.org/10.18002/rama.v9i2.1162"
            },
            {
              "uri": "https://books.google.pt/books/about/Judo_Memoirs_of_Jigoro_Kano.html?id=DT8rLOzndekC",
              "events": [
                "birth"
              ]
            },
            {
              "uri": "https://www.cismeurope.org/history-judo/",
              "events": [
                "birth death"
              ]
            }
          ],
          "source_yaml": "database/persons/JPN/Iikubo_Tsunetoshi.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-77",
          "name": "Hirano Yuzo",
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/hirano_202402/hirano.png",
            "source": {
              "uri": "https://orca.cardiff.ac.uk/id/eprint/136518/"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://www.abola.pt/espaco-universidade/noticias/os-primordios-do-jujutsu-em-portugal-artigo-de-vitor-rosa-147-2023080911320721614"
            },
            {
              "uri": "https://orca.cardiff.ac.uk/id/eprint/136518/"
            },
            {
              "uri": "https://judolandia.tripod.com/histport.htm"
            }
          ],
          "source_yaml": "database/persons/JPN/Hirano_Yuzo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-91",
          "name": "Hirano Tokio",
          "native_name": {
            "name": "平野時男",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1922-10-06",
            "location": "Awaji-shima",
            "country_code": "JPN"
          },
          "death": {
            "date": "1993-07-26",
            "location": null,
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://archive.org/download/tokio_hirano/tokio_hirano.jpg",
            "source": {
              "uri": "https://www.facebook.com/267050263349461/photos/pb.100063573521426.-2207520000/418174741570345/?type=3",
              "cite": "Tokio Hirano - (Official) Facebook"
            }
          },
          "teachers": [
            {
              "id": "JDP-90",
              "style_id": "JDP-S-1",
              "place": "Budō Senmon Gakko",
              "quality": 2,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio's_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques",
                  "cite": "De Crée, Carl. (2014). Nanatsu-no-kata, Endō-no-kata, and Jōge-no-kata ―A pedagogical and qualitative biomechanical evaluation of Hirano Tokio’s kuzushi (unbalancing) concept as part of skill acquisition for throwing techniques in Kōdōkan jūdō. Revista de Artes Marciales Asiáticas. 9. 69-96. 10.18002/rama.v9i2.1162.",
                  "citation": "While still at Kyōto, Hirano later also became an uchi deshi to Ushijima Tatsukuma"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "8 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio's_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques",
                  "cite": "De Crée, Carl. (2014). Nanatsu-no-kata, Endō-no-kata, and Jōge-no-kata ―A pedagogical and qualitative biomechanical evaluation of Hirano Tokio’s kuzushi (unbalancing) concept as part of skill acquisition for throwing techniques in Kōdōkan jūdō. Revista de Artes Marciales Asiáticas. 9. 69-96. 10.18002/rama.v9i2.1162.",
                  "citation": "Hirano Tokio, then 8th dan, passed away on 26 July 1993"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judoinfo.com/hirano/"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%B9%B3%E9%87%8E%E6%99%82%E7%94%B7"
            },
            {
              "uri": "https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio's_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q21701522",
              "cite": "Wikidata"
            }
          ],
          "source_yaml": "database/persons/JPN/Hirano_Tokio.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-113",
          "name": "Hayashi Yazaemon",
          "native_name": {
            "name": "林弥左衛門",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1892",
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": "1964",
            "location": null,
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://archive.org/download/hayashi-yazaemon-sensei/Hayashi-Yazaemon-sensei.jpg",
            "source": {
              "uri": "https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/",
              "cite": "Hayashi Yazaemon-sensei (Shobukan Dojo)"
            }
          },
          "teachers": [
            {
              "id": "JDP-114",
              "style_id": "JDP-S-6",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
                  "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
                  "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô (...) Hayashi Saiichirô –> Hayashi Yazaemon –> Ôtake Risuke"
                },
                {
                  "uri": "https://shinbukan-katorishintoryu.org/?page_id=898&lang=en",
                  "cite": "Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo",
                  "citation": "Shinbukan Dojo’s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."
                }
              ]
            }
          ],
          "rank": [
            {
              "style": "JDP-S-6",
              "org": null,
              "teacher": "JDP-114",
              "rank": "Gokui kaiden",
              "date": null,
              "sources": [
                {
                  "uri": "https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/",
                  "cite": "Otake Risuke Nippon Budōkan Magazine Interview (Shobukan Dojo)",
                  "citation": "Ōtake: Hayashi-sensei, of course with his skill as a Gokui Kaiden holder of Katori Shintō-ryū, but also with his gentle and sincere character, was loved by his students as if he were the most affectionate father."
                }
              ]
            }
          ],
          "sources": [
            {
              "uri": "https://katorivietnam.org/otake-risuke-nippon-budokan-magazine-interview-about-katori-shinto-ryu-and-its-tradition-2020/"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Risuke_Otake"
            }
          ],
          "source_yaml": "database/persons/JPN/Hayashi_Yazaemon.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-114",
          "name": "Hayashi Sakuichiro",
          "native_name": {
            "name": "林作一郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": "JPN"
          },
          "teachers": [
            {
              "id": "JDP-115",
              "style_id": "JDP-S-6",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
                  "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
                  "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô (...) Hayashi Saiichirô –> Hayashi Yazaemon –> Ôtake Risuke"
                },
                {
                  "uri": "https://shinbukan-katorishintoryu.org/?page_id=898&lang=en",
                  "cite": "Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo",
                  "citation": "Shinbukan Dojo’s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."
                }
              ]
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://shinbukan-katorishintoryu.org/?page_id=898&lang=en"
            }
          ],
          "source_yaml": "database/persons/JPN/Hayashi_Sakuichiro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-92",
          "name": "Funakoshi Gigō",
          "native_name": {
            "name": "船越義豪",
            "lang": "ja"
          },
          "aka": [
            {
              "name": "Funakoshi Yoshitaka"
            }
          ],
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1906",
            "location": "Okinawa",
            "country_code": "JPN"
          },
          "death": {
            "date": "1945-11-24",
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Gigo_funakoshi.jpg/200px-Gigo_funakoshi.jpg",
            "source": {
              "uri": "https://ja.wikipedia.org/wiki/%E8%88%B9%E8%B6%8A%E7%BE%A9%E8%B1%AA#/media/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB:Gigo_funakoshi.jpg"
            }
          },
          "teachers": [
            {
              "id": "JDP-41",
              "style_id": "JDP-S-5",
              "place": null,
              "quality": 2,
              "period": {
                "start": 1918,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://en.wikipedia.org/wiki/Gig%C5%8D_Funakoshi",
                  "citation": "He was sickly as a child and began the formal study of karate-do at the age of twelve as a means to improve his health.[4] In the early years, Gichin Funakoshi often took Gigo with him to his trainings with Yasutsune Itosu"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-5",
              "org": null,
              "teacher": "JDP-41",
              "rank": "10 dan",
              "date": null,
              "quality": 1,
              "sources": [
                {
                  "uri": "https://en.wikipedia.org/wiki/Gig%C5%8D_Funakoshi",
                  "citation": "10th dan, successor waka (後継者) sensei to his father"
                }
              ],
              "style": "Karate",
              "style_native": {
                "name": "空手",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-5",
              "org": "Dai-Nippon Butoku Kai",
              "teacher": null,
              "rank": "Renshi",
              "date": null,
              "sources": [
                {
                  "uri": "https://ryukyu-bugei.com/?p=7840",
                  "citation": "Renshi title holders are Ōtuska Hironori (Wadō-ryū), Funakoshi Gigo (Shōtōkan, Funakoshi Gichin (Shōtōkan)"
                }
              ],
              "style": "Karate",
              "style_native": {
                "name": "空手",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Gig%C5%8D_Funakoshi"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E8%88%B9%E8%B6%8A%E7%BE%A9%E8%B1%AA"
            },
            {
              "uri": "https://shotokai.com/gigo-yoshitaka-funakoshi/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q628761",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Gig%C5%8D_Funakoshi",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Funakoshi_Gigo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-41",
          "name": "Funakoshi Gichin",
          "native_name": {
            "name": "船越 義珍",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1868-10-11",
            "location": "Shuri, Okinawa",
            "country_code": "JPN"
          },
          "death": {
            "date": "1957-04-26",
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "photo_url": "https://upload.wikimedia.org/wikipedia/commons/1/1d/EVD-kumite-002.jpg",
          "teachers": [
            {
              "id": "JDP-56",
              "style_id": "JDP-S-13",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Asato",
                  "citation": "Anko Asato (安里 安恒, Asato Ankō, Azato Yasutsune in Japanese, 1827 – 1906) was a Ryūkyūan master of karate. He and Ankō Itosu were the two main karate masters who taught Gichin Funakoshi, the founder of Shotokan karate."
                }
              ]
            },
            {
              "id": "JDP-55",
              "style_id": "JDP-S-13",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Asato",
                  "citation": "Anko Asato (安里 安恒, Asato Ankō, Azato Yasutsune in Japanese, 1827 – 1906) was a Ryūkyūan master of karate. He and Ankō Itosu were the two main karate masters who taught Gichin Funakoshi, the founder of Shotokan karate."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Gichin_Funakoshi"
            },
            {
              "uri": "https://judoinfo.com/karateranks/"
            },
            {
              "uri": "https://search.worldcat.org/title/7673297"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q41105",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Gichin_Funakoshi",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Funakoshi_Gichin.yaml",
          "photo_url_local": "images/cache/3bd273efb342fd77de8cd38ab0974a11.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-57",
          "name": "Fukuda Keiko",
          "native_name": {
            "name": "福田 敬子",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1913-04-12",
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "death": {
            "date": "2013-02-09",
            "location": "San Francisco",
            "country_code": "USA"
          },
          "description": {
            "en": "Keiko Fukuda (Japanese: 福田 敬子, Hepburn: Fukuda Keiko, April 12, 1913 – February 9, 2013) was a Japanese-American martial artist. She was the highest-ranked female judoka in history, holding the rank of 9th dan from the Kodokan (2006), and 10th dan from USA Judo (July 2011) and from the United States Judo Federation (USJF) (September 2011), and was the last surviving student of Kanō Jigorō, founder of judo. She was a renowned pioneer of women's judo, together with her senpai Masako Noritomi (1913–1982) being the first woman promoted to 6th dan (c. 1972). In 2006 the Kodokan promoted Fukuda to 9th dan.[8] She is also the first and, so far, only woman to have been promoted to 10th dan in the art of judo."
          },
          "photo": {
            "url": "https://assets.change.org/photos/7/kx/tf/pUKxTfavKIGEOvT-800x450-noPad.jpg",
            "source": {
              "uri": "https://www.change.org/p/uemura-haruki-demand-10th-degree-black-belt-for-keiko-fukuda",
              "cite": "Change.org - Keiko Fukuda 10th dan petition"
            }
          },
          "teachers": [
            {
              "id": "JDP-1",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1935,
                "end": 1966
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29",
                  "cite": "Johnson, G. (1974): «A single reed that bends gracefully in the wind.» Black Belt, 12(6):28–33.",
                  "citation": "Keiko Fukuda is the granddaughter of Professor Jigoro Kano's first jujitsu instructor. She began studying the art at Professor Kano's request at age 21 and since that time has taught in Australia,Canada, the Philippines, the U.S. and, of course, the Kodokan where she has received all her promotions (...) In the Kodokan, sometimes we would sit around the mat with Professor Kano and just talk and ask questions so we would know what each other was thinking"
                }
              ]
            },
            {
              "id": "JDP-11",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": 1935,
                "end": 1966
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29",
                  "cite": "Johnson, G. (1974): «A single reed that bends gracefully in the wind.» Black Belt, 12(6):28–33.",
                  "citation": "Miss Fukuda, describing her training with the late Professor Kyuzo Mifune (10th dan) (...)"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Kodokan",
              "teacher": null,
              "rank": "9 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-1",
              "org": "USJF",
              "teacher": null,
              "rank": "10 dan",
              "date": null,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Keiko_Fukuda"
            },
            {
              "uri": "https://www.usjf.com/2018/02/keiko-fukuda/"
            },
            {
              "uri": "https://judoinfo.com/fukuda/"
            },
            {
              "uri": "https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29"
            },
            {
              "uri": "https://stephdavis.co/blog/a-living-legend-judo-master-keiko-fukuda/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q460890",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Keiko_Fukuda",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Fukuda_Keiko.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-2",
          "name": "Fukuda Hachinosuke",
          "native_name": {
            "name": "福田八之助",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1828,
            "location": "Nagatoro",
            "country_code": "JPN"
          },
          "death": {
            "date": "1879-08-14",
            "location": null,
            "country_code": "JPN"
          },
          "teachers": [
            {
              "id": "JDP-4",
              "style_id": "JDP-S-3",
              "place": "Otamagaike dojo",
              "quality": null,
              "period": {
                "start": 1851,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "http://www.tenyokai.com/history.html"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E7%A6%8F%E7%94%B0%E5%85%AB%E4%B9%8B%E5%8A%A9"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q22124384",
              "cite": "Wikidata"
            }
          ],
          "source_yaml": "database/persons/JPN/Fukuda_Hachinosuke.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-93",
          "name": "Egami Shigeru",
          "native_name": {
            "name": "江上 茂",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1912-12-07",
            "location": "Ōmuta",
            "country_code": "JPN"
          },
          "death": {
            "date": "1981-01-08",
            "location": "Tokyo",
            "country_code": "JPN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/en/f/f4/Egami.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Shigeru_Egami#/media/File:Egami.jpg"
            }
          },
          "teachers": [
            {
              "id": "JDP-41",
              "style_id": "JDP-S-5",
              "place": null,
              "quality": 2,
              "period": {
                "start": 1930,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://shotokai.com/shigeru-egami/",
                  "cite": "Master Shigeru Egami, O-sensei’s successor (1912-1981) (Shotokai Encyclopedia)",
                  "citation": "Egami met Master Funakoshi when he was 18 years old, the moment he began studying at the famous Waseda University, there he helped to establish its Karate Do Club. (...)  He followed his Master together with Yoshitaka Funakoshi and Takeshi Shimoda all around Japan staging exhibitions, trying to expand the knowledge of Karate-do as a Japanese martial art."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null,
              "quality": null
            }
          ],
          "sources": [
            {
              "uri": "https://www.shotokai.jp/en_about/en_teacher/en_egami/"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Shigeru_Egami"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E6%B1%9F%E4%B8%8A%E8%8C%82"
            },
            {
              "uri": "https://budojapan.com/karate/20230608se/"
            },
            {
              "uri": "https://shotokai.com/shigeru-egami/"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q1246030",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Shigeru_Egami",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Egami_Shigeru.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-56",
          "name": "Asato Ankō",
          "native_name": {
            "name": "安里 安恒",
            "lang": "ryu"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": 1827,
            "location": "Shuri, Okinawa",
            "country_code": "JPN"
          },
          "death": {
            "date": 1903,
            "location": null,
            "country_code": null
          },
          "photo_url": "https://archive.org/download/anko-asato/Anko-Asato.jpg",
          "teachers": [
            {
              "id": "JDP-54",
              "style_id": "JDP-S-13",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Asato",
                  "citation": "In a 1934 article, Funakoshi noted that Asato and Itosu had studied karate together under Sōkon Matsumura."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%AE%89%E9%87%8C%E5%AE%89%E6%81%92"
            },
            {
              "uri": "https://www.world-traditional-karate-federation.com/anko-asato-move-to-tokyo.html"
            },
            {
              "uri": "https://web.archive.org/web/20100227032428/http://www.shotokai.jp/english/about/teacher.html"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q721201",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Ank%C5%8D_Asato",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Asato_Anko.yaml",
          "photo_url_local": "images/cache/b76050a70bf8ad93156f68171d1b25fd.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-58",
          "name": "Abbe Kenshirõ",
          "native_name": {
            "name": "阿部 謙四郎",
            "lang": "ja"
          },
          "nationality": [
            "JPN"
          ],
          "birth": {
            "date": "1915-12-15",
            "location": "Tokushima",
            "country_code": "JPN"
          },
          "death": {
            "date": "1985-12-01",
            "location": "Tokushima",
            "country_code": "USA"
          },
          "description": {
            "en": "Kenshiro Abbe was a prominent Japanese master of judo, aikido, and kendo. He introduced aikido to the United Kingdom in 1955, and founded the Kyushindo system.  Abbe was a graduate of the Budo Senmon Gakko, having studied judo and kendo there. Following an illustrious early career in the martial arts, he served in the Imperial Japanese Army before and during World War II. He then trained in aikido under its founder, Morihei Ueshiba, for a decade. Abbe held dan ranks in several martial arts, most notably 8th dan in judo, 6th dan in aikido, and 6th dan in kendo. After introducing aikido to the UK, he established several Japanese martial arts councils there during the late 1950s. He returned to Japan in 1964 and remained there for most of the remainder of his life."
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/en/thumb/5/56/Kenshiro_Abbe.jpg/220px-Kenshiro_Abbe.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Kenshiro_Abbe#/media/File:Kenshiro_Abbe.jpg",
              "cite": "Kenshiro Abbe - Wikipedia (original from Kendo Nagasaki, http://kendonagasaki.org/)"
            }
          },
          "teachers": [
            {
              "id": "JDP-59",
              "style_id": "JDP-S-8",
              "place": "Budō Senmon Gakko",
              "period": {
                "start": 1934,
                "end": 1945
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm",
                  "cite": "Kenshiro Abbe, The Kyu-Shin-Do And Zen Judo - Keo Cavalcanti, 6th Dan Zen Judo",
                  "citation": "At the Busen Abbe received instruction from Ogawa Hanshi (genius), the Butokukai Judan (10th Dan) sword master. While at the Busen Kenshiro also enrolled in Mr. Gen Tanabe's philosophy class, at the Kyoto Teikoku University. That early encounter with philosophy would be influential in the formation of his system. While the training was arduous at the Busen, Kenshiro managed to receive his Yondan (4th Dan) rank in Judo, being again the young Judoka to attain it. His sister, Toyoka, decided to take Martial Arts too, enrolling in Mrs. Mitamura's Naginata class. She would dedicate the rest of her life to the practice of the art."
                }
              ]
            },
            {
              "id": "JDP-27",
              "style_id": "JDP-S-4",
              "place": null,
              "period": {
                "start": 1937,
                "end": 1947
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm",
                  "cite": "Kenshiro Abbe, The Kyu-Shin-Do And Zen Judo - Keo Cavalcanti, 6th Dan Zen Judo",
                  "citation": "In 1937, at the age of 23, Abbe was awarded his Rokudan (6th Dan) rank and in June of that year he enlisted in the Japanese army, serving for four years in a garrison in the Toan-sho Province in Manchuria. It was during the time in Manchuria that Abbe began formulating his theory of Budo (the Way of the Warrior), Kyu-Shin-Do. And it was also at this time that Abbe was invited by O'Sensei, Morihei Ueshiba to study Aikido under his care."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-8",
              "org": "Dai-Nippon Butoku Kai",
              "teacher": null,
              "rank": "6 dan",
              "date": 1945,
              "style": "Kendo",
              "style_native": {
                "name": "剣道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-4",
              "org": null,
              "teacher": "JDP-27",
              "rank": "6 dan",
              "date": 1945,
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            },
            {
              "style_id": "JDP-S-1",
              "org": "Dai-Nippon Butoku Kai",
              "teacher": null,
              "rank": "7 dan",
              "date": 1945,
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Kenshiro_Abbe"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E9%98%BF%E9%83%A8%E8%AC%99%E5%9B%9B%E9%83%8E"
            },
            {
              "uri": "http://www.sydhoare.com/Kenshiro.pdf"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q1739011",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Keiko_Fukuda",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/JPN/Abe_Kenshiro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-69",
          "name": "Frigyes Tӧrӧk",
          "aka": [
            {
              "name": "Frigyes Vilmos Török"
            }
          ],
          "nationality": [
            "HUN"
          ],
          "birth": {
            "date": 1944,
            "location": "Budapest",
            "country_code": "HUN"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/torok_202402/torok.jpeg",
            "source": {
              "uri": "https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/",
              "cite": "ENTREVISTA – Viagem ao mundo dos homens bons (Judo Magazine)"
            }
          },
          "teachers": [
            {
              "id": "JDP-12",
              "style_id": "JDP-S-1",
              "place": "Judo Clube de Portugal",
              "quality": null,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
                  "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
                  "citation": "Em 1974, o então presidente da Federação Portuguesa de Judo, Prof. Fernando Costa Matos, sabendo da intenção do Mestre Frigyes Tӧrӧk, 3º Dan, de regressar a Portugal, vindo de Angola onde lecionava, colocou em contacto este professor de ascendência húngara e discípulo direto do Mestre Kiyoshi Kobayashi, com a Direção do Clube. "
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "FPJ",
              "teacher": null,
              "rank": "7 dan",
              "date": 2019,
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/06/Relat%C3%B3rio-Anual-FPJ-2019-23jun2020.pdf",
                  "cite": "Relatório Anual FPJ 2019",
                  "citation": "Os Diplomas de 7.º Dan foram atribuídos aos Mestres António Roquete de Andrade, Artur Alves da Mata, José Pinto Farias, Nelson Trindade e Frygyes Torok"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judolandia.tripod.com/torok.htm"
            },
            {
              "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf"
            },
            {
              "uri": "https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/"
            },
            {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html"
            }
          ],
          "source_yaml": "database/persons/HUN/Frigyes_Torok.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-125",
          "name": "Yves Klein",
          "nationality": [
            "FRA"
          ],
          "birth": {
            "date": "1928-04-28",
            "location": "Nice",
            "country_code": "FRA"
          },
          "death": {
            "date": "1962-06-06",
            "location": "Paris",
            "country_code": "FRA"
          },
          "photo": {
            "url": "https://www.radiofrance.fr/s3/cruiser-production/2023/12/8d7118cf-6be3-4573-8886-fd621281f20d/860_sc_photo-file-597.webp",
            "source": {
              "uri": "https://www.radiofrance.fr/francebleu/podcasts/les-pourquoi-de-la-cote-d-azur/pourquoi-7150784",
              "cite": "Pourquoi un judoka niçois est-il devenu le maître du bleu ? - Radio France"
            }
          },
          "teachers": [
            {
              "id": "JDP-124",
              "style_id": "JDP-S-1",
              "place": "Kodokan",
              "period": {
                "start": "1952",
                "end": "1954"
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://theeverydaypress.net/the-foundations-of-judo/",
                  "cite": "THE FOUNDATIONS OF JUDO - The Everyday Press",
                  "citation": "In the early 1950s, the 24-year-old Yves Klein spent a year and a half in Tokyo, studying mainly at the Kodokan under the ninth-dan judo master Oda"
                }
              ]
            },
            {
              "id": "JDP-124",
              "style_id": "JDP-S-1",
              "place": "Municipal Police of Tokyo",
              "period": {
                "start": "1952",
                "end": "1954"
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://www.ianwhittlesea.net/works_pages/wks_klein/wks_klein1.html",
                  "cite": "The Foundations of Judo - Ian Whittlesea",
                  "citation": "He has spent this time solely studying Judo... with the Municipal Police of Tokyo under Master Oda"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "rank": "4 dan",
              "date": "1954",
              "org": "Kodokan",
              "quality": 3,
              "sources": [
                {
                  "uri": "https://www.yvesklein.com/en/yves-klein/",
                  "cite": "Yves Klein - Official Website",
                  "citation": "Shortly before his return, he obtained his 4th dan in judo, thus reaching the highest level in Europe"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://theeverydaypress.net/the-foundations-of-judo/"
            },
            {
              "uri": "https://www.ianwhittlesea.net/works_pages/wks_klein/wks_klein1.html"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Yves_Klein"
            },
            {
              "uri": "https://fr.wikipedia.org/wiki/Yves_Klein"
            },
            {
              "uri": "https://www.yvesklein.com/en/yves-klein/"
            },
            {
              "uri": "https://walkerart.org/magazine/yves-klein-the-judoka/"
            }
          ],
          "source_yaml": "database/persons/FRA/Yves_Klein.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-78",
          "name": "Jackie Hugnet",
          "nationality": [
            "FRA"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": "2 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
                  "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
                  "citation": "Determinado em encontrar professores que o ajudassem a criar um Dojo, conheceu no então Parque de Campismo do Lima o francês Mestre Hugnet. Não podendo ficar em Portugal, mas sensível à determinação de Manuel Reis, enviou o seu irmão, Jackie Hugnet, 2º Dan, para o Porto."
                }
              ]
            }
          ],
          "sources": [
            {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html"
            },
            {
              "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf"
            }
          ],
          "source_yaml": "database/persons/FRA/Jackie_Hugnet.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-68",
          "name": "Henri Bouchend'Homme",
          "nationality": [
            "FRA"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null,
              "sources": [
                {
                  "uri": "https://judolandia.tripod.com/histport.htm",
                  "cite": "História do Judo em Portugal (Judolândia, texto de «Judo: da iniciação à competição», Costa Branco et. al",
                  "citation": "Ainda neste ano vem para Lisboa, integrando-se no  corpo docente do  Liceu Francês Charles Lepierre, Henri Bouchend'Homme - professor de Educação Física e 1º Dan. Henri Bouchend’ Homme vendo que não se praticava Judo em Lisboa começou a leccionar no Lisboa Ginásio."
                }
              ]
            }
          ],
          "sources": [
            {
              "uri": "https://judolandia.tripod.com/histport.htm"
            }
          ],
          "source_yaml": "database/persons/FRA/Henri_Bouchend_Homme.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-79",
          "name": "Gilbert Briskine",
          "nationality": [
            "FRA"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": "FFJDA",
              "teacher": null,
              "rank": "4 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
                  "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
                  "citation": "No Verão de 1961, o professor Hugnet é substituído pelo também francês, Gilbert Bryskine, 4º Dan, campeão de França, bicampeão da Europa (1952 e 1954) e professor diplomado pela Federação Francesa de Judo e Ju Jutsu."
                }
              ]
            }
          ],
          "sources": [
            {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html"
            },
            {
              "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf"
            },
            {
              "uri": "https://www.fnkp.pt/historia/"
            },
            {
              "uri": "https://www.judoinside.com/judoka/5062/Gilbert_Briskine/judo-career"
            }
          ],
          "source_yaml": "database/persons/FRA/Gilbert_Briskine.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-109",
          "name": "Erich Rahn",
          "nationality": [
            "DEU"
          ],
          "birth": {
            "date": "1885-05-01",
            "location": "Berlin",
            "country_code": "DEU"
          },
          "death": {
            "date": "1973-07-05",
            "location": "Berlin",
            "country_code": "DEU"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/d/da/Bundesarchiv_Bild_102-12574%2C_Berlin%2C_Jiu-Jitsu-Schule.jpg",
            "source": {
              "uri": "https://de.wikipedia.org/wiki/Erich_Rahn#/media/Datei:Bundesarchiv_Bild_102-12574,_Berlin,_Jiu-Jitsu-Schule.jpg",
              "cite": "Erich Rahn (below) performing an overhead throw (Tomoe-nage), November 1931 (Wikipedia)"
            }
          },
          "teachers": [
            {
              "name": "Higashi",
              "style_id": "JDP-S-14",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://de.wikipedia.org/wiki/Erich_Rahn"
            },
            {
              "uri": "https://judoencyclopedia.jimdofree.com/internationalization-diffusion-of-judo/"
            }
          ],
          "source_yaml": "database/persons/DEU/Erich_Rahn.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-110",
          "name": "Alfred Rhode",
          "aka": [
            {
              "name": "Alfred Werner Carl Rhode"
            }
          ],
          "nationality": [
            "DEU"
          ],
          "birth": {
            "date": "1896-08-16",
            "location": "Steinwalde",
            "country_code": "DEU"
          },
          "death": {
            "date": "1978-09-13",
            "location": "Sprendlingen",
            "country_code": "DEU"
          },
          "photo": {
            "url": "https://archive.org/download/alfred_rhode/alfred_rhode.jpg",
            "source": {
              "uri": "https://www.bath.ac.uk/library/cabinet-of-curiosities/story/45",
              "cite": "Yannick SCHULTZE - Die «Internationale Judo-Sommerschule»"
            }
          },
          "teachers": [
            {
              "id": "JDP-109",
              "style_id": "JDP-S-14",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://books.google.de/books?id=Oa8Cdh9UVrIC",
                  "cite": "WEDEMEYER-KOLWE, Bernd. «Der neue Mensch»: Körperkultur im Kaiserreich und in der Weimarer Republik. Königshausen & Neumann, 2004, p. 308",
                  "citation": "(...) 1922 gründete der Rahn-Schüler Alfred Rohde dann den 1. Deutschen Judo-Club in Frankfur (...)"
                },
                {
                  "uri": "https://link.springer.com/chapter/10.1057/9781137573971_6",
                  "cite": "PANZER, Sarah. When Jiu-Jitsu was German: Japanese Martial Arts in German Sport-and Körperkultur, 1905–1933. In: Transnational Encounters between Germany and Japan: Perceptions of Partnership in the Nineteenth and Twentieth Centuries. New York: Palgrave Macmillan US, 2016. p. 91-106.",
                  "citation": "The first German judo club was formed in 1922 in Frankfurt by Alfred Rhode, a former student of Erich Rahn. For several years, jiu-jitsu and judo coexisted relatively collegially in Germany, most likely because the still relatively small community of instructors and active participants made cooperation necessary if either discipline was to survive"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Deutsches-Dan Kollegium",
              "teacher": null,
              "rank": "8 dan",
              "date": "1976-08-16",
              "sources": [
                {
                  "uri": "http://www.lothar-nest.de/ln0243/ddk1932.html",
                  "cite": "Sportschule Lothar Nest: Judo - Sommerschule 1932 in Frankfurt a.M. aus den Unterlagen von Dieter Schiemann",
                  "citation": "Doris Schiemann und ihr Sohn Holger überbringen Lothar Nest mehrere Kartons aus dem Nachlaß von Dieter Schiemann, - er war Schatzmeister des DDK/DJB in den 60er Jahren und überreichte Alfred Rhode am 16.8.1076 die Urkunde zum 8.DAN DDK/DJB! Alfred Rhode gründete 1952 das DDK."
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://de.wikipedia.org/wiki/Alfred_Rhode"
            },
            {
              "uri": "https://www.judobund.de/ueber-uns/judo-und-seine-geschichte"
            },
            {
              "uri": "https://www.ijf.org/history/from-martial-art-to-olympic-sport/1129"
            },
            {
              "uri": "https://www.bath.ac.uk/library/cabinet-of-curiosities/story/45"
            },
            {
              "uri": "http://www.lothar-nest.de/ln0243/ddk1932.html"
            },
            {
              "uri": "https://www.1djc.de/judobilder1952.html"
            }
          ],
          "source_yaml": "database/persons/DEU/Alfred_Rhode.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-118",
          "name": "Zhang Zhaodong",
          "native_name": {
            "name": "張兆東",
            "lang": "zh"
          },
          "nationality": [
            "CHN"
          ],
          "birth": {
            "date": "1865",
            "location": null,
            "country_code": "CHN"
          },
          "death": {
            "date": "1938",
            "location": "Tianjin",
            "country_code": "CHN"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/b/b1/250_Bagau016ChangChaoDong.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Baguazhang#/media/File:250_Bagau016ChangChaoDong.jpg",
              "cite": "Xingyi/Baguazhang master Chang Chan Kuei (1859–1940) [Wikipedia Commons]"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://zh.wikipedia.org/w/index.php?title=%E5%BC%B5%E5%8D%A0%E9%AD%81"
            },
            {
              "uri": "https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274"
            }
          ],
          "source_yaml": "database/persons/CHN/Zhang_Zhaodong.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-117",
          "name": "Wang Shujin",
          "aka": [
            {
              "name": "Wang Heng Sun"
            }
          ],
          "nationality": [
            "CHN",
            "TWN"
          ],
          "birth": {
            "date": "1904",
            "location": null,
            "country_code": "CHN"
          },
          "death": {
            "date": "1981",
            "location": "Taipei",
            "country_code": "TWN"
          },
          "photo": {
            "url": "https://archive.org/download/wang-hawk-posture/Wang-hawk-posture.jpg",
            "source": {
              "uri": "https://blog.awma.com/man-of-steel/wang-hawk-posture/",
              "cite": "Wang [Shujin] hawk posture (AWMA)"
            }
          },
          "teachers": [
            {
              "id": "JDP-118",
              "style_id": "JDP-S-17",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274",
                  "cite": "Martial arts fight for survival (Taipei Times)",
                  "citation": " By chance one day, a senior student of the famous martial arts master Zhang Zhao-dong came to the business where Wang worked. (...)  Under Zhang's instruction, Wang learned the two arts for which he would later become famous; pa kua chang and hsing yi chuan. Pa kua chang means \"eight diagram palms\" and refers to the eight core diagrams which make up the I-Ching (易經, Book of Changes), one of the most important books of classical Chinese philosophy"
                }
              ]
            },
            {
              "id": "JDP-118",
              "style_id": "JDP-S-18",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274",
                  "cite": "Martial arts fight for survival (Taipei Times)",
                  "citation": " By chance one day, a senior student of the famous martial arts master Zhang Zhao-dong came to the business where Wang worked. (...)  Under Zhang's instruction, Wang learned the two arts for which he would later become famous; pa kua chang and hsing yi chuan. Pa kua chang means \"eight diagram palms\" and refers to the eight core diagrams which make up the I-Ching (易經, Book of Changes), one of the most important books of classical Chinese philosophy"
                }
              ]
            }
          ],
          "rank": [
            {
              "style": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Wang_Shujin"
            },
            {
              "uri": "https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274"
            }
          ],
          "links": [
            {
              "uri": "https://www.wikidata.org/wiki/Q4018116",
              "cite": "Wikidata"
            },
            {
              "uri": "https://dbpedia.org/page/Wang_Shujin",
              "cite": "DBpedia"
            }
          ],
          "source_yaml": "database/persons/CHN/Wang_Shujin.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-128",
          "name": "Petrucio Monteiro",
          "aka": [
            {
              "name": "Petrucio de Queiroz Monteiro"
            }
          ],
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": "1942",
            "location": "",
            "country_code": "BRA"
          },
          "death": {
            "date": "2022",
            "location": "",
            "country_code": "BRA"
          },
          "photo": {
            "url": "https://i0.wp.com/judorio.org/wp-content/uploads/2022/04/Petrucio-Monteiro.jpg",
            "source": {
              "uri": "https://judorio.org/nota-de-pesar-falecimento-do-sensei-petrucio-de-queiroz-monteiro/",
              "cite": "Nota de pesar – Falecimento do Sensei Petrucio de Queiroz Monteiro"
            }
          },
          "teachers": [
            {
              "id": "JDP-127",
              "style_id": "JDP-S-1",
              "quality": 2,
              "place": "Academia Rudolf Hermanny",
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://benfeitoria.com/projeto/biopetrucio",
                  "cite": "Biografia Petrucio Monteiro - Benfeitoria",
                  "citation": "O professor Petrucio seguiu a linha do professor Rudolf Hermanny"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "rank": "1 dan",
              "date": "1967",
              "org": null,
              "sources": [
                {
                  "uri": "https://www.judorio.org/PDF/PETRUCIO%20MONTEIRO.pdf",
                  "cite": "Petrucio Monteiro (PDF)",
                  "citation": "Faixa preta desde 1967"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judorio.org/nota-de-pesar-falecimento-do-sensei-petrucio-de-queiroz-monteiro/"
            },
            {
              "uri": "https://benfeitoria.com/projeto/biopetrucio"
            },
            {
              "uri": "https://www.judorio.org/PDF/PETRUCIO%20MONTEIRO.pdf"
            },
            {
              "uri": "https://www.facebook.com/judopetruciomonteiro/"
            }
          ],
          "source_yaml": "database/persons/BRA/Petrucio_Monteiro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-106",
          "name": "Oswaldo Fadda",
          "aka": [
            {
              "name": "Oswaldo Baptista Fadda"
            }
          ],
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": "1920-08-01",
            "location": "Rio de Janeiro",
            "country_code": "BRA"
          },
          "death": {
            "date": "2005-04-01",
            "location": "Rio de Janeiro",
            "country_code": "BRA"
          },
          "photo": {
            "url": "https://archive.org/download/oswaldo_fadda/oswaldo_fadda.jpeg",
            "source": {
              "uri": "https://www.portaldovaletudo.com.br/fadda-e-paiva-explicam-origem-do-sapateiro-e-principais-linhagens-do-jiu-jitsu-do-suburbio-carioca/",
              "cite": "Oswaldo Fadda (Portal do Vale Tudo)"
            }
          },
          "teachers": [
            {
              "id": "JDP-20",
              "style_id": "JDP-S-16",
              "place": "Academia França de Jiu-jitsu",
              "period": {
                "start": 1938,
                "end": null
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 108",
                  "citation": "Oswaldo Fadda começou a treinar com França por volta de 1938"
                }
              ]
            },
            {
              "id": "JDP-129",
              "style_id": "JDP-S-19",
              "place": "Liga de Esportes da Marinha",
              "period": {
                "start": 1938,
                "end": null
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://www.faddabjj.com/historia-fadda",
                  "cite": "A história da Família Fadda (FaddaBJJ)",
                  "citation": "Antes da sua história com o Jiu-Jitsu, os primeiros passos de Fadda no mundo das lutas foi na \"Nobre Arte\", ou seja, no boxe, através do campeão Baltazar Cardoso."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null,
              "sources": [
                {
                  "uri": "https://bjjfanatics.com.br/blogs/news/oswaldo-fadda",
                  "cite": "Oswaldo Fadda, Um Pioneiro na Democratização do Jiu Jitsu (BJJ Fanatics)",
                  "citation": "Oswaldo Baptista Fadda, conhecido como “Mestre Fadda”, nascido 15 de janeiro de 1921 no Rio de Janeiro e falecido em 1 de abril de 2005, na mesma cidade. Fadda foi um Grande Mestre de Jiu Jitsu Brasileiro, chegando ao 9º grau (faixa vermelha), sendo o aluno mais talentoso de Luiz França, e dando continuidade ao legado de seu mestre, sendo um dos mais importantes nomes da linhagem de mestres da GF Team, como Julio Cesar e Baraúna."
                }
              ]
            }
          ],
          "sources": [
            {
              "uri": "https://pt.wikipedia.org/wiki/Oswaldo_Fadda"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://bjjfanatics.com.br/blogs/news/oswaldo-fadda"
            },
            {
              "uri": "https://web.archive.org/web/20240507104820/https://www.faddabjj.com/historia-fadda"
            }
          ],
          "source_yaml": "database/persons/BRA/Oswaldo_Fadda.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-45",
          "name": "Mario Aleixo",
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": 1887,
            "location": "Rio de Janeiro, RJ",
            "country_code": "BRA"
          },
          "death": {
            "date": 1947,
            "location": null,
            "country_code": "BRA"
          },
          "photo_url": "https://img1.wsimg.com/isteam/ip/480b94b8-cb6a-48b7-9add-7d9635474067/Aleixo_1918.jpg/:/rs=w:400,cg:true,m",
          "teachers": [
            {
              "id": "JDP-18",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1915,
                "end": null
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 1, p. 110",
                  "citation": "Mário Alexio teve o privilégio de se adestrar no Jiu Jitsu com dois dos mais experientes e famosos mestres japoneses dos ringues. Recebeu suas primeiras instruções de Sada Miyako por volta de 1909. Posteriormente teve a oportunidade de se aperfeiçoar com o grande Conde Koma, pouco depois deste chegar ao Brasil, em 1915."
                }
              ]
            },
            {
              "id": "JDP-107",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1909,
                "end": null
              },
              "quality": 3,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 1, p. 110",
                  "citation": "Mário Alexio teve o privilégio de se adestrar no Jiu Jitsu com dois dos mais experientes e famosos mestres japoneses dos ringues. Recebeu suas primeiras instruções de Sada Miyako por volta de 1909. Posteriormente teve a oportunidade de se aperfeiçoar com o grande Conde Koma, pouco depois deste chegar ao Brasil, em 1915."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://agbook.com.br/book/361393--MUITO_ANTES_DO_MMA_O_legado_dos_precursores_do_Vale_Tudo_no_Brasil_e_no_mundo"
            }
          ],
          "source_yaml": "database/persons/BRA/Mario_Aleixo.yaml",
          "photo_url_local": "images/cache/c6045e9f5e720ffc90b700bc4a13cc78.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-20",
          "name": "Luis de França Filho",
          "aka": [
            {
              "name": "Luiz França"
            }
          ],
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": "1910-06-02",
            "location": "Alagoas",
            "country_code": "BRA"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo_url": "https://ia601602.us.archive.org/29/items/luiz_franca_filho/vsr23XAf.jpg",
          "teachers": [
            {
              "id": "JDP-22",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1916,
                "end": null
              },
              "quality": 1,
              "sources": [
                {
                  "uri": "https://www.bjjheroes.com/bjj-fighters/luiz-franca",
                  "cite": "BJJ Heroes: Luiz França",
                  "citation": "There Satake settled for a while, opening his own academy in 1916, at the Atlético Clube Rio Negro, becoming the first Japanese to open a Judo/Jiu Jitsu academy in Brazil. This gym became the place where Luiz França started his life as a martial artist. Satake would also become a Brazilian citizen years later, and change his name to Antônio Soshihiro Satake."
                },
                {
                  "uri": "https://www.facebook.com/photo.php?fbid=543032192445535&id=455479647867457&set=a.455593414522747",
                  "cite": "Equipe Fadda Jiu-Jitsu (Facebook)",
                  "citation": "Antigo aluno de Soishiro Satake e Mitsuyo Maeda, Luiz França foi o fundador da linhagem (não pertencente à família Gracie) de mais sucesso no Jiu-Jitsu, uma linhagem continuada especialmente através do trabalho efetuado pelo mais proeminente e capaz aluno de França, o Mestre Oswaldo Fadda, que mais tarde formaria a sua própria escola de talentosos alunos."
                }
              ]
            },
            {
              "id": "JDP-18",
              "style_id": "JDP-S-1",
              "place": "Belém",
              "period": {
                "start": 1929,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 106",
                  "citation": "Se França se iniciou no Jiu Jitsu com o Conde Koma, muito provavelmente foi em 1929 n Marinha, quando esteve em Belém ao serviço no navio Minas Gerais."
                }
              ]
            },
            {
              "id": "JDP-103",
              "style_id": "JDP-S-1",
              "place": "Rio de Janeiro",
              "period": {
                "start": 1930,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 106",
                  "citation": "Posteriormente, deu continuidade ao seu aprendizado no Rio de Janeiro com Geo Omori, Takeo Yano e Hélio Gracie..."
                }
              ]
            },
            {
              "id": "JDP-102",
              "style_id": "JDP-S-16",
              "place": "Rio de Janeiro",
              "period": {
                "start": null,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 106",
                  "citation": "Posteriormente, deu continuidade ao seu aprendizado no Rio de Janeiro com Geo Omori, Takeo Yano e Hélio Gracie..."
                }
              ]
            },
            {
              "id": "JDP-129",
              "style_id": "JDP-S-19",
              "place": "Liga de Esportes da Marinha",
              "period": {
                "start": 1928,
                "end": null
              },
              "quality": 2,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "citation": "Foi na Marinha, em 1928, que França se iniciou nas artes marciais. Primeiro com o Boxe, sob a orientação de Balthazar Cardoso"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://repositorio.ufsc.br/handle/123456789/103771"
            },
            {
              "uri": "https://www.faddabjj.com/historia-fadda"
            },
            {
              "uri": "https://www.bjjee.com/articles/the-lost-legend-of-jacyntho-ferro-one-of-carlos-gracie-sr-s-jiu-jitsu-instructors/"
            },
            {
              "uri": "http://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            }
          ],
          "source_yaml": "database/persons/BRA/Luis_de_França_Filho.yaml",
          "photo_url_local": "images/cache/2eb49812686fa9df85178583b7666f50.jpg"
        }
      },
      {
        "data": {
          "id": "JDP-19",
          "name": "Jacinto Ferro",
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": 1881,
            "location": null,
            "country_code": "BRA"
          },
          "death": {
            "date": 1929,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/jacinto_ferro/jacinto_ferro.png",
            "source": {
              "uri": "https://simonbjj.com/ferro"
            }
          },
          "teachers": [
            {
              "id": "JDP-18",
              "style_id": "JDP-S-1",
              "place": null,
              "quality": null,
              "period": {
                "start": 1915,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 89",
                  "citation": "... Tenho [Maeda] os seguintes alunos aos quais deposito inteira confiança [...] Jacintho Ferro, Dr. Matheus Pereira, Guilherm de La Rocque, Raphael Gomes e Waldermar Gomes..."
                },
                {
                  "uri": "https://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html",
                  "cite": "Mitsuyo Maeda e o Judô Kodokan (Judo Tradicional Goshinjutsukan)",
                  "citation": "as aulas eram dadas em uma academia que Maeda abriu em 1916,nos salões do Cine Teatro Moderno, localizado ao lado da Igreja de Nazaré, hoje uma praça, as aulas eram amplamente divulgadas nos ornais para quem quisesse aprender pagando.O primeiro aluno de Maeda foi o estivador Jacinto Ferro, ex-lutador de greco-romana, Jacinto foi instrutor de Maeda e ajudou a dar aulas para o Carlos Gracie."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://repositorio.ufsc.br/handle/123456789/103771"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://www.bjjee.com/articles/the-lost-legend-of-jacyntho-ferro-one-of-carlos-gracie-sr-s-jiu-jitsu-instructors/"
            },
            {
              "uri": "https://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"
            }
          ],
          "source_yaml": "database/persons/BRA/Jacinto_Ferro.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-102",
          "name": "Hélio Gracie",
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": "1913-10-01",
            "location": "Belém",
            "country_code": "BRA"
          },
          "death": {
            "date": "2009-01-29",
            "location": "Petrópolis",
            "country_code": "BRA"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/H%C3%A9lio_Gracie_%281952%29.tif/lossy-page1-800px-H%C3%A9lio_Gracie_%281952%29.tif.jpg",
            "source": {
              "uri": "https://pt.wikipedia.org/wiki/H%C3%A9lio_Gracie#/media/Ficheiro:H%C3%A9lio_Gracie_(1952).tif",
              "cite": "Arquivo Nacional, 1952 (Hélio Gracie - Wikipedia)"
            }
          },
          "teachers": [
            {
              "id": "JDP-21",
              "style_id": "JDP-S-16",
              "place": null,
              "period": {
                "start": 1925,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 165",
                  "citation": "... meu Jiu Jitsu era muito diferente do dele. O meu fôra aprendido há muitos anos com o meu irmão Carlos..."
                },
                {
                  "uri": "https://pt.wikipedia.org/wiki/H%C3%A9lio_Gracie",
                  "citation": "Observador, Hélio passou a acompanhar, dos seus treze aos dezesseis anos, as aulas ministradas por Carlos."
                }
              ]
            },
            {
              "name": "George",
              "style_id": "JDP-S-16",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol 3, p.91",
                  "citation": "Hélio foi treinado por George para as suas primeiras lutas, antes deste romper com Carlos em 1934"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-16",
              "org": null,
              "teacher": null,
              "rank": "10 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://ge.globo.com/rj/serra-lagos-norte/noticia/2017/01/faixa-vermelha-lembra-ensinamentos-de-helio-gracie-oito-anos-apos-morte.html",
                  "citation": "Hélio Gracie foi o último condecorado com a faixa vermelha 10º grau"
                }
              ],
              "style": "Brazilian jiu-jitsu",
              "style_native": {
                "name": "Jiu-Jitsu brasileiro",
                "lang": "pt"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://pt.wikipedia.org/wiki/H%C3%A9lio_Gracie"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://bjjfanatics.com.br/blogs/news/helio-gracie-o-mestre-dos-mestres"
            }
          ],
          "source_yaml": "database/persons/BRA/Hélio_Gracie.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-108",
          "name": "George Gracie",
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": "1911",
            "location": null,
            "country_code": "BRA"
          },
          "death": {
            "date": "1986",
            "location": null,
            "country_code": "BRA"
          },
          "photo": {
            "url": "https://archive.org/download/george_gracie/george_gracie.png",
            "source": {
              "uri": "https://www.instagram.com/historyofbjj/p/C6I-H-prJB3/",
              "cite": "George Gracie (History of BJJ Instagram)"
            }
          },
          "teachers": [
            {
              "id": "JDP-21",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": null,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://judotradicionalgoshinjutsukan.blogspot.com/2010/01/topico-bubishi.html",
                  "cite": "Tópico Bubishi (Judo Tradicional Goshinjutsukan)",
                  "citation": "...O que sabemos de fato é que, Maeda ensinou Judô a Carlos Gracie em virtude da afinidade com seu pai, Gastão Gracie. Carlos por sua vez ensinou a seus demais irmãos, em especial a Hélio Gracie. Neste ponto surgem duas teorias. A primeira alega que Maeda ensinou somente o judô de Jigoro Kano a Carlos, e esse o repassou a Hélio, que era o mais franzino dos Gracie, adaptando-o com grande enfoque no Ne-waza - técnicas de solo do judô, ponto central do Gracie jiu-jitsu ou brasilian jiu-jitsu. Para compensar seu biotipo, a partir dos ensinamentos de Carlos, Hélio aprimorou a parte de solo pelo uso do dispositivo de alavanca, dando-lhe a força extra que o mesmo não dispunha. A segunda teoria, apoiada pelos Gracies, fala que Maeda era, também, exímio praticante de Ju-jutsu tradicional e foi essa a arte que ensinou aos brasileiros. Porém, em uma recente entrevista, Hélio Gracie afirma que 'Carlos lutava judô', veja a entrevista http://www.youtube.com/watch?v=BG309oqVLb4"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://www.bjjheroes.com/bjj-fighters/george-gracie-facts-and-bio"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "location": "vol III, p. 172"
            },
            {
              "uri": "https://simonbjj.com/george-gracie"
            }
          ],
          "source_yaml": "database/persons/BRA/George_Gracie.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-23",
          "name": "Donato Pires dos Reis",
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": null,
            "location": "Belém, Pará",
            "country_code": "BRA"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/donato/donato.png",
            "source": {
              "uri": "https://simonbjj.com/donato-pires",
              "cite": "Donato Pires dos Reis, RJ, 1930"
            }
          },
          "teachers": [
            {
              "id": "JDP-19",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1920,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 94",
                  "citation": "...'Oscar' muito provavelmente se trata do nome de Carlos grafado equivocadamente (...) Na notícia, 'Oscar Gracie' e Donato são apresentados como alunos do famoso esportista paraense Jacyntho Ferro, este sim, discípulo directo de Maeda..."
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://www.budokast.com.br/post/breve-hist%C3%B3ria-do-jiu-jitsu-brasileiro-parte-1"
            },
            {
              "uri": "http://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://simonbjj.com/donato-pires"
            }
          ],
          "source_yaml": "database/persons/BRA/Donato_Pires_dos_reis.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-21",
          "name": "Carlos Gracie",
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": "1902-09-14",
            "location": "Belém, Pará",
            "country_code": "BRA"
          },
          "death": {
            "date": "1994-10-07",
            "location": "Petrópolis",
            "country_code": "BRA"
          },
          "photo": {
            "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Carlos_Gracie_%281951%29_%28cropped%29.tif/lossy-page1-206px-Carlos_Gracie_%281951%29_%28cropped%29.tif.jpg",
            "source": {
              "uri": "https://en.wikipedia.org/wiki/Carlos_Gracie#/media/File:Carlos_Gracie_(1951).tif",
              "cite": "Imagem do Fundo Correio da Manhã (Carlos Gracie - Wikipedia)"
            }
          },
          "teachers": [
            {
              "id": "JDP-19",
              "style_id": "JDP-S-1",
              "place": null,
              "period": {
                "start": 1916,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol. 3, p. 94",
                  "citation": "...'Oscar' muito provavelmente se trata do nome de Carlos grafado equivocadamente (...) Na notícia, 'Oscar Gracie' e Donato são apresentados como alunos do famoso esportista paraense Jacyntho Ferro, este sim, discípulo directo de Maeda..."
                }
              ]
            },
            {
              "id": "JDP-18",
              "style_id": "JDP-S-1",
              "place": "Paysandu Sport Club",
              "period": {
                "start": 1916,
                "end": null
              },
              "quality": null,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol 3, p.91",
                  "citation": "...chefiada pelo competentissimo prof. Conde Koma. Aqui, depois de algumas demosntrações, organisou um gymnasio e eu [Carlos] fui um dos primeiros alunos [...] há registos que Maeda deu aulas, em 1916, no Paysandu Sport Club, em Belém, cidade onde Carlos residia com a sua família"
                },
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
                  "location": "vol 3, p.93",
                  "citation": "Fui aluno do célebre Conde Koma, no Pará [...] e nessa época Carlos Gracia também estava aprendendo"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": null,
              "org": null,
              "teacher": null,
              "rank": null,
              "date": null
            }
          ],
          "sources": [
            {
              "uri": "https://repositorio.ufsc.br/handle/123456789/103771"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://www.bjjee.com/articles/the-lost-legend-of-jacyntho-ferro-one-of-carlos-gracie-sr-s-jiu-jitsu-instructors/"
            },
            {
              "uri": "http://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html"
            },
            {
              "uri": "https://pt.wikipedia.org/wiki/Carlos_Gracie"
            }
          ],
          "source_yaml": "database/persons/BRA/Carlos_Gracie.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-129",
          "name": "Balthazar Cardoso",
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": null,
            "location": "São Luís, Maranhão",
            "country_code": "BRA"
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/screenshot-from-2025-05-11-16-58-43/Screenshot%20From%202025-05-11%2016-58-43.png",
            "source": {
              "uri": "https://memoria.bn.gov.br/DocReader/DocReader.aspx?bib=112518_01&Pesq=%22Balthazar%20Cardoso%22&pagfis=695",
              "cite": "Jornal dos Esportes (1931-09-28, Ed. 167, p.3)"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "quality": null,
              "place": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-19",
              "rank": "W42/L6/D8",
              "date": null,
              "org": null,
              "sources": [
                {
                  "uri": "https://boxrec.com/en/proboxer/624960",
                  "cite": "Balthazar Cardoso (Boxrec)",
                  "citation": ""
                }
              ],
              "style": "Boxing"
            }
          ],
          "sources": [
            {
              "uri": "https://boxrec.com/en/proboxer/624960"
            },
            {
              "uri": "https://www.faddabjj.com/historia-fadda"
            }
          ],
          "source_yaml": "database/persons/BRA/Balthazar_Cardoso.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-130",
          "name": "Aluizio de Melo",
          "aka": [
            {
              "name": "Professor Loanzi"
            },
            {
              "name": "Aluizio Nogueira Bandeira de Melo"
            }
          ],
          "nationality": [
            "BRA"
          ],
          "birth": {
            "date": "1893",
            "location": "Paraíba",
            "country_code": "BRA"
          },
          "death": {
            "date": "1975",
            "location": "Porto Alegre",
            "country_code": "BRA"
          },
          "photo": {
            "url": "https://archive.org/download/loanzi/loanzi.png",
            "source": {
              "uri": "https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/",
              "cite": "Dojô Professor Loanzi - Museu Virtual do Judô"
            }
          },
          "teachers": [
            {
              "id": "JDP-18",
              "style_id": "JDP-S-1",
              "period": {
                "start": "1915",
                "end": null
              },
              "place": null,
              "quality": 3,
              "sources": [
                {
                  "uri": "https://isbnsearch.org/isbn/9798639871030",
                  "cite": "SILVA & CORRÊA (2020). Muito antes do MMA",
                  "location": "vol. III, p. 111-113",
                  "citation": "aos 17 anos, teve a oportunidade de treinar Jiu Jitsu com o Conde Koma, durante a passagem da trupe japonesa pelo Nordeste do Brasil"
                },
                {
                  "uri": "https://aratabajiujitsu.com.br/a-origem-dos-arataba/",
                  "cite": "A Origem dos Arataba (Arataba Jiu-Jitsu)",
                  "citation": "Todo mundo sabe que Mitsuyo Maeda, o Conde Koma, radicou-se no norte do Brasil por volta de 1913 e ensinou jiu-jitsu para diversas pessoas, dentre as quais posso citar Carlos Gracie, Luiz França e Aluizio de Melo"
                },
                {
                  "uri": "https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/",
                  "cite": "Dojô Professor Loanzi - Museu Virtual do Judô",
                  "citation": "QUEM FOI ALOIZIO NOGUEIRA BANDEIRA DE MELLO – PROF. LOANZI (...) Foi aluno do famoso Mitsuyo Moeda, Conde Koma, introdutor do jiu jitsu e do judô no Brasil"
                }
              ]
            },
            {
              "id": "JDP-126",
              "style_id": "JDP-S-1",
              "place": "Budokan, São Paulo",
              "quality": 2,
              "period": {
                "start": null,
                "end": null
              },
              "sources": [
                {
                  "uri": "https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/",
                  "cite": "Dojô Professor Loanzi - Museu Virtual do Judô",
                  "citation": "Em 1959 contatou seu mestre e sensei, que lhe havia promovido à faixa preta sho-dan, Ryuzo Ogawa, de São Paulo"
                }
              ]
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": "Budokan - SP",
              "rank": "1 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/",
                  "cite": "Dojô Professor Loanzi - Museu Virtual do Judô",
                  "citation": "Em 1959 contatou seu mestre e sensei, que lhe havia promovido à faixa preta sho-dan, Ryuzo Ogawa, de São Paulo"
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030"
            },
            {
              "uri": "https://aratabajiujitsu.com.br/a-origem-dos-arataba/"
            },
            {
              "uri": "https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/"
            }
          ],
          "source_yaml": "database/persons/BRA/Aluizio_de_Melo.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-86",
          "name": "Georges Stobbaerts",
          "nationality": [
            "PRT",
            "BEL"
          ],
          "birth": {
            "date": 1940,
            "location": "Casablanca",
            "country_code": "MAR"
          },
          "death": {
            "date": "2014-01-06",
            "location": null,
            "country_code": null
          },
          "photo": {
            "url": "https://archive.org/download/stobbaerts/stobbaerts.jpg",
            "source": {
              "uri": "https://www.georgesstobbaerts.com/pt/",
              "cite": "Life and work of Georges Stobbaerts"
            }
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-4",
              "org": "Dai Nippon Butokukai",
              "teacher": null,
              "rank": "8 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://web.archive.org/web/20081021195508/http://www.cao.pt/surya/pe_17_1.htm",
                  "cite": "Entrevista ao Professor Georges Stobbaerts (Pedro Escudeiro, 2000 - Archived)",
                  "citation": "Georges Stobbaerts, tenho 62 anos e actualmente sou 8º dan de Aikido conferido pela Dai Nippon Butoku Kai, cuja sede é em Kyoto no Japão, no mais antigo Dojo o Butokuden que depende directamente da família Imperial."
                }
              ],
              "style": "Aikidō",
              "style_native": {
                "name": "合気道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://www.georgesstobbaerts.com/georges/"
            },
            {
              "uri": "https://tenchi.pt/georges-stobbaerts/"
            },
            {
              "uri": "https://web.archive.org/web/20081021195508/http://www.cao.pt/surya/pe_17_1.htm"
            }
          ],
          "source_yaml": "database/persons/BEL/Georges_Stobbaerts.yaml"
        }
      },
      {
        "data": {
          "id": "JDP-66",
          "name": "Antony Striker",
          "aka": [
            {
              "name": "Antony Stricker"
            },
            {
              "name": "Tony Striker"
            }
          ],
          "nationality": [
            "BEL"
          ],
          "birth": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "death": {
            "date": null,
            "location": null,
            "country_code": null
          },
          "teachers": [
            {
              "id": null,
              "style_id": null,
              "place": null,
              "quality": null,
              "period": {
                "start": null,
                "end": null
              }
            }
          ],
          "rank": [
            {
              "style_id": "JDP-S-1",
              "org": null,
              "teacher": null,
              "rank": "1 dan",
              "date": null,
              "sources": [
                {
                  "uri": "https://judolandia.tripod.com/histport.htm",
                  "cite": "História do Judo em Portugal (Judolândia, texto de «Judo: da iniciação à competição», Costa Branco et. al",
                  "citation": "Quase na mesma altura chega a Lisboa Antony Striker (Suíço) 1º Dan, o qual abre uma sala no Largo do Intendente, onde despontaram para o Judo, entre outros, Afonso Maia de Loureiro, Vasco de Sousa e José Manuel Bastos Nunes."
                }
              ],
              "style": "Kōdōkan Jūdō",
              "style_native": {
                "name": "講道館柔道",
                "lang": "ja"
              }
            }
          ],
          "sources": [
            {
              "uri": "https://judolandia.tripod.com/histport.htm"
            }
          ],
          "source_yaml": "database/persons/BEL/Antony_Striker.yaml"
        }
      }
    ],
    "edges": [
      {
        "data": {
          "id": "JDPff214f340061",
          "name": "Mifune Kyūzō (Kōdōkan Jūdō) Walter Todd",
          "source": "JDP-11",
          "target": "JDP-24",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 1,
          "period": {
            "start": 1946,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP22d8abe6241f8",
          "name": "Yamashita Yoshitsugu (Kōdōkan Jūdō) Theodore Roosevelt Jr.",
          "source": "JDP-95",
          "target": "JDP-96",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1904,
            "end": 1904
          },
          "sources": [
            {
              "uri": "https://ejmas.com/jcs/jcsart_svinth1_1000.htm",
              "cite": "Professor Yamashita Goes to Washington (Journal of Combative Sport, Oct 2000)",
              "citation": "So, during March and April 1904, Roosevelt practiced judo three afternoons a week, using a ground floor office in the White House as his workout space (...) Yamashita later said that while Roosevelt was his best pupil (...)"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP192ee989aec75",
          "name": "AnnMaria De Mars (Kōdōkan Jūdō) Ronda Rousey",
          "source": "JDP-132",
          "target": "JDP-133",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 3,
          "period": {
            "start": "1998",
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.blackbeltmag.com/fists-of-love-the-mothers-who-raised-martial-arts-legends",
              "cite": "Fists of Love: The Mothers Who Raised Martial Arts Legends - Black Belt Magazine",
              "citation": "She began coaching Ronda at age 11, instilling a mindset that would later carry her daughter to Olympic bronze in judo and UFC glory"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP01a8ca74bd2bc",
          "name": "Iizuka Kunisaburō (Kōdōkan Jūdō) Kenneth Kuniyuki",
          "source": "JDP-31",
          "target": "JDP-122",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Keio University, Tokyo",
          "quality": 3,
          "period": {
            "start": "1931",
            "end": "1932"
          },
          "sources": [
            {
              "uri": "https://www.usjf.com/kenneth-kuniyuki/",
              "cite": "Kenneth Kuniyuki - USJF",
              "location": null,
              "citation": "From 1931 to 1932 Kenneth studied under Kunisaburo Iizuka, 8-dan, and original student of Kano Sensei in Tokyo, Japan"
            },
            {
              "uri": "https://shoyuzine.tripod.com/id14.html",
              "cite": "Asian Americans who've made a difference - Shoyu Zine",
              "citation": "In 1932 he went to Japan to train at Keio University under the instruction of Kunisaburo Iizuka, 8 dan at the time"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP89efef22d3813",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) Karl Geis",
          "source": "JDP-12",
          "target": "JDP-52",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 2,
          "period": {
            "start": 1952,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.karlgeis.com/his-resume",
              "cite": "Karl Geis Martial Arts Resume (Karl Geis Ryu homepage)",
              "citation": "During my studies in Japan I received significant personal instruction from the following Kodokan teachers: [...] Kobayashi Sensei, 8th Dan"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP9870dc206f7ae",
          "name": "Tsunako Miyake (Aikidō) Karl Geis",
          "source": "JDP-53",
          "target": "JDP-52",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.karlgeis.com/his-resume",
              "cite": "Karl Geis Martial Arts Resume (Karl Geis Ryu homepage)",
              "citation": "During my studies in Japan I received significant personal instruction from the following Kodokan teachers: [...] Miyake, Tsunako Sensei, 7th Dan"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPb41be74b09b94",
          "name": "Kenneth Kuniyuki (Kōdōkan Jūdō) James Cagney",
          "source": "JDP-122",
          "target": "JDP-123",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Seinan Dojo, Los Angeles",
          "quality": 1,
          "period": {
            "start": 1945,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.mixedmartialarts.com/judo/1945-film-fight-scene",
              "cite": "1945 film fight scene - MixedMartialArts.com",
              "citation": "James would train Judo at the Seinan Dojo under Kenneth Kuniyuki"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP740facb0c9038",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) Hal Sharp",
          "source": "JDP-12",
          "target": "JDP-25",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 3,
          "period": {
            "start": 1952,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPd622b82c6d278",
          "name": "Ishikawa Takahiko (Kōdōkan Jūdō) Hal Sharp",
          "source": "JDP-119",
          "target": "JDP-25",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Keishicho",
          "quality": 3,
          "period": {
            "start": 1953,
            "end": 1955
          },
          "sources": [
            {
              "uri": "https://www.usjf.com/takahiko-ishikawa/",
              "cite": "Memories of My Sensei Takahiko Ishikawa, 9th Dan by Harold (Hal) E. Sharp (USJF)",
              "citation": "I would like to share some of my experiences with you about my Sensei and dear friend, Takahiko Ishikawa (...) I first met Ishikawa in 1953 in Japan after I became a Shodan (1st degree black belt) and thus was allowed to workout at the Keishicho (Tokyo Police Dojo) (...)"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP0f242f5a12d5c",
          "name": "Oda Tsunetane (Kōdōkan Jūdō) Hal Sharp",
          "source": "JDP-124",
          "target": "JDP-25",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 3,
          "period": {
            "start": 1950,
            "end": null
          },
          "sources": [
            {
              "uri": "https://judoinfo.com/oda/",
              "cite": "Master Tsunetane Oda - JudoInfo",
              "citation": "...I began to practice with Master Oda at Rikkyo University in Tokyo, during the early 1950’s and still remain fascinated by his bravado (...) I remained under Master Oda’s tutelage for many years practicing 3 times a day. Often I would accompany Master Oda to the Kodokan as well as the Dojo at Sugamo Prison."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP9c31ba8a6e82f",
          "name": "Ishikawa Takahiko (Kōdōkan Jūdō) Gene LeBell",
          "source": "JDP-119",
          "target": "JDP-120",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Keishicho",
          "quality": 3,
          "period": {
            "start": 1953,
            "end": 1955
          },
          "sources": [
            {
              "uri": "https://mokurendojo.blogspot.com/2008/05/mokuren-interview-judo-gene-lebell.html",
              "cite": "Mokuren Interview: 'Judo' Gene LeBell (Mokuren Dojo)",
              "citation": "Who do you think were the greatest judo teachers you ever got to learn from? Gene Lebell: In the U.S. Shig Tashma, Larry Coughran, Kenneth Kinyuki, Fuji Nazawa (who just died 2 days ago), and of course I learned a lot from training in Japan (Ishikawa)"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP7a205fd26b075",
          "name": "Ōtake Risuke (Tenshin Shōden Katori Shintō-ryū) Donn F. Draeger",
          "source": "JDP-112",
          "target": "JDP-111",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": null,
          "quality": 3,
          "period": {
            "start": 1967,
            "end": null
          },
          "sources": [
            {
              "uri": "http://aiki-kohai.over-blog.com/2018/08/chronique-abregee-de-donn-f.draeger.html",
              "cite": "Tatsusjin : la chronique abrégée de Donn F. Draeger (Aïki-Kohaï)",
              "citation": "A partir de 1967, Il sera ensuite la premier pratiquant non japonais à entrer dans l'école Tenshin shoden Katori Shinto ryu alors sous la direction du célèbre Risuke Otake shihan, achevant son parcours dans cette école par l'obtention d'un grade d'instructeur."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP9d6a8cf6f6357",
          "name": "Wang Shujin (Baguazhang) Donn F. Draeger",
          "source": "JDP-117",
          "target": "JDP-111",
          "interaction": "Baguazhang",
          "interaction_id": "JDP-S-17",
          "interaction_native": {
            "name": "八卦掌",
            "lang": "cn"
          },
          "place": "Meiji Shrine",
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://kogenbudo.org/i-htm/",
              "cite": "Donn Draeger & Robert Smith: Their Intersection Concerning Chinese Martial Arts (KogenBudo)",
              "citation": "There was a famous xingyiquan and baguazhang teacher in Japan in those days, named Wang Shujin (...) Donn (and a number of other of his associates) began training with Wang on the grounds of the Meiji Shrine (...)"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP2234818afc425",
          "name": "Ōsawa Yoshimi (Kōdōkan Jūdō) AnnMaria De Mars",
          "source": "JDP-131",
          "target": "JDP-132",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Waseda University, Tokyo",
          "quality": 2,
          "period": {
            "start": "1976",
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.usjf.com/annmaria-de-mars-2/",
              "cite": "AnnMaria De Mars - USJF",
              "citation": "at the age of 18, as a college junior, De Mars was an exchange student at Waseda University in Tokyo, Japan. While there, she trained under Sensei Osawa"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP758c4f95a43a9",
          "name": "Anatoliy Rakhlin (Kōdōkan Jūdō) Vladimir Putin",
          "source": "JDP-99",
          "target": "JDP-100",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1964,
            "end": null
          },
          "sources": [
            {
              "uri": "https://judo.ru/news/4707",
              "citation": "В 1964 году набрал первую группу юношей, среди которых были Аркадий Ротенберг, Валентин Степанов, Николай Кононов, Василий Шестаков, Владимир Путин.",
              "cite": "Утрата"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPb9c627dcfd84",
          "name": "Anatoliy Rakhlin (Sambo) Vladimir Putin",
          "source": "JDP-99",
          "target": "JDP-100",
          "interaction": "Sambo",
          "interaction_id": "JDP-S-15",
          "interaction_native": {
            "name": "сaмбо",
            "lang": "ru"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1964,
            "end": null
          },
          "sources": [
            {
              "uri": "https://vecherka-spb.ru/2023/08/08/chestnoe-i-dobrosovestnoe-otnoshenie-k-delu-kakim-bil-anatolii-rakhlin--lichnii-trener-vladimira-putina-",
              "citation": "Хорошо помню, как Анатолий Соломонович проводил отбор в секцию самбо. Нужно было подтянуться — кто сколько сможет.",
              "cite": "Вечерний Санкт-Петербург"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP732f857ecb167",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Vasili Oshchepkov",
          "source": "JDP-1",
          "target": "JDP-97",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 0,
          "period": {
            "start": 1911,
            "end": 1917
          },
          "sources": [
            {
              "uri": "https://oca.asia/sports/info/15/58/",
              "citation": "Oshchepkov spent much of his life living in Japan and training judo under its founder Kano Jigoro."
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Vasili_Oshchepkov",
              "citation": "",
              "cite": "Vasili Oshchepkov - Wikipedia"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPa4f0ccdc32162",
          "name": "Vasili Oshchepkov (Kōdōkan Jūdō) Sergei Dashkevich",
          "source": "JDP-97",
          "target": "JDP-98",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1931,
            "end": null
          },
          "sources": [
            {
              "uri": "https://judo.ru/news/9889",
              "citation": "В 1931 году прошёл обучение в Москве у родоначальника отечественного дзюдо Василия Сергеевича Ощепкова на курсах преподавателей дзюдо для низовых заводских и вузовских коллективов"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPb7d262c01a814",
          "name": "Vasili Oshchepkov (Sambo) Sergei Dashkevich",
          "source": "JDP-97",
          "target": "JDP-98",
          "interaction": "Sambo",
          "interaction_id": "JDP-S-15",
          "interaction_native": {
            "name": "сaмбо",
            "lang": "ru"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1931,
            "end": null
          },
          "sources": [
            {
              "uri": "https://judo.ru/news/9889",
              "citation": "В 1931 году прошёл обучение в Москве у родоначальника отечественного дзюдо Василия Сергеевича Ощепкова на курсах преподавателей дзюдо для низовых заводских и вузовских коллективов"
            },
            {
              "uri": "https://turbojudo.spb.ru/news/v-den-125letiya-so-dnya-rozhdeniya-osnovopolozhnika-leningradskogo-dzyudo-sergeya-dashkevicha-sostoyalos-pamyatnoe-meropriyatie",
              "citation": "Вёл занятия в группе самбо, где его воспитанником с 1952 года был Анатолий Рахлин."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP27ae0869195f9",
          "name": "Vasili Oshchepkov (Kōdōkan Jūdō) Anatoly Kharlampiyev",
          "source": "JDP-97",
          "target": "JDP-101",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "State Central Order of Lenin Institute of Physical Culture",
          "quality": 2,
          "period": {
            "start": 1931,
            "end": null
          },
          "sources": [
            {
              "uri": "https://ru.wikipedia.org/wiki/%D0%A5%D0%B0%D1%80%D0%BB%D0%B0%D0%BC%D0%BF%D0%B8%D0%B5%D0%B2,_%D0%90%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9_%D0%90%D1%80%D0%BA%D0%B0%D0%B4%D1%8C%D0%B5%D0%B2%D0%B8%D1%87",
              "citation": "В 1936 г. окончил Государственный центральный ордена Ленина институт физической культуры (отделение дзюдо Василия Сергеевича Ощепкова)[...]Создавая «систему самбо», Харлампиев тщательно изучал дзюдо и осваивал его на практике. В дзюдо он видел основание нового вида борьбы в одежде, обогащённого наиболее эффективными приёмами других видов борьбы. Дзюдо он осваивал под руководством Василия Сергеевича Ощепкова, который во время многолетнего пребывания в Японии тренировался в школе дзюдо Кодокан."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP305f6b404693b",
          "name": "Sergei Dashkevich (Sambo) Anatoliy Rakhlin",
          "source": "JDP-98",
          "target": "JDP-99",
          "interaction": "Sambo",
          "interaction_id": "JDP-S-15",
          "interaction_native": {
            "name": "сaмбо",
            "lang": "ru"
          },
          "place": "Leningrad Palace of the Pioneers",
          "quality": 2,
          "period": {
            "start": 1955,
            "end": null
          },
          "sources": [
            {
              "uri": "https://sambo.sport/en/news/anatoliy-rakhlin-chelovek-pedagog-trener/",
              "citation": "In 1953 he started taking SAMBO classes in the Palace of the Pioneers under the guidance of a highly experienced wrestler S. Dashkevich, a wrestling partner of Ivan Poddubny himself.",
              "cite": "Anatoliy Rakhlin: Person, Teacher, Coach | International SAMBO Federation (FIAS)"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP791094ddc3f8",
          "name": "José Costa Branco (Kōdōkan Jūdō) Nuno Delgado",
          "source": "JDP-62",
          "target": "JDP-63",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Sport Algés e Dafundo",
          "quality": 3,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.ulisboa.pt/sites/ulisboa.pt/files/public/aluno_de_kobayashi_moldou_o_campeao.pdf",
              "cite": "José Costa Branco: Aluno de Kobayashi moldou o campeão (O Jogo, 22-II-2020)",
              "citation": "... no histórico Sport Algés e Dafundo durante 28 anos. Foi lá que José Costa Branco encontrou Nuno Delgado, que saiu de Santarém, onde vivia e combatia, para regressar a Lisboa e se licenciar em Ciências do Desporto"
            },
            {
              "uri": "https://www.record.pt/modalidades/detalhe/alges-conquista-nacional-de-seniores-por-equipas",
              "cite": "Algés conquista Nacional de seniores por equipas (Record, 30-IV-2001)",
              "citation": "Quero dedicar o triunfo ao ex-treinador José Branco, porque ele já merecia este título no ano passado, altura em que se retirou dos tapetes, considerou Nuno Delgado, medalha de bronze em Sydney 2000."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPfc5e356a23dc9",
          "name": "Fernando Costa Matos (Kōdōkan Jūdō) Nuno Delgado",
          "source": "JDP-15",
          "target": "JDP-63",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.linkedin.com/posts/nunodelgadotpv_mestrebastosnunes-judo-portugaljudo-activity-7155564790885556225-5SnY?originalSubdomain=pt",
              "cite": "Nuno Delgado",
              "citation": "A par do meu Mestre Fernando Costa Matos, são as mais altas graduações Lusas, discípulos diretos de Kiyoshi Kobayashi, que tanto moldaram os nossos judocas, com a sua sabedoria e pedagogia"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP93f07c2d7d3e",
          "name": "António Roquette de Andrade (Kōdōkan Jūdō) Mário Aguilar",
          "source": "JDP-61",
          "target": "JDP-88",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube do Estoril",
          "quality": 2,
          "period": {
            "start": 1981,
            "end": 1982
          },
          "sources": [
            {
              "uri": "https://github.com/Judo-Documentation-Project/budotree",
              "cite": "Mário Aguilar, private communication, 2021",
              "citation": "... os meus mestres por ordem cronológica foram: (...) António Roquete (...) no Judo Clube do Estoril - 1 ano"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPc2f9ad5aafa7d",
          "name": "Petrucio Monteiro (Kōdōkan Jūdō) Mário Aguilar",
          "source": "JDP-128",
          "target": "JDP-88",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Academia Petrucio Monteiro",
          "quality": 3,
          "period": {
            "start": 1980,
            "end": 1981
          },
          "sources": [
            {
              "uri": "https://github.com/Judo-Documentation-Project/budotree",
              "cite": "Mário Aguilar, private communication, 2021",
              "citation": "... os meus mestres por ordem cronológica foram: (...) Mestre Petrúcio Monteiro (Brasil) - 1980 a 1981 e meio"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP610df06008134",
          "name": "Yamamoto Nobuaki (Kōdōkan Jūdō) Manuel Reis",
          "source": "JDP-74",
          "target": "JDP-75",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Clube de Judo do Porto",
          "quality": 2,
          "period": {
            "start": 1968,
            "end": 1969
          },
          "sources": [
            {
              "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
              "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
              "citation": "Em 1968, ao abrigo do Fundo de Fomento Desportivo, chega ao Porto o jovem Mestre japonês, de 26 anos, Nabuaki Yamamoto, 5º Dan, aluno do Kodokan e antigo campeão universitário do Japão, tornando-se professor do Clube de Judo do Porto. No início de 1969, o Mestre Yamamoto parte para a Islândia e as aulas voltam a ser ministradas pelos judocas mais graduados, que contavam agora com o apoio muito esporádico de alguns elementos da Federação Portuguesa de Judo"
            },
            {
              "uri": "https://judomagazine.pt/2023/05/16/entrevista-viagem-ao-mundo-dos-homens-bons-2/",
              "citation": "Fernando Costa Matos encontrou-se com um dos mais antigos praticantes do judo em Portugal, Manuel Reis, que já tinha trazido o japonês Yamamoto nos anos 60 para orientar o clube e que aceitou de bom grado a vinda de Frigyes Torok para a direção técnica do tradicional clube da cidade Invicta."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPf3045ea1e0a4f",
          "name": "Armando Gonçalves (Jūjutsu) Manuel Reis",
          "source": "JDP-76",
          "target": "JDP-75",
          "interaction": "Jūjutsu",
          "interaction_id": "JDP-S-14",
          "interaction_native": {
            "name": "柔術",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html",
              "citation": "...Manuel Reis fora aluno de  Armando Gonçalves, um portuense Professor de Ju-Jutsu 柔術..."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP52fc4981eb5cf",
          "name": "Jackie Hugnet (Kōdōkan Jūdō) Manuel Reis",
          "source": "JDP-78",
          "target": "JDP-75",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Círculo de Judo do Porto",
          "quality": 2,
          "period": {
            "start": 1955,
            "end": 1965
          },
          "sources": [
            {
              "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
              "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
              "citation": "Em 1955, os judocas do Porto organizados em torno do professor Jackie Hugnet, criam o Círculo de Judo do Porto, onde Hugnet foi professor durante sete anos, lecionando três vezes por semana a primeira classe em que o Judo Kodokan foi ministrado de forma sistemática no Porto. Os professores Hugnet e Manuel Reis foram instrutores de Judo da Polícia de Segurança Pública do Porto, durante cerca de dois anos meio, coincidentes com parte do período em que o Comandante da corporação era o famoso Chefe Santos Júnior."
            },
            {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html",
              "citation": "Este, impressionado com a determinação de Manuel Reis mas sem disponibilidade para ficar em Portugal, enviou para o Círculo de Judo do Porto o seu irmão Jackie Hugnet, 2º Dan de Judo, que connosco permaneceu por uma década"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPcfd500dc5a8e2",
          "name": "Gilbert Briskine (Kōdōkan Jūdō) Manuel Reis",
          "source": "JDP-79",
          "target": "JDP-75",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Círculo de Judo do Porto",
          "quality": 2,
          "period": {
            "start": 1961,
            "end": 1963
          },
          "sources": [
            {
              "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
              "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
              "citation": "No Verão de 1961, o professor Hugnet é substituído pelo também francês, Gilbert Bryskine, 4º Dan, campeão de França, bicampeão da Europa (1952 e 1954) e professor diplomado pela Federação Francesa de Judo e Ju Jutsu. É com Bryskine que os atletas do Círculo começam a participar em provas federativas, quer individualmente, quer por equipas. Em 1963, Gilbert Bryskine regressou a França devido a um grave acidente de automóvel que o deixou incapacitado."
            },
            {
              "uri": "http://clubejudoporto.weebly.com/os-nossos-fundadores.html",
              "citation": "Na época, recebemos também os ensinamento de outro francês, Gilbert Briskine, 4º Dan de Judo e mestre de Karaté-Do 空手道, Disciplina a quem a divulgação em Portugal muito deve."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPdd374a04dd31c",
          "name": "António Corrêa Pereira (Kōdōkan Jūdō) Luís Franco Pires Martins",
          "source": "JDP-83",
          "target": "JDP-82",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Academia de Budo",
          "quality": 1,
          "period": {
            "start": 1951,
            "end": null
          },
          "sources": [
            {
              "uri": "https://repositorio.ipv.pt/handle/10400.19/448",
              "cite": "FIGUEIREDO, Abel Aurélio Abreu. A institucionalização do karaté-os modelos organizacionais do karaté em Portugal. 2006. PhD Thesis. Instituto Politecnico de Viseu (Portugal)",
              "citation": "(...)Além de ser o primeiro cinto negro inscrito no Kodokan (Japão), Corrêa Pereira é o primeiro editor de revistas de Judo Kodokan (...) o Dr. João Luís Franco Pires Martins refere que por volta de 1946 é que se iniciou a prática de Judo na Academia de Judo, sendo aí que ele inicia a prática de Judo, em 1951"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP11e5853b784a7",
          "name": "Georges Stobbaerts (Aikidō) Leopoldo Ferreira",
          "source": "JDP-86",
          "target": "JDP-85",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Budokai Cascais",
          "quality": 3,
          "period": {
            "start": 1972,
            "end": 1976
          },
          "sources": [
            {
              "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm",
              "cite": "Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)",
              "citation": " Eu só conheci o Mestre Stobbaerts, em Agosto ou Setembro de 1972 (...) Portanto, durante anos, os meus fins-de-semana eram passados em Cascais a praticar Aikido. Pratiquei com o Mestre Stobbaerts talvez uns três ou quatro anos."
            },
            {
              "uri": "https://web.archive.org/web/20081021195508/http://www.cao.pt/surya/pe_17_1.htm",
              "cite": "Entrevista ao Professor Georges Stobbaerts (Pedro Escudeiro, 2000 - Archived)",
              "citation": "Nessa altura o ambiente no Aikido era muito bom, toda a gente praticava com toda gente, mesmo os alunos da escola do Kobayashi, como o Leopoldo Ferreira, que chegou a ser meu aluno."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP8a78708d55b3b",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) José Costa Branco",
          "source": "JDP-12",
          "target": "JDP-62",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": null,
          "period": {
            "start": 1975,
            "end": null
          },
          "sources": [
            {
              "uri": "https://judomagazine.pt/2021/07/04/1980-moscovo/",
              "cite": "José Branco não boicotou o seu sonho (Judo Magazine)",
              "citation": "O judo passou a ser central na sua vida que tinha levado uma volta muito grande. No Judo Clube de Portugal teve por mestre Kiyoshi Kobayashi e os seus colegas de clube passaram a ser os seus amigos para todos os momentos da vida quotidiana."
            },
            {
              "uri": "https://delagoabay.wordpress.com/2011/01/16/jose-branco-olimpico-e-campeao-de-judo-e-de-tiro/",
              "cite": "José Branco, Olímpico e Campeão de Tiro e Judo (The Delagoa Bay Company blog)",
              "citation": "Ao lado de josé branco, um amigo muito especial , mestre Kobayaschi . Refere o José: no período mais difícil da minha vida, então com 22 anos, quando me encontrava completamente atolado, foi o único que me lançou a mão. No último segundo da minha vida, ele fará parte dos meus pensamentos."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP81575c3595c8d",
          "name": "Fragoso Fernandes (Karate) José Araújo",
          "source": "JDP-81",
          "target": "JDP-80",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": "Academia de Budo",
          "quality": 3,
          "period": {
            "start": 1966,
            "end": null
          },
          "sources": [
            {
              "uri": "https://aikidomdc.wixsite.com/brpd/untitled-c1eb9",
              "cite": "Aikido Marcial Dôjo Clube - Mestre José Araújo",
              "citation": "Inicia a prática do Aikido e Karatedo em 1966, na Academia de Budo, com a idade de 10 anos, sendo seus professores Carlos Pereira, aluno de Mestre Georges Stobbaerts, e Fragoso Fernandes, aluno de Pires Martins, introdutor do Karatedo em Portugal."
            },
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
              "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
              "citation": "O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o responsável pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem séria, rigorosa e profundamente empenhada."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP77c03cf9de2be",
          "name": "Carlos Pereira (Aikidō) José Araújo",
          "source": "JDP-84",
          "target": "JDP-80",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Academia de Budo",
          "quality": 3,
          "period": {
            "start": 1966,
            "end": null
          },
          "sources": [
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
              "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
              "citation": "O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o responsável pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem séria, rigorosa e profundamente empenhada."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP7e474b11a0a11",
          "name": "Leopoldo Ferreira (Aikidō) José Araújo",
          "source": "JDP-85",
          "target": "JDP-80",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Academia de Budo",
          "quality": 3,
          "period": {
            "start": 1973,
            "end": null
          },
          "sources": [
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
              "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
              "citation": "Foi o Leopoldo Ferreira (...) Mas quem ficou na Academia, em permanência, a dar aulas de Aikido foi o Leopoldo Ferreira."
            },
            {
              "uri": "https://web.archive.org/web/20081021192805/http://www.cao.pt/surya/pe_12_2.htm",
              "cite": "Entrevista ao Professor Leopoldo Ferreira (Pedro Escudeiro, 2000 - Archived)",
              "citation": "Quando o José Araújo recomeçou a praticar já estava eu a dar aulas, portanto, foi por volta de 1973, creio."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP16ca923e9bc21",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) Henrique Nunes",
          "source": "JDP-12",
          "target": "JDP-64",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": 3,
          "period": {
            "start": 1959,
            "end": null
          },
          "sources": [
            {
              "uri": "https://judomagazine.pt/2023/03/19/reportagem-no-santuario-com-henrique-nunes-1/",
              "cite": "No «santuário» com Henrique Nunes (Judo Magazine)",
              "citation": "«Ali em frente é a área reservada ao meu Mestre, à pessoa que mais admiro e de quem tenho imensas saudades» adiantou o nosso anfitrião sinalizando uma grande fotografia de Kiyoshi Kobayashi, aquela que é marca global do japonês que desde 1958 referencia o judo nacional em todas as suas dimensões, técnicas, culturais, profissionais e até institucionais. Ao lado uma fotografia datada de 1966 com Henrique Nunes a receber de KK uma medalha de campeão nacional, uma das muitas, ao ponto de ser difícil recordar-se de todas."
            },
            {
              "uri": "https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381",
              "cite": "Seis histórias à volta do Tatami _ Gala 60º Aniversário FPJ",
              "citation": "... o mestre Kobayashi em Portugal, em '58 (...) foi o meu mestre."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPb21815b52bf1b",
          "name": "Afonso Henriques Maia de Loureiro (Kōdōkan Jūdō) Henrique Nunes",
          "source": "JDP-65",
          "target": "JDP-64",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": 3,
          "period": {
            "start": 1954,
            "end": null
          },
          "sources": [
            {
              "uri": "https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=381",
              "cite": "Seis histórias à volta do Tatami _ Gala 60º Aniversário FPJ",
              "citation": "...Tive óptimos professores no princípio. Era o Comandante Afonso Henriques Maia Loureiro, era o dr. Nuno Ribeiro..."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP3af8fd3c5451e",
          "name": "Luís Franco Pires Martins (Karate) Fragoso Fernandes",
          "source": "JDP-82",
          "target": "JDP-81",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": "Academia de Budo",
          "quality": 3,
          "period": {
            "start": 1966,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_17-22.pdf",
              "cite": "ARAÚJO, José, O Dr. Pires Martins e a União Portuguesa de Budo. In: A Génese do Karaté em Portugal",
              "citation": "Guardo ainda a imagem das minhas primeiras aulas de Karate-do, orientadas por essa extraordinária ﬁgura que era o Doutor Fragoso Fernandes, para mim, naquela época, a incarnação das virtudes físicas, técnicas e morais do Budoka (...)  Aluno desde o primeiro dia do Dr. Pires Martins, transpôs para o contacto com os alunos que se iniciavam a sua visão, como tive desde então o ensejo de conﬁrmar"
            },
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
              "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
              "citation": "O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o responsável pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem séria, rigorosa e profundamente empenhada."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPc7bc9e9eb864d",
          "name": "José Manuel Bastos Nunes (Kōdōkan Jūdō) Fernando Seabra",
          "source": "JDP-16",
          "target": "JDP-87",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Sintra - Judokai",
          "quality": 2,
          "period": {
            "start": 1980,
            "end": null
          },
          "sources": [
            {
              "uri": "https://judomagazine.pt/2024/01/23/mestre-ze-manel/",
              "citation": "Foi com o «Mestre Zé Manel», como carinhosamente os alunos mais chegados se atreviam a tratá-lo, que iniciei a minha prática do Judo no Judo Clube de Sintra – Judokai, no Cacém, em 1980, e foi essencialmente com Ele que aprendi grande parte do pouco que hoje sei neste meu percurso pelo Judo"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPe00b983a9f0a1",
          "name": "Yamamoto Nobuaki (Kōdōkan Jūdō) Fernando Sarmento",
          "source": "JDP-74",
          "target": "JDP-73",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Clube de Judo do Porto",
          "quality": 3,
          "period": {
            "start": 1968,
            "end": 1969
          },
          "sources": [
            {
              "uri": "http://escolamurakamimaia.weebly.com/fernando-sarmento.html",
              "cite": "Fernando Duarte Sarmento (Escola Murakami da Maia)",
              "citation": "Inicia o seu percurso nas «Artes Marciais» em 1968 como praticante de Judo no Clube de Judo do Porto (Rua Duque de Loulé), treinando sob a orientação directa do Mestre Nobuaki Yamamoto (5º Dan)"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP437280c98b2b1",
          "name": "Carlos Portas (Aikidō) Fernando Sarmento",
          "source": "JDP-72",
          "target": "JDP-73",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Mussubi Escola de Aikido",
          "quality": 3,
          "period": {
            "start": 2006,
            "end": null
          },
          "sources": [
            {
              "uri": "http://escolamurakamimaia.weebly.com/fernando-sarmento.html",
              "cite": "Fernando Duarte Sarmento (Escola Murakami da Maia)",
              "citation": "A 17 de Março de 2006 inicia a prática do Aikido na Mussubi Escola de Aikido / Takemusu Aiki Portugal sob a direcção técnico-pedagógica do Mestre Carlos Portas, com quem continua a praticar regularmente até ao presente momento. É graduado por Carlos Portas em 1º Dan a 11 de Agosto de 2007 e 2º Dan em 8 de Agosto de 2009."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPaf095e18e02e8",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) Fernando Costa Matos",
          "source": "JDP-12",
          "target": "JDP-15",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "INEF",
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.facebook.com/ipatj/photos/a.243433975668608/1073113529367311/?type=3&locale=pt_PT",
              "cite": "Renato Santos Kobayashi, in Instituto Português de Artes Tradicionais Japonesas - Facebook",
              "citation": "Em 1958 o Mestre K.K. assinou então um contrato para ficar em Portugal por um período de dois anos. Nesta sequência, aceita o convite para integrar o corpo docente do então Instituto Nacional de Educação Física (INEF), onde lecionou durante dez anos (...)  Destaca-se o nome do Fernando Costa Matos, atleta olímpico que iniciou o Judo no INEF em 1959 e em 1964 participou pela 1.ª vez nos J. Olímpicosde Tóquio."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPe53930128531a",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) Fernando Costa Matos",
          "source": "JDP-12",
          "target": "JDP-15",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://web.archive.org/web/20240212151508/https://www.linkedin.com/posts/nunodelgadotpv_mestrebastosnunes-judo-portugaljudo-activity-7155564790885556225-5SnY/?originalSubdomain=pt",
              "cite": "Nuno Delgado LinkedIn post",
              "citation": "O Mestre Bastos Nunes, juntou-se ao seu querido Mestre Kobayashi que serviu com verdadeira alma Samurai, «linha dura» como dizia sempre. A par do meu Mestre Fernando Costa Matos, são as mais altas graduações Lusas, discípulos diretos de Kiyoshi Kobayashi, que tanto moldaram os nossos judocas, com a sua sabedoria e pedagogia."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP767da8789bc6a",
          "name": "Tomita Takeji (Aikidō) Carlos Portas",
          "source": "JDP-71",
          "target": "JDP-72",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Iwama Dōjō",
          "quality": null,
          "period": {
            "start": 1985,
            "end": 1993
          },
          "sources": [
            {
              "uri": "https://aikidomdc.wixsite.com/brpd/untitled-c1nrv",
              "cite": "Mestre Carlos Portas (Aikido Marcial Dojo Clube)",
              "citation": " Em 1985, viu no jornal o anúncio de uma demonstração de Aikido por um mestre japonês (Mestre Tomita), em Estocolmo, e foi ver. Achou que tinha caído num poço de luz e logo ali perguntou ao Mestre se o aceitava como aluno, o que veio a acontecer. Regressou a Portugal em 1993"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP8021aa26caf7e",
          "name": "Georges Stobbaerts (Aikidō) Carlos Pereira",
          "source": "JDP-86",
          "target": "JDP-84",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://web.archive.org/web/20081021194517/http://www.cao.pt/surya/pe_18_1.htm",
              "cite": "Entrevista ao Professor José Araújo (Pedro Escudeiro, 2000 - Archived)",
              "citation": "O professor de Aikido era o Carlos Pereira, aluno do Mestre Stobbaerts, o de Karate era o Dr. Fragoso Fernandes, aluno do Dr. Pires Martins, (o introdutor do Karate em Portugal) que era o responsável pelo Karate. Professor de Filosofia, foi uma das pessoas que mais me marcou nas Artes Marciais, pela sua abordagem séria, rigorosa e profundamente empenhada."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPa0e700ad76f3f",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) José Manuel Bastos Nunes",
          "source": "JDP-12",
          "target": "JDP-16",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP567168ed6fa45",
          "name": "Antony Striker (Kōdōkan Jūdō) José Manuel Bastos Nunes",
          "source": "JDP-66",
          "target": "JDP-16",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "http://judokai.pt/JUDO%20-%20MANUAL.pdf",
              "cite": "Judokai: Manual de Formação para Graduaçãoem 1º Dan - Judo (Judo Clube de Sintra - Judokai)",
              "citation": "Quase na mesma altura [1955] chega a Lisboao Suiço Antony Stryker, 1º Dan,que abre uma sala no Largo do Intendente, onde teve como aluno, entre outros, José Manuel Bastos Nunes."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPcec4d270a582d",
          "name": "Ogawa Ryuzo (Kōdōkan Jūdō) Augusto de Oliveira Cordeiro",
          "source": "JDP-126",
          "target": "JDP-127",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Budokan (SP)",
          "quality": 3,
          "period": {
            "start": "1950",
            "end": null
          },
          "sources": [
            {
              "uri": "https://blogoterohermanny.blogspot.com/2009/09/o-mestre-augusto-cordeiro.html",
              "cite": "Rudolf Hermanny's Blog",
              "citation": "ao estabelecer contato com a Associação Budokan do Prof. Riuzo Ogawa se apaixonou pelo magnífico Judô que ali se ensinava e praticava. Após uma temporada residindo em casa do mestre e praticando com seus alunos, o Prof. Cordeiro adotou a nova metodologia e a forma de competição oficial do judô"
            },
            {
              "uri": "https://revistabudo.com.br/georges-mehdi-e-rudolf-hermanny-uma-historia-que-transcende-o-tempo-e-os-tatamis/",
              "cite": "Revista Budô",
              "citation": "discípulo direto do mestre japonês Ryuzo Ogawa"
            },
            {
              "uri": "https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php",
              "cite": "Maçaneiro (2024)",
              "location": "pp. 91-92",
              "citation": "Cordeiro continuou a procurar pelo judô e, no início da década de 1950, chegou à um acordo com Ryuzo Ogawa, tornando-se sua primeira filial no Rio de Janeiro"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPf43d82d910e85",
          "name": "Yano Takeo (Kōdōkan Jūdō) Augusto de Oliveira Cordeiro",
          "source": "JDP-105",
          "target": "JDP-127",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Rio de Janeiro",
          "quality": 2,
          "period": {
            "start": "1937",
            "end": "1948"
          },
          "sources": [
            {
              "uri": "https://www.teses.usp.br/teses/disponiveis/39/39136/tde-14052024-174041/pt-br.php",
              "cite": "MAÇANEIRO, Gustavo Goulart Braga. Desenvolvimento organizacional do judô brasileiro. São Paulo : Escola de Educação Física e Esporte, Universidade de São Paulo, 2024. Dissertação de Mestrado em Estudos Socioculturais e Comportamentais da Educação Física e Esporte",
              "location": "p. 91",
              "citation": "em 1944 a ACM promoveu competições e graduações (...) Por esse período é que Takeo Yano foi responsável pela graduação de professores no Rio de Janeiro e, dentre eles, aquele que se tornou, anos mais tarde, o primeiro presidente da CBJ, Augusto Cordeiro"
            },
            {
              "uri": "https://memoria.bn.gov.br/DocReader/DocReader.aspx?bib=221961_03&&pasta=ano%20195&pagfis=59293",
              "cite": "Diario da Noite",
              "location": "Ed. 06066, 11 de Dezembro de 1957, p. 3",
              "citation": "Corria o ano de 1937 e tratei de inscrever o meu nome entre os alunos do professor Takeo Yama [sic], que afinal de contas, funcionou como o meu descobridor"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP412532f7b8fe3",
          "name": "Hirano Yuzo (Jūjutsu) Armando Gonçalves",
          "source": "JDP-77",
          "target": "JDP-76",
          "interaction": "Jūjutsu",
          "interaction_id": "JDP-S-14",
          "interaction_native": {
            "name": "柔術",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "http://id.bnportugal.gov.pt/bib/catbnp/732683",
              "cite": "GONÇALVES, Armando; O fraco vence o forte. 1941",
              "citation": "Ex-discípulo do Professor japonês, Hirano (...) O nosso saudoso ex-professor Hirano não tinha admiração nenhuma pelo sistema Kano"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP08b36b7b57039",
          "name": "Fernando Costa Matos (Kōdōkan Jūdō) António Roquette de Andrade",
          "source": "JDP-15",
          "target": "JDP-61",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.ahbe.pt/portfolio-item/judo/",
              "cite": "A História Do Judo na AHBE",
              "citation": "O professor Costa Matos leccionou Judo na AHBE entre 1970 e 1976, altura em que, por motivos de saúde, foi substituído pelo seu melhor aluno, o professor António Roquete de Andrade, o qual assumiu definitivamente o cargo de treinador principal da AHBE em 1977, após ter participado como atleta nos Jogos Olímpicos de MONTREAL em 1976."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP885eff8391058",
          "name": "Erich Rahn (Jūjutsu) António Corrêa Pereira",
          "source": "JDP-109",
          "target": "JDP-83",
          "interaction": "Jūjutsu",
          "interaction_id": "JDP-S-14",
          "interaction_native": {
            "name": "柔術",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP2e63235d1defe",
          "name": "Antony Striker (Kōdōkan Jūdō) Alexandre Gueifão",
          "source": "JDP-66",
          "target": "JDP-67",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judokai de Lisboa",
          "quality": 3,
          "period": {
            "start": 1958,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf",
              "cite": "Gueifão, Alexandre, «À volta de Homens com sério Código de Honra», in «A Génese do Karate em Portugal»",
              "citation": "Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orientação de Tony Stricker e H. Bouchend-Homme da Organização Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP97d82c63cb475",
          "name": "Henri Bouchend'Homme (Kōdōkan Jūdō) Alexandre Gueifão",
          "source": "JDP-68",
          "target": "JDP-67",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judokai de Lisboa",
          "quality": 3,
          "period": {
            "start": 1958,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf",
              "cite": "Gueifão, Alexandre, «À volta de Homens com sério Código de Honra», in «A Génese do Karate em Portugal»",
              "citation": "Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orientação de Tony Stricker e H. Bouchend-Homme da Organização Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP617433b19ec0e",
          "name": "Luís Franco Pires Martins (Karate) Alexandre Gueifão",
          "source": "JDP-82",
          "target": "JDP-67",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": "Academia de Budo",
          "quality": 3,
          "period": {
            "start": 1964,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.suishinkan.com.pt/biografia.html",
              "citation": "Foi co-introdutor da prática do Karate em Portugal na Academia de Budo, em Lisboa, onde começou a praticar em 1964 sob a orientação do seu primeiro Mestre de Karate-Do - Mestre Pires Martins da UBU"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPeb77c63bb7454",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) Alexandre Gueifão",
          "source": "JDP-12",
          "target": "JDP-67",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": 3,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.shotokai.pt/uploads/4/6/1/9/4619567/gkp_35-62.pdf",
              "cite": "Gueifão, Alexandre, «À volta de Homens com sério Código de Honra», in «A Génese do Karate em Portugal»",
              "citation": "Retrato saudoso e quase desvanecido de um karateka que se iniciou em Judo no ano de 1958 sob a orientação de Tony Stricker e H. Bouchend-Homme da Organização Judokai, e mais tarde sob os ensinamentos do Grande Mestre K. Kobayashi, no Judo Clube de Portugal."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPfce666edcbacb",
          "name": "Murakami Tetsuji (Karate) Alexandre Gueifão",
          "source": "JDP-94",
          "target": "JDP-67",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1969,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.suishinkan.com.pt/biografia.html",
              "citation": "O seu segundo Mestre foi Tetsuji Murakami Sensei, de quem foi aluno desde 1969, data que marca o nascimento efectivo da prática do estilo Shotokai em Portugal com a realização do primeiro estágio de Mestre Murakami."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPa62c5b637be08",
          "name": "Antony Striker (Kōdōkan Jūdō) Afonso Henriques Maia de Loureiro",
          "source": "JDP-66",
          "target": "JDP-65",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": 3,
          "period": {
            "start": 1954,
            "end": 1958
          },
          "sources": [
            {
              "uri": "https://judolandia.tripod.com/histport.htm",
              "cite": "História do Judo em Portugal (Judolândia, texto de «Judo: da iniciação à competição», Costa Branco et. al",
              "citation": "Quase na mesma altura chega a Lisboa Antony Striker (Suíço) 1º Dan, o qual abre uma sala no Largo do Intendente, onde despontaram para o Judo, entre outros, Afonso Maia de Loureiro, Vasco de Sousa e José Manuel Bastos Nunes."
            },
            {
              "uri": "https://youtu.be/5RGPsWHXyuw?si=82kuy6FCU-_yPryq&t=243",
              "cite": "Seis histórias à volta do Tatami _ Gala 60º Aniversário FPJ",
              "citation": "Em 1954. O professor era um tal belga, Anton Stricker, que era segurança do Reino Belga"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPc4850d3c9e3bf",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Yokoyama Sakujiro",
          "source": "JDP-1",
          "target": "JDP-9",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1886,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPbc98a5bc6385",
          "name": "Inoe Keitaro (Tenjin Shin'yō-ryū) Yokoyama Sakujiro",
          "source": "JDP-10",
          "target": "JDP-9",
          "interaction": "Tenjin Shin'yō-ryū",
          "interaction_id": "JDP-S-3",
          "interaction_native": {
            "name": "天神真楊流",
            "lang": "ja"
          },
          "place": "Yushima Tenjin dojo",
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPed37772a55c71",
          "name": "Isogai Hajime (Kōdōkan Jūdō) Yano Takeo",
          "source": "JDP-43",
          "target": "JDP-105",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://simonbjj.com/takeo-yano",
              "cite": "The Eastern Demon, Takeo Yano (Simon BJJ)",
              "citation": "There is not much information known about Takeo Yano, but it is believed he may have been born in 1909 and trained at the Dai Nippon Butoko Kai academy in Kioto under famed Judoka, Hajime Isogai."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPc835eb3334229",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Yamashita Yoshitsugu",
          "source": "JDP-1",
          "target": "JDP-95",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1884,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.judo-ch.jp/english/legend/yamasita/",
              "cite": "Kodokan hall of fame: Yoshitsugu Yamashita (Judo Channel)",
              "citation": "Yoshitsugu Yamashita was the son of an Odawara Han martial arts instructor, and he entered Kodokan in August of 1884."
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Yamashita_Yoshitsugu",
              "citation": "In August 1884, he joined the Kodokan judo dojo of his childhood friend Kano Jigoro as its nineteenth member"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPe7262b84494a5",
          "name": "Takeda Sōkaku (Daitō-ryū Aiki-jūjutsu) Ueshiba Morihei",
          "source": "JDP-28",
          "target": "JDP-27",
          "interaction": "Daitō-ryū Aiki-jūjutsu",
          "interaction_id": "JDP-S-10",
          "interaction_native": {
            "name": "大東流 合気柔術",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": 1915,
            "end": 1922
          }
        }
      },
      {
        "data": {
          "id": "JDPccfce7c7de618",
          "name": "Tozawa Tokusaburo (Tenjin Shin'yō-ryū) Ueshiba Morihei",
          "source": "JDP-47",
          "target": "JDP-27",
          "interaction": "Tenjin Shin'yō-ryū",
          "interaction_id": "JDP-S-3",
          "interaction_native": {
            "name": "天神真楊流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": 1901,
            "end": 1901
          },
          "sources": [
            {
              "uri": "http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf",
              "cite": "BUYENS, Guy. Introduction to Traditional martial systems. 2016",
              "citation": "Iso Mataemon Masatomo had amongst his students Inoue Keitaro and Tozawa Tokusaburo, who were the teachers of Miyamoto Hanzo). Morihei Ueshiba, founder of aikido, studied Tenjin Shinyo-ryu with Tozawa Tokusaburo"
            },
            {
              "uri": "https://aikidojournal.com/2011/08/27/tokusaburo-tozawa/",
              "citation": "[Tokusaburo Tozawa]. Teacher of TENJIN SHIN’YO-RYU JUJUTSU in Tokyo in late 1800s and early 1900s. Taught Morihei UESHIBA for brief period in 1901",
              "events": [
                "period"
              ]
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPd6af37faebdcc",
          "name": "Masakatsu Naka (Yagyū Shingan-ryū) Ueshiba Morihei",
          "source": "JDP-50",
          "target": "JDP-27",
          "interaction": "Yagyū Shingan-ryū",
          "interaction_id": "JDP-S-11",
          "interaction_native": {
            "name": "柳生心眼流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Yagy%C5%AB_Shingan-ry%C5%AB",
              "citation": "Morihei Ueshiba, the founder of Aikido, was a student of Yagyū Shingan-ryū. In 1908, after five years of training, he received the rank of Shoden from Masakatsu Nakai, a Shihan of the Edo-line of Yagyū Shingan-ryū"
            },
            {
              "uri": "https://aikidojournal.com/2016/09/24/interview-with-morihei-ueshiba-and-kisshomaru-ueshiba/",
              "citation": "O-Sensei: At about the age of 14 or 15. First I learned Tenshinyo-ryu Jiujitsu from Tokusaburo Tozawa Sensei, then Kito-ryu, Yagyu-ryu, Aioi-ryu, Shinkage-ryu, all of them jujutsu forms."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP888e2d25bbe",
          "name": "Naitō Takaharu (Kendo) Ueda Heitaro",
          "source": "JDP-60",
          "target": "JDP-39",
          "interaction": "Kendo",
          "interaction_id": "JDP-S-8",
          "interaction_native": {
            "name": "剣道",
            "lang": "ja"
          },
          "place": "Bujutsu Kyoin Yoseijo",
          "quality": 3,
          "period": {
            "start": 1905,
            "end": null
          },
          "sources": [
            {
              "uri": "https://kenshi247.net/blog/2022/01/24/the-iron-will-of-the-kendo-god-ueda-heitaro/",
              "cite": "The iron will of the kendo god Ueda Heitaro - Kenshi 24/7",
              "citation": "At the Yoseijo he was there as a koshusei or a part-time student there to learn kendo only (full time students also did academic study). There he studied directly under Naito Takaharu and crossed shinai with the likes of Saimura, Nakano, Oshima, and Shimatani (this was slightly before Mochida, Ogawa, Miyazaki, and Oasa, etc arrived). "
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPf6541550ea417",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Uchida Ryōhei",
          "source": "JDP-1",
          "target": "JDP-48",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 1,
          "period": {
            "start": 1893,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.researchgate.net/publication/277665808_Kodokan_Judo's_three_orphaned_forms_of_counter_techniques_-_Part_1_The_gonosen-no-kata_-_Forms_of_post-attack_initiative_counter_throws",
              "citation": "Miyakawa remained a Gen’yōshamember and became a Kōdōkan top-executive (Kōdōkan Saikō  Kanbu講道館最高幹部)  closely  associated  with Kanō Jigorō, as was Uchida Ryōhei"
            },
            {
              "uri": "https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/",
              "citation": "He was also an accomplished jūdōka, a favorite of Kanō shihan 師範 (master), one of the three most senior 5th dan rank holders in Kodokan history, and a noted street brawler."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP5d35dc47dfb6c",
          "name": "Miyagawa Taichiro (Jigō Tenshin Ryū) Uchida Ryōhei",
          "source": "JDP-49",
          "target": "JDP-48",
          "interaction": "Jigō Tenshin Ryū",
          "interaction_id": "JDP-S-12",
          "interaction_native": {
            "name": "自剛天真流",
            "lang": "ja"
          },
          "place": "Meikokan dojo",
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/",
              "citation": "宮川太一郎嘉永元年（1848）生正林又七郎の高弟・免許皆伝代々黒田家の臣である。一万流剣術，自剛天真流組討を極め，明治10年(1877) 11月玄洋社附属の向浜塾で自聞天真流を教授したのが，後の明道館道場の起源とされている。"
            },
            {
              "uri": "https://kanochronicles.com/2023/06/05/ki-%e6%b0%97-in-judo-%e6%9f%94%e9%81%93-uchida-ryohei-and-the-secrets-of-budo-%e6%ad%a6%e9%81%93%e6%a5%b5%e6%84%8f-the-kano-chronicles/",
              "citation": "He learned a number of martial arts, most notably Jigō Tenshin Ryū Jūjutsu in Fukuoka’s Meidokan dōjō, an art in which he was notably successful. In 1893 he moved to Tokyo to live with his wealthy coal mine owner uncle Hiraoka Kōtarō, a supporter of the Genyōsha, and began to study Russian at a Tokyo school and jūdō at Kanō Jigorō’s Kodokan."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPce11f0cae0d8f",
          "name": "Iso Masatomo (Tenjin Shin'yō-ryū) Tozawa Tokusaburo",
          "source": "JDP-4",
          "target": "JDP-47",
          "interaction": "Tenjin Shin'yō-ryū",
          "interaction_id": "JDP-S-3",
          "interaction_native": {
            "name": "天神真楊流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "http://www.tenyokai.com/booklet.php",
              "citation": "Geneology of Tenjin Shinyo Ryu Jujutsu: (...) Iso Matauemon Masatomo -> Tozawa Tokusaburo"
            },
            {
              "uri": "http://www.hontaiyoshinryu.be/images/Documents/p_schools.pdf",
              "citation": "Iso Mataemon Masatomo had amongst his students Inoue Keitaro and Tozawa Tokusaburo, who were the teachers of Miyamoto Hanzo). Morihei Ueshiba, founder of aikido, studied Tenjin Shinyo-ryu with Tozawa Tokusaburo"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP14d9670ffa044",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Tomita Tsunejirō",
          "source": "JDP-1",
          "target": "JDP-17",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1882,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP5eb79108fed75",
          "name": "Saitō Morihiro (Aikidō) Tomita Takeji",
          "source": "JDP-70",
          "target": "JDP-71",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Iwama Dōjō",
          "quality": null,
          "period": {
            "start": 1962,
            "end": 1
          },
          "sources": [
            {
              "uri": "https://www.aikidojournal.eu/docs/238/393_946_en.pdf",
              "cite": "TAKEJI TOMITA: From studying with O-Sensei to the creation of Aïki Shin Myo Den (Aikido Journal)",
              "citation": "From 1962 on, after his first visit in Iwama, he decides to follow the teaching of O'Sensei and of his assistant, Morihiro Saito Sensei (...) In 1968, he becomes Morihiro Saito's Uchideshi and is rapidly adopted by the Master's family (...) Tomita Sensei practiced for about 7 years at the Iwama Dojo. Those years were for him formativeyears dedicated to education and to discovering the way of Budo."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPf6fb81792aa4b",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Tomiki Kenji",
          "source": "JDP-1",
          "target": "JDP-26",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": 1895,
            "end": 1896
          }
        }
      },
      {
        "data": {
          "id": "JDP3accd72501269",
          "name": "Ueshiba Morihei (Aikidō) Tomiki Kenji",
          "source": "JDP-27",
          "target": "JDP-26",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": 1926,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP3224f9fc27936",
          "name": "Takenaka  Motonoshin (Kitō-ryū) Takenaka Tetsunosuke Issei",
          "source": "JDP-7",
          "target": "JDP-6",
          "interaction": "Kitō-ryū",
          "interaction_id": "JDP-S-2",
          "interaction_native": {
            "name": "起倒流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP8d9b070ae65b5",
          "name": "Takino Yūken (Kitō-ryū) Takenaka  Motonoshin",
          "source": "JDP-8",
          "target": "JDP-7",
          "interaction": "Kitō-ryū",
          "interaction_id": "JDP-S-2",
          "interaction_native": {
            "name": "起倒流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP0be66768b38cc",
          "name": "Yokoyama Sakujiro (Kōdōkan Jūdō) Takahashi Kazuyoshi",
          "source": "JDP-9",
          "target": "JDP-14",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP7c9893f5cb615",
          "name": "Iizuka Kunisaburō (Kōdōkan Jūdō) Sugino Yoshio",
          "source": "JDP-31",
          "target": "JDP-30",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Keiō Gijuku Daigaku",
          "quality": 2,
          "period": {
            "start": 1918,
            "end": 1919
          }
        }
      },
      {
        "data": {
          "id": "JDP150d64c4e757f",
          "name": "Ueshiba Morihei (Aikidō) Sugino Yoshio",
          "source": "JDP-27",
          "target": "JDP-30",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Wakamatsu-cho dojo",
          "quality": 2,
          "period": {
            "start": 1931,
            "end": 1935
          }
        }
      },
      {
        "data": {
          "id": "JDPa25a8b979e90d",
          "name": "Tamai Narimichi (Tenshin Shōden Katori Shintō-ryū) Sugino Yoshio",
          "source": "JDP-32",
          "target": "JDP-30",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": "Kawasaki",
          "quality": 1,
          "period": {
            "start": 1927,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPa8f2723f4b8dd",
          "name": "Kuboki Sozaemon (Tenshin Shōden Katori Shintō-ryū) Sugino Yoshio",
          "source": "JDP-33",
          "target": "JDP-30",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": "Kawasaki",
          "quality": 1,
          "period": {
            "start": 1927,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPd3dd89b2eaeac",
          "name": "Ito Tanekichi (Tenshin Shōden Katori Shintō-ryū) Sugino Yoshio",
          "source": "JDP-34",
          "target": "JDP-30",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": "Kawasaki",
          "quality": 1,
          "period": {
            "start": 1927,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPe4784f3eaf122",
          "name": "Shiina Ichizo (Tenshin Shōden Katori Shintō-ryū) Sugino Yoshio",
          "source": "JDP-35",
          "target": "JDP-30",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": "Kawasaki",
          "quality": 1,
          "period": {
            "start": 1927,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPbb0d311951d8f",
          "name": "Kanaya Genro (Yōshin-ryū) Sugino Yoshio",
          "source": "JDP-36",
          "target": "JDP-30",
          "interaction": "Yōshin-ryū",
          "interaction_id": "JDP-S-7",
          "interaction_native": {
            "name": "楊心流",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": 1928,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP52fe7e1b165f5",
          "name": "Iizasa Shuri-no-suke Morisada (Tenshin Shōden Katori Shintō-ryū) Shiina Ichizo",
          "source": "JDP-116",
          "target": "JDP-35",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
              "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
              "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPf87e8c231b6f9",
          "name": "Yokoyama Sakujiro (Kōdōkan Jūdō) Satake Soshihiro",
          "source": "JDP-9",
          "target": "JDP-22",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": 1892,
            "end": null
          },
          "sources": [
            {
              "uri": "https://simonbjj.com/satake",
              "cite": "The Sumo wrestle who taught BJJ, Soshiro Satake",
              "citation": "At some point later, probably in the late 1890’s, he joined the Kodokan and would become peers of Mitsuyo Maeda. The two judoka trained together under Sakujiro Yokoyama, who was known as one of the Four Guardians of the Kodokan"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E4%BD%90%E7%AB%B9%E4%BF%A1%E5%9B%9B%E9%83%8E",
              "citation": "1892年（明治25年）5月に講道館に入門"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP31c97f3693b0e",
          "name": "Ueshiba Morihei (Aikidō) Saitō Morihiro",
          "source": "JDP-27",
          "target": "JDP-70",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Iwama Dōjō",
          "quality": null,
          "period": {
            "start": 1946,
            "end": 1969
          },
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Morihiro_Saito",
              "citation": "It was at this time, at the age of 18, that Saito joined Ueshiba for training (...) From 1946 until Ueshiba’s passing in 1969, Saito served as Ueshiba's assistant in a variety of ways at Iwama while his wife served Mrs. Ueshiba. During Saito’s period as a deshi he taught classes in the Iwama dojo."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP43bc27141761a",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Saigō Shirō",
          "source": "JDP-1",
          "target": "JDP-121",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 3,
          "period": {
            "start": 1882,
            "end": 1890
          },
          "sources": [
            {
              "uri": "urn:isbn:1425163491",
              "cite": "WATSON, Brian N. Judo memoirs of Jigoro Kano. Trafford Publishing, 2008",
              "location": "p. 20",
              "citation": "Shortly thereafter, in August 1882, the now famous Shiro Saigo became a student of mine"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPcf484f7a7a5ce",
          "name": "Hayashi Yazaemon (Tenshin Shōden Katori Shintō-ryū) Ōtake Risuke",
          "source": "JDP-113",
          "target": "JDP-112",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
              "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
              "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô (...) Hayashi Saiichirô –> Hayashi Yazaemon –> Ôtake Risuke"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPcfc3b0866f3d4",
          "name": "Mifune Kyūzō (Kōdōkan Jūdō) Ōsawa Yoshimi",
          "source": "JDP-11",
          "target": "JDP-131",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Waseda University Judo Club",
          "quality": 3,
          "period": {
            "start": "1943",
            "end": null
          },
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E5%A4%A7%E6%B2%A2%E6%85%B6%E5%B7%B1",
              "cite": "大沢吉己 - 日本語版ウィキペディア",
              "citation": "1943年4月に早稲田大学に入学し柔道部に入部すると、師範には三船久蔵や徳三宝らが顔を揃え、月に1度ほどではあったが指導に来てその薫陶を受けた"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPe71a1bcf23c88",
          "name": "Itō Tokugorō (Kōdōkan Jūdō) Geo Omori",
          "source": "JDP-104",
          "target": "JDP-103",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 153",
              "citation": "Foi discípulo de um dos maiores lutadores do Kodokan, Tokugoro Ito"
            },
            {
              "uri": "https://en.wikipedia.org/wiki/Geo_Omori",
              "citation": "He learned under Tokugoro Ito and was a training partner of the famed Sanpo Toku"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPe2c18194307d1",
          "name": "Matsui Sanzo (Muso-ryu Shinjujutsu) Okano Yoshitaro",
          "source": "JDP-42",
          "target": "JDP-38",
          "interaction": "Muso-ryu Shinjujutsu",
          "interaction_id": "JDP-S-9",
          "interaction_native": {
            "name": "無相流新柔術",
            "lang": "ja"
          },
          "place": null,
          "quality": 0,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPf0f311ea5112c",
          "name": "Isogai Hajime (Kōdōkan Jūdō) Okano Yoshitaro",
          "source": "JDP-43",
          "target": "JDP-38",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Butokuden",
          "quality": 1,
          "period": {
            "start": 1906,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP35125a4e41862",
          "name": "Nagaoka Shūichi (Kōdōkan Jūdō) Okano Yoshitaro",
          "source": "JDP-44",
          "target": "JDP-38",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Butokuden",
          "quality": 1,
          "period": {
            "start": 1906,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP16deb4623ed19",
          "name": "Naitō Takaharu (Kendo) Ogawa Kinnosuke",
          "source": "JDP-60",
          "target": "JDP-59",
          "interaction": "Kendo",
          "interaction_id": "JDP-S-8",
          "interaction_native": {
            "name": "剣道",
            "lang": "ja"
          },
          "place": "Budō Senmon Gakko",
          "quality": 3,
          "period": {
            "start": 1907,
            "end": 1910
          },
          "sources": [
            {
              "uri": "https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm",
              "cite": "Ogawa Kinnosuke - Kenshi 24/7",
              "citation": "In 1905 a school was formally opened to teach kendo instructors and Naito was selected as the senior teacher. At this time the school was known as the Bujutsu Kyoin Yoseijo, but eventually (after a few re-organisations and renames) it would be known to everyone as Busen (Budo Senmon Gakko). It was to this school that Ogawa was dispatched by the Nagoya police department in 1907. Ogawa would spend 3 years studying kendo directly under Naito."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP92ff3200c47d9",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Nagaoka Shūichi",
          "source": "JDP-1",
          "target": "JDP-44",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1891,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP58ed21b999cbd",
          "name": "Egami Shigeru (Karate) Murakami Tetsuji",
          "source": "JDP-93",
          "target": "JDP-94",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1968,
            "end": null
          },
          "sources": [
            {
              "uri": "https://shotokai.com/tetsuji-murakami/",
              "cite": "Tetsuji Murakami Sensei (Shotokai Encyclopedia)",
              "citation": "In 1968 he travels to Japan where he meets Master Shigeru Egami. Very impressed by Master Egami and the technique he observes, he decides to make a profound and very difficult transformation in his technique and his practice. He returns to Europe as the representative of the Nihon Karate-do Shotokai."
            },
            {
              "uri": "https://kogenbudo.org/interview-with-master-nuno-russo-by-pedro-escudeiro/",
              "cite": "https://kogenbudo.org/interview-with-master-nuno-russo-by-pedro-escudeiro/",
              "citation": " A couple of years later, though, we had our first international seminar with a Japanese karate master: Murakami Tetsuji, from Shotokai Karate, a student of Egami Shigeru sensei. After this seminar, Murakami sensei became the leader of our karate group"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPda3d20205ead",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Mochizuki Minoru",
          "source": "JDP-1",
          "target": "JDP-29",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1925,
            "end": 1930
          }
        }
      },
      {
        "data": {
          "id": "JDPbaf6e6704d4d6",
          "name": "Mifune Kyūzō (Kōdōkan Jūdō) Mochizuki Minoru",
          "source": "JDP-11",
          "target": "JDP-29",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1925,
            "end": 1930
          }
        }
      },
      {
        "data": {
          "id": "JDP785c1c312fd45",
          "name": "Ueshiba Morihei (Aikidō) Mochizuki Minoru",
          "source": "JDP-27",
          "target": "JDP-29",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": "Kobukan dojo",
          "quality": null,
          "period": {
            "start": 1930,
            "end": null
          },
          "sources": [
            {
              "uri": "https://aikidojournal.com/2002/11/18/interview-with-minoru-mochizuki-1/",
              "citation": "That was back in 1930 when Ueshiba Sensei still didn’t have a place of his own and was teaching in the living room of a regular private house in the Mejiro area of Tokyo. But just after we started going there, we all moved to the newly finished Ushigome dojo (site of the present Hombu Dojo)"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP8d08d69f449b2",
          "name": "Funakoshi Gichin (Karate) Mochizuki Minoru",
          "source": "JDP-41",
          "target": "JDP-29",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.ffkarate.fr/hiroo-mochizuki-interview-yoseikan-budo/",
              "citation": "Elève de Jigoro Kano, qui l’avait envoyé apprendre l’aïkido auprès de Morihei Ueshiba, Minoru Mochizuki avait aussi travaillé avec Gichin Funakoshi. [...]  C’était la responsabilité d’une vie pour lui, car c’est la mission que lui avait confié Jigoro Kano. Mais il se trouvait un peu faible du point de vue des atémis, qu’il avait pourtant étudié avec Funakoshi"
            },
            {
              "uri": "https://books.google.pt/books?id=SdYDAAAAMBAJ&pg=PA34#v=onepage&q&f=false",
              "cite": "A Man of Many Budo (interview with Minoru Mochizuki), Black Belt, Aug 1989.",
              "citation": "Minoru Mochizuki holds the distinction of being the only living man to have studied with aikido founder Morihei Uyeshiba, judo founder Jigoro Kano, and \"the father of Japanese karate, Gichin Funakoshi."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPbeb64497c5e96",
          "name": "Tomiki Kenji (Aikidō) Tsunako Miyake",
          "source": "JDP-26",
          "target": "JDP-53",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://aikidojournal.com/2004/05/06/hiroaki-kogure-sensei-part-two",
              "cite": "Interview with Hiroaki Kogure Sensei, part 2 (interview by Josh Gold, 2004, Aikido Journal)",
              "citation": "Tomiki Sensei had three top students. they were Hideo Oba, Senta Yamada, and Tsunako Miyake Sensei."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP193184551e1f5",
          "name": "Tomiki Kenji (Kōdōkan Jūdō) Tsunako Miyake",
          "source": "JDP-26",
          "target": "JDP-53",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://studygrouptomikiaikido.blog/2022/09/05/simplification-or-sportification",
              "cite": "MIYAKE Sensei, Extracts from an Interview by R.J.Lawrance, The E.A.A. Newsletter, Issue 90.2 (in: Study Group Tomiki Aikido - The simplification of Ueshiba’s Aikido)",
              "citation": "Then, I met Tomiki sensei at the Kodokan (...) Now that he is gone, I think that it is very important for us to understand his idea, that to improve judo we must train in judo and aikido together."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP045a1947bb148",
          "name": "Matashichiro Shobayashi (Jigō Tenshin Ryū) Miyagawa Taichiro",
          "source": "JDP-51",
          "target": "JDP-49",
          "interaction": "Jigō Tenshin Ryū",
          "interaction_id": "JDP-S-12",
          "interaction_native": {
            "name": "自剛天真流",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://opac.tenri-u.ac.jp/opac/repository/metadata/1573/",
              "citation": "宮川太一郎嘉永元年（1848）生正林又七郎の高弟・免許皆伝代々黒田家の臣である。一万流剣術，自剛天真流組討を極め，明治10年(1877) 11月玄洋社附属の向浜塾で自聞天真流を教授したのが，後の明道館道場の起源とされている。大正9年(1920)6月20日77才にて病没。長男．宮川彦之助も目録まで進み，自剛天真流の普及に務めた。"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP63affcfd88deb",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Mifune Kyūzō",
          "source": "JDP-1",
          "target": "JDP-11",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1903,
            "end": 1965
          }
        }
      },
      {
        "data": {
          "id": "JDP0fdc1ad053991",
          "name": "Yokoyama Sakujiro (Kōdōkan Jūdō) Mifune Kyūzō",
          "source": "JDP-9",
          "target": "JDP-11",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1903,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPdbd4b56f4ecaf",
          "name": "Yokoyama Sakujiro (Kōdōkan Jūdō) Maeda Mitsuyo",
          "source": "JDP-9",
          "target": "JDP-18",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 1,
          "period": {
            "start": 1897,
            "end": null
          },
          "sources": [
            {
              "uri": "https://ja.wikipedia.org/wiki/%E6%A8%AA%E5%B1%B1%E4%BD%9C%E6%AC%A1%E9%83%8E",
              "cite": "横山作次郎 (ウィキペディア)",
              "citation": "また、三船久蔵や前田光世の師匠としても知られる"
            },
            {
              "uri": "https://simonbjj.com/satake",
              "cite": "The Sumo wrestle who taught BJJ, Soshiro Satake",
              "citation": "At some point later, probably in the late 1890’s, he joined the Kodokan and would become peers of Mitsuyo Maeda. The two judoka trained together under Sakujiro Yokoyama, who was known as one of the Four Guardians of the Kodokan"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP0d1b59b227387",
          "name": "Iizasa Shuri-no-suke Morisada (Tenshin Shōden Katori Shintō-ryū) Kumajiro Yamaguchi",
          "source": "JDP-116",
          "target": "JDP-115",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
              "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
              "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô (...) Hayashi Saiichirô –> Hayashi Yazaemon –> Ôtake Risuke"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP0f173bb3b1781",
          "name": "Okano Yoshitaro (Kōdōkan Jūdō) Konishi Yasuhiro",
          "source": "JDP-38",
          "target": "JDP-37",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": 1906,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPadbfe55f670cb",
          "name": "Ueda Heitaro (Kendo) Konishi Yasuhiro",
          "source": "JDP-39",
          "target": "JDP-37",
          "interaction": "Kendo",
          "interaction_id": "JDP-S-8",
          "interaction_native": {
            "name": "剣道",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": 1906,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP69c52d96db44",
          "name": "Matsui Sanzo (Muso-ryu Shinjujutsu) Konishi Yasuhiro",
          "source": "JDP-42",
          "target": "JDP-37",
          "interaction": "Muso-ryu Shinjujutsu",
          "interaction_id": "JDP-S-9",
          "interaction_native": {
            "name": "無相流新柔術",
            "lang": "ja"
          },
          "place": null,
          "quality": 0,
          "period": {
            "start": 1906,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP964590a47e749",
          "name": "Shingai Tadaatsu (Kendo) Konishi Yasuhiro",
          "source": "JDP-40",
          "target": "JDP-37",
          "interaction": "Kendo",
          "interaction_id": "JDP-S-8",
          "interaction_native": {
            "name": "剣道",
            "lang": "ja"
          },
          "place": "Keiō Gijuku Daigaku",
          "quality": 1,
          "period": {
            "start": 1913,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP532bdd59563f1",
          "name": "Funakoshi Gichin (Karate) Konishi Yasuhiro",
          "source": "JDP-41",
          "target": "JDP-37",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": "Keiō Gijuku Daigaku",
          "quality": 1,
          "period": {
            "start": 1924,
            "end": null
          },
          "sources": [
            {
              "uri": "https://ryukyu-bugei.com/?p=6586",
              "citation": "When he [Konishi] met Funakoshi Gichin in June 1925, he was finally able to learn Karate. However, since its contents was only Kata, together with Ōtsuka Hironori 大塚博紀 (1892–1982, founder of Wadō-ryū Karate-dō and Jūjutsu Kenpō) who was also a disciple of Funakoshi, Konishi began to devise Yakusoku Kumite 約束組手 and the like. Later Konishi studied Karate with Motobu Chōki and Mabuni Kenwa."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP8351268c7e13a",
          "name": "Ueshiba Morihei (Aikidō) Konishi Yasuhiro",
          "source": "JDP-27",
          "target": "JDP-37",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": 1924,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP64139368d2014",
          "name": "Mifune Kyūzō (Kōdōkan Jūdō) Kobayashi Kiyoshi",
          "source": "JDP-11",
          "target": "JDP-12",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1903,
            "end": 1965
          }
        }
      },
      {
        "data": {
          "id": "JDPdfa76a71cb585",
          "name": "Ushijima Tatsukuma (Kōdōkan Jūdō) Kimura Masahiko",
          "source": "JDP-90",
          "target": "JDP-89",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1925,
            "end": 1930
          }
        }
      },
      {
        "data": {
          "id": "JDPb415d81f42f9d",
          "name": "Funakoshi Gichin (Karate) Kimura Masahiko",
          "source": "JDP-41",
          "target": "JDP-89",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.bjjee.com/articles/my-judo-by-masahiko-kimura-his-story-vision-in-his-own-words-part-1/",
              "cite": "'My Judo' by Masahiko Kimura, His Story & Vision in His Own Words Part 1 (BJJ EE)",
              "citation": "Later on, I [ed. Kimura] got interested in karate, and learned Shorinji-ryu (Note: today’s Shotokan karate) under the guidance of Master Funakoshi for a little over 2 years."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP1db20aec011ae",
          "name": "Takahashi Kazuyoshi (Kōdōkan Jūdō) Kawaishi Mikinosuke",
          "source": "JDP-14",
          "target": "JDP-13",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Waseda University",
          "quality": null,
          "period": {
            "start": 1881,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP2788ff1c5ef27",
          "name": "Fukuda Hachinosuke (Tenjin Shin'yō-ryū) Kanō Jigorō",
          "source": "JDP-2",
          "target": "JDP-1",
          "interaction": "Tenjin Shin'yō-ryū",
          "interaction_id": "JDP-S-3",
          "interaction_native": {
            "name": "天神真楊流",
            "lang": "ja"
          },
          "place": "Fukuda Hachinosuke dojo",
          "quality": 3,
          "period": {
            "start": 1877,
            "end": 1879
          }
        }
      },
      {
        "data": {
          "id": "JDP06113a7857a53",
          "name": "Iso Masatomo (Tenjin Shin'yō-ryū) Kanō Jigorō",
          "source": "JDP-4",
          "target": "JDP-1",
          "interaction": "Tenjin Shin'yō-ryū",
          "interaction_id": "JDP-S-3",
          "interaction_native": {
            "name": "天神真楊流",
            "lang": "ja"
          },
          "place": "Iso Masatomo dojo",
          "quality": 3,
          "period": {
            "start": 1879,
            "end": 1881
          }
        }
      },
      {
        "data": {
          "id": "JDPadc0b318b2cd6",
          "name": "Iikubo Tsunetoshi (Kitō-ryū) Kanō Jigorō",
          "source": "JDP-5",
          "target": "JDP-1",
          "interaction": "Kitō-ryū",
          "interaction_id": "JDP-S-2",
          "interaction_native": {
            "name": "起倒流",
            "lang": "ja"
          },
          "place": "Eishōji",
          "quality": 3,
          "period": {
            "start": 1881,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPb2205633e3152",
          "name": "Oshima Masateru (Yagyū Shingan-ryū) Kanō Jigorō",
          "source": "JDP-46",
          "target": "JDP-1",
          "interaction": "Yagyū Shingan-ryū",
          "interaction_id": "JDP-S-11",
          "interaction_native": {
            "name": "柳生心眼流",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": 1881,
            "end": null
          },
          "sources": [
            {
              "uri": "https://kanochronicles.com/the-kodokan-and-bojutsu-jo-staff-fighting-and-judo/",
              "citation": "When I was young, I practiced Yagyū-ryū bōjutsu with a man named Oshima. As my practice of this discipline had not reached the level of shugyō (NOTE: dedicated, austere study), usually I do not mention it. However, since then I thought there was value in bōjutsu shugyō"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPe238f1fbb0361",
          "name": "Matsumura Sōkon (Shuri-te) Itosu Ankō",
          "source": "JDP-54",
          "target": "JDP-55",
          "interaction": "Shuri-te",
          "interaction_id": "JDP-S-13",
          "interaction_native": {
            "name": "首里手",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Asato",
              "citation": "In a 1934 article, Funakoshi noted that Asato and Itosu had studied karate together under Sōkon Matsumura."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPecf0bf79d061",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Itō Tokugorō",
          "source": "JDP-1",
          "target": "JDP-104",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.city.daisen.lg.jp/docs/2013110800147/file_contents/3.pdf",
              "cite": "Cosmos, Daisen City Lifelong Learning Information Magazine, No. 3 , Daisen City Lifelong Learning Promotion Headquarters, December 15, 2008",
              "location": "pp. 31-32"
            },
            {
              "uri": "https://ja.wikipedia.org/wiki/%E4%BC%8A%E8%97%A4%E5%BE%B3%E4%BA%94%E9%83%8E",
              "citation": "中退後は講道館で嘉納治五郎門下となって磯貝一・徳三宝・三船久蔵らと共に柔道に励んだ"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP7c50c2e531167",
          "name": "Yokoyama Sakujiro (Kōdōkan Jūdō) Isogai Hajime",
          "source": "JDP-9",
          "target": "JDP-43",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1891,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPf470a2c9a12e3",
          "name": "Iso Masatari Mataemon (Tenjin Shin'yō-ryū) Iso Masatomo",
          "source": "JDP-3",
          "target": "JDP-4",
          "interaction": "Tenjin Shin'yō-ryū",
          "interaction_id": "JDP-S-3",
          "interaction_native": {
            "name": "天神真楊流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP86b4ac1d29103",
          "name": "Iso Masatari Mataemon (Tenjin Shin'yō-ryū) Inoe Keitaro",
          "source": "JDP-3",
          "target": "JDP-10",
          "interaction": "Tenjin Shin'yō-ryū",
          "interaction_id": "JDP-S-3",
          "interaction_native": {
            "name": "天神真楊流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP1c2ed8ddd5de9",
          "name": "Yokoyama Sakujiro (Kōdōkan Jūdō) Iizuka Kunisaburō",
          "source": "JDP-9",
          "target": "JDP-31",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": null,
          "period": {
            "start": 1891,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP246b277de23de",
          "name": "Takenaka Tetsunosuke Issei (Kitō-ryū) Iikubo Tsunetoshi",
          "source": "JDP-6",
          "target": "JDP-5",
          "interaction": "Kitō-ryū",
          "interaction_id": "JDP-S-2",
          "interaction_native": {
            "name": "起倒流",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDP2f19142eb9ef4",
          "name": "Ushijima Tatsukuma (Kōdōkan Jūdō) Hirano Tokio",
          "source": "JDP-90",
          "target": "JDP-91",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Budō Senmon Gakko",
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.researchgate.net/publication/263087428_Nanatsu-no-kata_Endo-no-kata_and_Joge-no-kata_-A_pedagogical_and_qualitative_biomechanical_evaluation_of_Hirano_Tokio's_kuzushi_unbalancing_concept_as_part_of_skill_acquisition_for_throwing_techniques",
              "cite": "De Crée, Carl. (2014). Nanatsu-no-kata, Endō-no-kata, and Jōge-no-kata ―A pedagogical and qualitative biomechanical evaluation of Hirano Tokio’s kuzushi (unbalancing) concept as part of skill acquisition for throwing techniques in Kōdōkan jūdō. Revista de Artes Marciales Asiáticas. 9. 69-96. 10.18002/rama.v9i2.1162.",
              "citation": "While still at Kyōto, Hirano later also became an uchi deshi to Ushijima Tatsukuma"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPa0b0455784e76",
          "name": "Hayashi Sakuichiro (Tenshin Shōden Katori Shintō-ryū) Hayashi Yazaemon",
          "source": "JDP-114",
          "target": "JDP-113",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
              "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
              "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô (...) Hayashi Saiichirô –> Hayashi Yazaemon –> Ôtake Risuke"
            },
            {
              "uri": "https://shinbukan-katorishintoryu.org/?page_id=898&lang=en",
              "cite": "Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo",
              "citation": "Shinbukan Dojo’s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP22e4bb5a9b5bb",
          "name": "Kumajiro Yamaguchi (Tenshin Shōden Katori Shintō-ryū) Hayashi Sakuichiro",
          "source": "JDP-115",
          "target": "JDP-114",
          "interaction": "Tenshin Shōden Katori Shintō-ryū",
          "interaction_id": "JDP-S-6",
          "interaction_native": {
            "name": "天真正伝香取神道流",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://lifeforasword.wordpress.com/2013/11/14/exkurs-die-moderne-geschichte-der-katori-shinto-ryu/",
              "cite": "Exkurs: Die moderne Geschichte der Katori Shintô ryû (Ein Leben für die Schwertkunst)",
              "citation": "Iisasa Morisada (sieben direkte Schüler): Yamaguchi Kumajirô Eikan Mairaku / Tamai Saidô / Noguchi Jizaemon / Ono Heishichirô Moriichi / Shiina Ichizô / Hongû Toranosuke / Kaneko Shinoshô (...) Hayashi Saiichirô –> Hayashi Yazaemon –> Ôtake Risuke"
            },
            {
              "uri": "https://shinbukan-katorishintoryu.org/?page_id=898&lang=en",
              "cite": "Tenshinsho-den Katori Shinto Ryu - Shinbukan Dojo",
              "citation": "Shinbukan Dojo’s practice of Katori Shinto Ryu follows the teachings passed down from Hayashi Sakuichiro Shihan to Hayashi Yazaemon Shihan, who was then succeeded by Otake Risuke Shihan (Shinbukan Dojo founder)."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP6ba0bdd3e805f",
          "name": "Funakoshi Gichin (Karate) Funakoshi Gigō",
          "source": "JDP-41",
          "target": "JDP-92",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1918,
            "end": null
          },
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Gig%C5%8D_Funakoshi",
              "citation": "He was sickly as a child and began the formal study of karate-do at the age of twelve as a means to improve his health.[4] In the early years, Gichin Funakoshi often took Gigo with him to his trainings with Yasutsune Itosu"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP2c7a96ca7d69f",
          "name": "Asato Ankō (Shuri-te) Funakoshi Gichin",
          "source": "JDP-56",
          "target": "JDP-41",
          "interaction": "Shuri-te",
          "interaction_id": "JDP-S-13",
          "interaction_native": {
            "name": "首里手",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Asato",
              "citation": "Anko Asato (安里 安恒, Asato Ankō, Azato Yasutsune in Japanese, 1827 – 1906) was a Ryūkyūan master of karate. He and Ankō Itosu were the two main karate masters who taught Gichin Funakoshi, the founder of Shotokan karate."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPa6bfd3c2cbb67",
          "name": "Itosu Ankō (Shuri-te) Funakoshi Gichin",
          "source": "JDP-55",
          "target": "JDP-41",
          "interaction": "Shuri-te",
          "interaction_id": "JDP-S-13",
          "interaction_native": {
            "name": "首里手",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Asato",
              "citation": "Anko Asato (安里 安恒, Asato Ankō, Azato Yasutsune in Japanese, 1827 – 1906) was a Ryūkyūan master of karate. He and Ankō Itosu were the two main karate masters who taught Gichin Funakoshi, the founder of Shotokan karate."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP075dc51b318ab",
          "name": "Kanō Jigorō (Kōdōkan Jūdō) Fukuda Keiko",
          "source": "JDP-1",
          "target": "JDP-57",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 3,
          "period": {
            "start": 1935,
            "end": 1966
          },
          "sources": [
            {
              "uri": "https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29",
              "cite": "Johnson, G. (1974): «A single reed that bends gracefully in the wind.» Black Belt, 12(6):28–33.",
              "citation": "Keiko Fukuda is the granddaughter of Professor Jigoro Kano's first jujitsu instructor. She began studying the art at Professor Kano's request at age 21 and since that time has taught in Australia,Canada, the Philippines, the U.S. and, of course, the Kodokan where she has received all her promotions (...) In the Kodokan, sometimes we would sit around the mat with Professor Kano and just talk and ask questions so we would know what each other was thinking"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPf7eb2aac12d9",
          "name": "Mifune Kyūzō (Kōdōkan Jūdō) Fukuda Keiko",
          "source": "JDP-11",
          "target": "JDP-57",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 3,
          "period": {
            "start": 1935,
            "end": 1966
          },
          "sources": [
            {
              "uri": "https://books.google.pt/books?id=fNYDAAAAMBAJ&pg=PA29",
              "cite": "Johnson, G. (1974): «A single reed that bends gracefully in the wind.» Black Belt, 12(6):28–33.",
              "citation": "Miss Fukuda, describing her training with the late Professor Kyuzo Mifune (10th dan) (...)"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP6e2aaf3d3871d",
          "name": "Iso Masatomo (Tenjin Shin'yō-ryū) Fukuda Hachinosuke",
          "source": "JDP-4",
          "target": "JDP-2",
          "interaction": "Tenjin Shin'yō-ryū",
          "interaction_id": "JDP-S-3",
          "interaction_native": {
            "name": "天神真楊流",
            "lang": "ja"
          },
          "place": "Otamagaike dojo",
          "quality": null,
          "period": {
            "start": 1851,
            "end": null
          }
        }
      },
      {
        "data": {
          "id": "JDPa37d927578b63",
          "name": "Funakoshi Gichin (Karate) Egami Shigeru",
          "source": "JDP-41",
          "target": "JDP-93",
          "interaction": "Karate",
          "interaction_id": "JDP-S-5",
          "interaction_native": {
            "name": "空手",
            "lang": "ja"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": 1930,
            "end": null
          },
          "sources": [
            {
              "uri": "https://shotokai.com/shigeru-egami/",
              "cite": "Master Shigeru Egami, O-sensei’s successor (1912-1981) (Shotokai Encyclopedia)",
              "citation": "Egami met Master Funakoshi when he was 18 years old, the moment he began studying at the famous Waseda University, there he helped to establish its Karate Do Club. (...)  He followed his Master together with Yoshitaka Funakoshi and Takeshi Shimoda all around Japan staging exhibitions, trying to expand the knowledge of Karate-do as a Japanese martial art."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP901a38ba9ac6e",
          "name": "Matsumura Sōkon (Shuri-te) Asato Ankō",
          "source": "JDP-54",
          "target": "JDP-56",
          "interaction": "Shuri-te",
          "interaction_id": "JDP-S-13",
          "interaction_native": {
            "name": "首里手",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://en.wikipedia.org/wiki/Ank%C5%8D_Asato",
              "citation": "In a 1934 article, Funakoshi noted that Asato and Itosu had studied karate together under Sōkon Matsumura."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP24309a2eae52e",
          "name": "Ogawa Kinnosuke (Kendo) Abbe Kenshirõ",
          "source": "JDP-59",
          "target": "JDP-58",
          "interaction": "Kendo",
          "interaction_id": "JDP-S-8",
          "interaction_native": {
            "name": "剣道",
            "lang": "ja"
          },
          "place": "Budō Senmon Gakko",
          "quality": 3,
          "period": {
            "start": 1934,
            "end": 1945
          },
          "sources": [
            {
              "uri": "https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm",
              "cite": "Kenshiro Abbe, The Kyu-Shin-Do And Zen Judo - Keo Cavalcanti, 6th Dan Zen Judo",
              "citation": "At the Busen Abbe received instruction from Ogawa Hanshi (genius), the Butokukai Judan (10th Dan) sword master. While at the Busen Kenshiro also enrolled in Mr. Gen Tanabe's philosophy class, at the Kyoto Teikoku University. That early encounter with philosophy would be influential in the formation of his system. While the training was arduous at the Busen, Kenshiro managed to receive his Yondan (4th Dan) rank in Judo, being again the young Judoka to attain it. His sister, Toyoka, decided to take Martial Arts too, enrolling in Mrs. Mitamura's Naginata class. She would dedicate the rest of her life to the practice of the art."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP59e143db9776a",
          "name": "Ueshiba Morihei (Aikidō) Abbe Kenshirõ",
          "source": "JDP-27",
          "target": "JDP-58",
          "interaction": "Aikidō",
          "interaction_id": "JDP-S-4",
          "interaction_native": {
            "name": "合気道",
            "lang": "ja"
          },
          "place": null,
          "quality": 3,
          "period": {
            "start": 1937,
            "end": 1947
          },
          "sources": [
            {
              "uri": "https://web.archive.org/web/20090218133219/http://rrjudo.com/history/zenjudo.htm",
              "cite": "Kenshiro Abbe, The Kyu-Shin-Do And Zen Judo - Keo Cavalcanti, 6th Dan Zen Judo",
              "citation": "In 1937, at the age of 23, Abbe was awarded his Rokudan (6th Dan) rank and in June of that year he enlisted in the Japanese army, serving for four years in a garrison in the Toan-sho Province in Manchuria. It was during the time in Manchuria that Abbe began formulating his theory of Budo (the Way of the Warrior), Kyu-Shin-Do. And it was also at this time that Abbe was invited by O'Sensei, Morihei Ueshiba to study Aikido under his care."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPa14f9fb93cf16",
          "name": "Kobayashi Kiyoshi (Kōdōkan Jūdō) Frigyes Tӧrӧk",
          "source": "JDP-12",
          "target": "JDP-69",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Judo Clube de Portugal",
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.fpj.pt/wp-content/uploads/2020/12/MANUAL-Gradua%C3%A7%C3%B5es-2021_.pdf",
              "cite": "Manual de Graduações e Regulamento de Graduações. Federação Portuguesa de Judo (Dezembro 2020)",
              "citation": "Em 1974, o então presidente da Federação Portuguesa de Judo, Prof. Fernando Costa Matos, sabendo da intenção do Mestre Frigyes Tӧrӧk, 3º Dan, de regressar a Portugal, vindo de Angola onde lecionava, colocou em contacto este professor de ascendência húngara e discípulo direto do Mestre Kiyoshi Kobayashi, com a Direção do Clube. "
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP484a5761c9eef",
          "name": "Oda Tsunetane (Kōdōkan Jūdō) Yves Klein",
          "source": "JDP-124",
          "target": "JDP-125",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Kodokan",
          "quality": 3,
          "period": {
            "start": "1952",
            "end": "1954"
          },
          "sources": [
            {
              "uri": "https://theeverydaypress.net/the-foundations-of-judo/",
              "cite": "THE FOUNDATIONS OF JUDO - The Everyday Press",
              "citation": "In the early 1950s, the 24-year-old Yves Klein spent a year and a half in Tokyo, studying mainly at the Kodokan under the ninth-dan judo master Oda"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP5b47eb6484ae5",
          "name": "Oda Tsunetane (Kōdōkan Jūdō) Yves Klein",
          "source": "JDP-124",
          "target": "JDP-125",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Municipal Police of Tokyo",
          "quality": 2,
          "period": {
            "start": "1952",
            "end": "1954"
          },
          "sources": [
            {
              "uri": "https://www.ianwhittlesea.net/works_pages/wks_klein/wks_klein1.html",
              "cite": "The Foundations of Judo - Ian Whittlesea",
              "citation": "He has spent this time solely studying Judo... with the Municipal Police of Tokyo under Master Oda"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPef468df89670d",
          "name": "Erich Rahn (Jūjutsu) Alfred Rhode",
          "source": "JDP-109",
          "target": "JDP-110",
          "interaction": "Jūjutsu",
          "interaction_id": "JDP-S-14",
          "interaction_native": {
            "name": "柔術",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://books.google.de/books?id=Oa8Cdh9UVrIC",
              "cite": "WEDEMEYER-KOLWE, Bernd. «Der neue Mensch»: Körperkultur im Kaiserreich und in der Weimarer Republik. Königshausen & Neumann, 2004, p. 308",
              "citation": "(...) 1922 gründete der Rahn-Schüler Alfred Rohde dann den 1. Deutschen Judo-Club in Frankfur (...)"
            },
            {
              "uri": "https://link.springer.com/chapter/10.1057/9781137573971_6",
              "cite": "PANZER, Sarah. When Jiu-Jitsu was German: Japanese Martial Arts in German Sport-and Körperkultur, 1905–1933. In: Transnational Encounters between Germany and Japan: Perceptions of Partnership in the Nineteenth and Twentieth Centuries. New York: Palgrave Macmillan US, 2016. p. 91-106.",
              "citation": "The first German judo club was formed in 1922 in Frankfurt by Alfred Rhode, a former student of Erich Rahn. For several years, jiu-jitsu and judo coexisted relatively collegially in Germany, most likely because the still relatively small community of instructors and active participants made cooperation necessary if either discipline was to survive"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP7335ab8e692e5",
          "name": "Zhang Zhaodong (Baguazhang) Wang Shujin",
          "source": "JDP-118",
          "target": "JDP-117",
          "interaction": "Baguazhang",
          "interaction_id": "JDP-S-17",
          "interaction_native": {
            "name": "八卦掌",
            "lang": "cn"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274",
              "cite": "Martial arts fight for survival (Taipei Times)",
              "citation": " By chance one day, a senior student of the famous martial arts master Zhang Zhao-dong came to the business where Wang worked. (...)  Under Zhang's instruction, Wang learned the two arts for which he would later become famous; pa kua chang and hsing yi chuan. Pa kua chang means \"eight diagram palms\" and refers to the eight core diagrams which make up the I-Ching (易經, Book of Changes), one of the most important books of classical Chinese philosophy"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPdfe76687281da",
          "name": "Zhang Zhaodong (Xingyiquan) Wang Shujin",
          "source": "JDP-118",
          "target": "JDP-117",
          "interaction": "Xingyiquan",
          "interaction_id": "JDP-S-18",
          "interaction_native": {
            "name": "形意拳",
            "lang": "cn"
          },
          "place": null,
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.taipeitimes.com/News/feat/archives/2002/02/17/124274",
              "cite": "Martial arts fight for survival (Taipei Times)",
              "citation": " By chance one day, a senior student of the famous martial arts master Zhang Zhao-dong came to the business where Wang worked. (...)  Under Zhang's instruction, Wang learned the two arts for which he would later become famous; pa kua chang and hsing yi chuan. Pa kua chang means \"eight diagram palms\" and refers to the eight core diagrams which make up the I-Ching (易經, Book of Changes), one of the most important books of classical Chinese philosophy"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP6f3fbb87da41a",
          "name": "Augusto de Oliveira Cordeiro (Kōdōkan Jūdō) Petrucio Monteiro",
          "source": "JDP-127",
          "target": "JDP-128",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Academia Rudolf Hermanny",
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://benfeitoria.com/projeto/biopetrucio",
              "cite": "Biografia Petrucio Monteiro - Benfeitoria",
              "citation": "O professor Petrucio seguiu a linha do professor Rudolf Hermanny"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP5ebb01dcc7095",
          "name": "Luis de França Filho (Brazilian jiu-jitsu) Oswaldo Fadda",
          "source": "JDP-20",
          "target": "JDP-106",
          "interaction": "Brazilian jiu-jitsu",
          "interaction_id": "JDP-S-16",
          "interaction_native": {
            "name": "Jiu-Jitsu brasileiro",
            "lang": "pt"
          },
          "place": "Academia França de Jiu-jitsu",
          "quality": 3,
          "period": {
            "start": 1938,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 108",
              "citation": "Oswaldo Fadda começou a treinar com França por volta de 1938"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP8aabc5765ecff",
          "name": "Balthazar Cardoso (Boxing) Oswaldo Fadda",
          "source": "JDP-129",
          "target": "JDP-106",
          "interaction": "Boxing",
          "interaction_id": "JDP-S-19",
          "place": "Liga de Esportes da Marinha",
          "quality": 3,
          "period": {
            "start": 1938,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.faddabjj.com/historia-fadda",
              "cite": "A história da Família Fadda (FaddaBJJ)",
              "citation": "Antes da sua história com o Jiu-Jitsu, os primeiros passos de Fadda no mundo das lutas foi na \"Nobre Arte\", ou seja, no boxe, através do campeão Baltazar Cardoso."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP664b9564b677c",
          "name": "Maeda Mitsuyo (Kōdōkan Jūdō) Mario Aleixo",
          "source": "JDP-18",
          "target": "JDP-45",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 3,
          "period": {
            "start": 1915,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 1, p. 110",
              "citation": "Mário Alexio teve o privilégio de se adestrar no Jiu Jitsu com dois dos mais experientes e famosos mestres japoneses dos ringues. Recebeu suas primeiras instruções de Sada Miyako por volta de 1909. Posteriormente teve a oportunidade de se aperfeiçoar com o grande Conde Koma, pouco depois deste chegar ao Brasil, em 1915."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPe404d611c9e0d",
          "name": "Miyako Sada (Kōdōkan Jūdō) Mario Aleixo",
          "source": "JDP-107",
          "target": "JDP-45",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 3,
          "period": {
            "start": 1909,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 1, p. 110",
              "citation": "Mário Alexio teve o privilégio de se adestrar no Jiu Jitsu com dois dos mais experientes e famosos mestres japoneses dos ringues. Recebeu suas primeiras instruções de Sada Miyako por volta de 1909. Posteriormente teve a oportunidade de se aperfeiçoar com o grande Conde Koma, pouco depois deste chegar ao Brasil, em 1915."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP6e67c9d851976",
          "name": "Satake Soshihiro (Kōdōkan Jūdō) Luis de França Filho",
          "source": "JDP-22",
          "target": "JDP-20",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 1,
          "period": {
            "start": 1916,
            "end": null
          },
          "sources": [
            {
              "uri": "https://www.bjjheroes.com/bjj-fighters/luiz-franca",
              "cite": "BJJ Heroes: Luiz França",
              "citation": "There Satake settled for a while, opening his own academy in 1916, at the Atlético Clube Rio Negro, becoming the first Japanese to open a Judo/Jiu Jitsu academy in Brazil. This gym became the place where Luiz França started his life as a martial artist. Satake would also become a Brazilian citizen years later, and change his name to Antônio Soshihiro Satake."
            },
            {
              "uri": "https://www.facebook.com/photo.php?fbid=543032192445535&id=455479647867457&set=a.455593414522747",
              "cite": "Equipe Fadda Jiu-Jitsu (Facebook)",
              "citation": "Antigo aluno de Soishiro Satake e Mitsuyo Maeda, Luiz França foi o fundador da linhagem (não pertencente à família Gracie) de mais sucesso no Jiu-Jitsu, uma linhagem continuada especialmente através do trabalho efetuado pelo mais proeminente e capaz aluno de França, o Mestre Oswaldo Fadda, que mais tarde formaria a sua própria escola de talentosos alunos."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPff29e0ea95741",
          "name": "Maeda Mitsuyo (Kōdōkan Jūdō) Luis de França Filho",
          "source": "JDP-18",
          "target": "JDP-20",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Belém",
          "quality": 2,
          "period": {
            "start": 1929,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 106",
              "citation": "Se França se iniciou no Jiu Jitsu com o Conde Koma, muito provavelmente foi em 1929 n Marinha, quando esteve em Belém ao serviço no navio Minas Gerais."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPd07a068268ce5",
          "name": "Geo Omori (Kōdōkan Jūdō) Luis de França Filho",
          "source": "JDP-103",
          "target": "JDP-20",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Rio de Janeiro",
          "quality": 2,
          "period": {
            "start": 1930,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 106",
              "citation": "Posteriormente, deu continuidade ao seu aprendizado no Rio de Janeiro com Geo Omori, Takeo Yano e Hélio Gracie..."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP8e371142c9c16",
          "name": "Hélio Gracie (Brazilian jiu-jitsu) Luis de França Filho",
          "source": "JDP-102",
          "target": "JDP-20",
          "interaction": "Brazilian jiu-jitsu",
          "interaction_id": "JDP-S-16",
          "interaction_native": {
            "name": "Jiu-Jitsu brasileiro",
            "lang": "pt"
          },
          "place": "Rio de Janeiro",
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 106",
              "citation": "Posteriormente, deu continuidade ao seu aprendizado no Rio de Janeiro com Geo Omori, Takeo Yano e Hélio Gracie..."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP516eac1e4729b",
          "name": "Balthazar Cardoso (Boxing) Luis de França Filho",
          "source": "JDP-129",
          "target": "JDP-20",
          "interaction": "Boxing",
          "interaction_id": "JDP-S-19",
          "place": "Liga de Esportes da Marinha",
          "quality": 2,
          "period": {
            "start": 1928,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "citation": "Foi na Marinha, em 1928, que França se iniciou nas artes marciais. Primeiro com o Boxe, sob a orientação de Balthazar Cardoso"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPf2b759eadffca",
          "name": "Maeda Mitsuyo (Kōdōkan Jūdō) Jacinto Ferro",
          "source": "JDP-18",
          "target": "JDP-19",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": 1915,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 89",
              "citation": "... Tenho [Maeda] os seguintes alunos aos quais deposito inteira confiança [...] Jacintho Ferro, Dr. Matheus Pereira, Guilherm de La Rocque, Raphael Gomes e Waldermar Gomes..."
            },
            {
              "uri": "https://judotradicionalgoshinjutsukan.blogspot.com/2009/08/mitsuyo-maeda-nasc.html",
              "cite": "Mitsuyo Maeda e o Judô Kodokan (Judo Tradicional Goshinjutsukan)",
              "citation": "as aulas eram dadas em uma academia que Maeda abriu em 1916,nos salões do Cine Teatro Moderno, localizado ao lado da Igreja de Nazaré, hoje uma praça, as aulas eram amplamente divulgadas nos ornais para quem quisesse aprender pagando.O primeiro aluno de Maeda foi o estivador Jacinto Ferro, ex-lutador de greco-romana, Jacinto foi instrutor de Maeda e ajudou a dar aulas para o Carlos Gracie."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPac0af7a652eb5",
          "name": "Carlos Gracie (Brazilian jiu-jitsu) Hélio Gracie",
          "source": "JDP-21",
          "target": "JDP-102",
          "interaction": "Brazilian jiu-jitsu",
          "interaction_id": "JDP-S-16",
          "interaction_native": {
            "name": "Jiu-Jitsu brasileiro",
            "lang": "pt"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": 1925,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 165",
              "citation": "... meu Jiu Jitsu era muito diferente do dele. O meu fôra aprendido há muitos anos com o meu irmão Carlos..."
            },
            {
              "uri": "https://pt.wikipedia.org/wiki/H%C3%A9lio_Gracie",
              "citation": "Observador, Hélio passou a acompanhar, dos seus treze aos dezesseis anos, as aulas ministradas por Carlos."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP6df51a669136b",
          "name": "Carlos Gracie (Kōdōkan Jūdō) George Gracie",
          "source": "JDP-21",
          "target": "JDP-108",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://judotradicionalgoshinjutsukan.blogspot.com/2010/01/topico-bubishi.html",
              "cite": "Tópico Bubishi (Judo Tradicional Goshinjutsukan)",
              "citation": "...O que sabemos de fato é que, Maeda ensinou Judô a Carlos Gracie em virtude da afinidade com seu pai, Gastão Gracie. Carlos por sua vez ensinou a seus demais irmãos, em especial a Hélio Gracie. Neste ponto surgem duas teorias. A primeira alega que Maeda ensinou somente o judô de Jigoro Kano a Carlos, e esse o repassou a Hélio, que era o mais franzino dos Gracie, adaptando-o com grande enfoque no Ne-waza - técnicas de solo do judô, ponto central do Gracie jiu-jitsu ou brasilian jiu-jitsu. Para compensar seu biotipo, a partir dos ensinamentos de Carlos, Hélio aprimorou a parte de solo pelo uso do dispositivo de alavanca, dando-lhe a força extra que o mesmo não dispunha. A segunda teoria, apoiada pelos Gracies, fala que Maeda era, também, exímio praticante de Ju-jutsu tradicional e foi essa a arte que ensinou aos brasileiros. Porém, em uma recente entrevista, Hélio Gracie afirma que 'Carlos lutava judô', veja a entrevista http://www.youtube.com/watch?v=BG309oqVLb4"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP037289851a094",
          "name": "Jacinto Ferro (Kōdōkan Jūdō) Donato Pires dos Reis",
          "source": "JDP-19",
          "target": "JDP-23",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": 1920,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 94",
              "citation": "...'Oscar' muito provavelmente se trata do nome de Carlos grafado equivocadamente (...) Na notícia, 'Oscar Gracie' e Donato são apresentados como alunos do famoso esportista paraense Jacyntho Ferro, este sim, discípulo directo de Maeda..."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP4973424fe9cdd",
          "name": "Jacinto Ferro (Kōdōkan Jūdō) Carlos Gracie",
          "source": "JDP-19",
          "target": "JDP-21",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": null,
          "period": {
            "start": 1916,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol. 3, p. 94",
              "citation": "...'Oscar' muito provavelmente se trata do nome de Carlos grafado equivocadamente (...) Na notícia, 'Oscar Gracie' e Donato são apresentados como alunos do famoso esportista paraense Jacyntho Ferro, este sim, discípulo directo de Maeda..."
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP2edb52c9b5782",
          "name": "Maeda Mitsuyo (Kōdōkan Jūdō) Carlos Gracie",
          "source": "JDP-18",
          "target": "JDP-21",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Paysandu Sport Club",
          "quality": null,
          "period": {
            "start": 1916,
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol 3, p.91",
              "citation": "...chefiada pelo competentissimo prof. Conde Koma. Aqui, depois de algumas demosntrações, organisou um gymnasio e eu [Carlos] fui um dos primeiros alunos [...] há registos que Maeda deu aulas, em 1916, no Paysandu Sport Club, em Belém, cidade onde Carlos residia com a sua família"
            },
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA, Elton; CORRÊA, Eduardo. Muito antes do MMA: O legado dos precursores do Vale Tudo no Brasil e no mundo. 2020.",
              "location": "vol 3, p.93",
              "citation": "Fui aluno do célebre Conde Koma, no Pará [...] e nessa época Carlos Gracia também estava aprendendo"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDPa7f78580bf4db",
          "name": "Maeda Mitsuyo (Kōdōkan Jūdō) Aluizio de Melo",
          "source": "JDP-18",
          "target": "JDP-130",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": null,
          "quality": 3,
          "period": {
            "start": "1915",
            "end": null
          },
          "sources": [
            {
              "uri": "https://isbnsearch.org/isbn/9798639871030",
              "cite": "SILVA & CORRÊA (2020). Muito antes do MMA",
              "location": "vol. III, p. 111-113",
              "citation": "aos 17 anos, teve a oportunidade de treinar Jiu Jitsu com o Conde Koma, durante a passagem da trupe japonesa pelo Nordeste do Brasil"
            },
            {
              "uri": "https://aratabajiujitsu.com.br/a-origem-dos-arataba/",
              "cite": "A Origem dos Arataba (Arataba Jiu-Jitsu)",
              "citation": "Todo mundo sabe que Mitsuyo Maeda, o Conde Koma, radicou-se no norte do Brasil por volta de 1913 e ensinou jiu-jitsu para diversas pessoas, dentre as quais posso citar Carlos Gracie, Luiz França e Aluizio de Melo"
            },
            {
              "uri": "https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/",
              "cite": "Dojô Professor Loanzi - Museu Virtual do Judô",
              "citation": "QUEM FOI ALOIZIO NOGUEIRA BANDEIRA DE MELLO – PROF. LOANZI (...) Foi aluno do famoso Mitsuyo Moeda, Conde Koma, introdutor do jiu jitsu e do judô no Brasil"
            }
          ]
        }
      },
      {
        "data": {
          "id": "JDP99e944218bafa",
          "name": "Ogawa Ryuzo (Kōdōkan Jūdō) Aluizio de Melo",
          "source": "JDP-126",
          "target": "JDP-130",
          "interaction": "Kōdōkan Jūdō",
          "interaction_id": "JDP-S-1",
          "interaction_native": {
            "name": "講道館柔道",
            "lang": "ja"
          },
          "place": "Budokan, São Paulo",
          "quality": 2,
          "period": {
            "start": null,
            "end": null
          },
          "sources": [
            {
              "uri": "https://acervosvirtuais.ufpel.edu.br/museuvirtualdojudo/2022/07/academia-ruy-barbosa/",
              "cite": "Dojô Professor Loanzi - Museu Virtual do Judô",
              "citation": "Em 1959 contatou seu mestre e sensei, que lhe havia promovido à faixa preta sho-dan, Ryuzo Ogawa, de São Paulo"
            }
          ]
        }
      }
    ]
  }
}